/*! jQuery v3.7.1 | (c) OpenJS Foundation and other contributors | jquery.org/license */
!function(e,t){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=e.document?t(e,!0):function(e){if(!e.document)throw new Error("jQuery requires a window with a document");return t(e)}:t(e)}("undefined"!=typeof window?window:this,function(ie,e){"use strict";var oe=[],r=Object.getPrototypeOf,ae=oe.slice,g=oe.flat?function(e){return oe.flat.call(e)}:function(e){return oe.concat.apply([],e)},s=oe.push,se=oe.indexOf,n={},i=n.toString,ue=n.hasOwnProperty,o=ue.toString,a=o.call(Object),le={},v=function(e){return"function"==typeof e&&"number"!=typeof e.nodeType&&"function"!=typeof e.item},y=function(e){return null!=e&&e===e.window},C=ie.document,u={type:!0,src:!0,nonce:!0,noModule:!0};function m(e,t,n){var r,i,o=(n=n||C).createElement("script");if(o.text=e,t)for(r in u)(i=t[r]||t.getAttribute&&t.getAttribute(r))&&o.setAttribute(r,i);n.head.appendChild(o).parentNode.removeChild(o)}function x(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?n[i.call(e)]||"object":typeof e}var t="3.7.1",l=/HTML$/i,ce=function(e,t){return new ce.fn.init(e,t)};function c(e){var t=!!e&&"length"in e&&e.length,n=x(e);return!v(e)&&!y(e)&&("array"===n||0===t||"number"==typeof t&&0<t&&t-1 in e)}function fe(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}ce.fn=ce.prototype={jquery:t,constructor:ce,length:0,toArray:function(){return ae.call(this)},get:function(e){return null==e?ae.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=ce.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return ce.each(this,e)},map:function(n){return this.pushStack(ce.map(this,function(e,t){return n.call(e,t,e)}))},slice:function(){return this.pushStack(ae.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},even:function(){return this.pushStack(ce.grep(this,function(e,t){return(t+1)%2}))},odd:function(){return this.pushStack(ce.grep(this,function(e,t){return t%2}))},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(0<=n&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:s,sort:oe.sort,splice:oe.splice},ce.extend=ce.fn.extend=function(){var e,t,n,r,i,o,a=arguments[0]||{},s=1,u=arguments.length,l=!1;for("boolean"==typeof a&&(l=a,a=arguments[s]||{},s++),"object"==typeof a||v(a)||(a={}),s===u&&(a=this,s--);s<u;s++)if(null!=(e=arguments[s]))for(t in e)r=e[t],"__proto__"!==t&&a!==r&&(l&&r&&(ce.isPlainObject(r)||(i=Array.isArray(r)))?(n=a[t],o=i&&!Array.isArray(n)?[]:i||ce.isPlainObject(n)?n:{},i=!1,a[t]=ce.extend(l,o,r)):void 0!==r&&(a[t]=r));return a},ce.extend({expando:"jQuery"+(t+Math.random()).replace(/\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||"[object Object]"!==i.call(e))&&(!(t=r(e))||"function"==typeof(n=ue.call(t,"constructor")&&t.constructor)&&o.call(n)===a)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e,t,n){m(e,{nonce:t&&t.nonce},n)},each:function(e,t){var n,r=0;if(c(e)){for(n=e.length;r<n;r++)if(!1===t.call(e[r],r,e[r]))break}else for(r in e)if(!1===t.call(e[r],r,e[r]))break;return e},text:function(e){var t,n="",r=0,i=e.nodeType;if(!i)while(t=e[r++])n+=ce.text(t);return 1===i||11===i?e.textContent:9===i?e.documentElement.textContent:3===i||4===i?e.nodeValue:n},makeArray:function(e,t){var n=t||[];return null!=e&&(c(Object(e))?ce.merge(n,"string"==typeof e?[e]:e):s.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:se.call(t,e,n)},isXMLDoc:function(e){var t=e&&e.namespaceURI,n=e&&(e.ownerDocument||e).documentElement;return!l.test(t||n&&n.nodeName||"HTML")},merge:function(e,t){for(var n=+t.length,r=0,i=e.length;r<n;r++)e[i++]=t[r];return e.length=i,e},grep:function(e,t,n){for(var r=[],i=0,o=e.length,a=!n;i<o;i++)!t(e[i],i)!==a&&r.push(e[i]);return r},map:function(e,t,n){var r,i,o=0,a=[];if(c(e))for(r=e.length;o<r;o++)null!=(i=t(e[o],o,n))&&a.push(i);else for(o in e)null!=(i=t(e[o],o,n))&&a.push(i);return g(a)},guid:1,support:le}),"function"==typeof Symbol&&(ce.fn[Symbol.iterator]=oe[Symbol.iterator]),ce.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(e,t){n["[object "+t+"]"]=t.toLowerCase()});var pe=oe.pop,de=oe.sort,he=oe.splice,ge="[\\x20\\t\\r\\n\\f]",ve=new RegExp("^"+ge+"+|((?:^|[^\\\\])(?:\\\\.)*)"+ge+"+$","g");ce.contains=function(e,t){var n=t&&t.parentNode;return e===n||!(!n||1!==n.nodeType||!(e.contains?e.contains(n):e.compareDocumentPosition&&16&e.compareDocumentPosition(n)))};var f=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;function p(e,t){return t?"\0"===e?"\ufffd":e.slice(0,-1)+"\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\"+e}ce.escapeSelector=function(e){return(e+"").replace(f,p)};var ye=C,me=s;!function(){var e,b,w,o,a,T,r,C,d,i,k=me,S=ce.expando,E=0,n=0,s=W(),c=W(),u=W(),h=W(),l=function(e,t){return e===t&&(a=!0),0},f="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",t="(?:\\\\[\\da-fA-F]{1,6}"+ge+"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",p="\\["+ge+"*("+t+")(?:"+ge+"*([*^$|!~]?=)"+ge+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+t+"))|)"+ge+"*\\]",g=":("+t+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+p+")*)|.*)\\)|)",v=new RegExp(ge+"+","g"),y=new RegExp("^"+ge+"*,"+ge+"*"),m=new RegExp("^"+ge+"*([>+~]|"+ge+")"+ge+"*"),x=new RegExp(ge+"|>"),j=new RegExp(g),A=new RegExp("^"+t+"$"),D={ID:new RegExp("^#("+t+")"),CLASS:new RegExp("^\\.("+t+")"),TAG:new RegExp("^("+t+"|[*])"),ATTR:new RegExp("^"+p),PSEUDO:new RegExp("^"+g),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+ge+"*(even|odd|(([+-]|)(\\d*)n|)"+ge+"*(?:([+-]|)"+ge+"*(\\d+)|))"+ge+"*\\)|)","i"),bool:new RegExp("^(?:"+f+")$","i"),needsContext:new RegExp("^"+ge+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+ge+"*((?:-\\d)?\\d*)"+ge+"*\\)|)(?=[^-]|$)","i")},N=/^(?:input|select|textarea|button)$/i,q=/^h\d$/i,L=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,H=/[+~]/,O=new RegExp("\\\\[\\da-fA-F]{1,6}"+ge+"?|\\\\([^\\r\\n\\f])","g"),P=function(e,t){var n="0x"+e.slice(1)-65536;return t||(n<0?String.fromCharCode(n+65536):String.fromCharCode(n>>10|55296,1023&n|56320))},M=function(){V()},R=J(function(e){return!0===e.disabled&&fe(e,"fieldset")},{dir:"parentNode",next:"legend"});try{k.apply(oe=ae.call(ye.childNodes),ye.childNodes),oe[ye.childNodes.length].nodeType}catch(e){k={apply:function(e,t){me.apply(e,ae.call(t))},call:function(e){me.apply(e,ae.call(arguments,1))}}}function I(t,e,n,r){var i,o,a,s,u,l,c,f=e&&e.ownerDocument,p=e?e.nodeType:9;if(n=n||[],"string"!=typeof t||!t||1!==p&&9!==p&&11!==p)return n;if(!r&&(V(e),e=e||T,C)){if(11!==p&&(u=L.exec(t)))if(i=u[1]){if(9===p){if(!(a=e.getElementById(i)))return n;if(a.id===i)return k.call(n,a),n}else if(f&&(a=f.getElementById(i))&&I.contains(e,a)&&a.id===i)return k.call(n,a),n}else{if(u[2])return k.apply(n,e.getElementsByTagName(t)),n;if((i=u[3])&&e.getElementsByClassName)return k.apply(n,e.getElementsByClassName(i)),n}if(!(h[t+" "]||d&&d.test(t))){if(c=t,f=e,1===p&&(x.test(t)||m.test(t))){(f=H.test(t)&&U(e.parentNode)||e)==e&&le.scope||((s=e.getAttribute("id"))?s=ce.escapeSelector(s):e.setAttribute("id",s=S)),o=(l=Y(t)).length;while(o--)l[o]=(s?"#"+s:":scope")+" "+Q(l[o]);c=l.join(",")}try{return k.apply(n,f.querySelectorAll(c)),n}catch(e){h(t,!0)}finally{s===S&&e.removeAttribute("id")}}}return re(t.replace(ve,"$1"),e,n,r)}function W(){var r=[];return function e(t,n){return r.push(t+" ")>b.cacheLength&&delete e[r.shift()],e[t+" "]=n}}function F(e){return e[S]=!0,e}function $(e){var t=T.createElement("fieldset");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function B(t){return function(e){return fe(e,"input")&&e.type===t}}function _(t){return function(e){return(fe(e,"input")||fe(e,"button"))&&e.type===t}}function z(t){return function(e){return"form"in e?e.parentNode&&!1===e.disabled?"label"in e?"label"in e.parentNode?e.parentNode.disabled===t:e.disabled===t:e.isDisabled===t||e.isDisabled!==!t&&R(e)===t:e.disabled===t:"label"in e&&e.disabled===t}}function X(a){return F(function(o){return o=+o,F(function(e,t){var n,r=a([],e.length,o),i=r.length;while(i--)e[n=r[i]]&&(e[n]=!(t[n]=e[n]))})})}function U(e){return e&&"undefined"!=typeof e.getElementsByTagName&&e}function V(e){var t,n=e?e.ownerDocument||e:ye;return n!=T&&9===n.nodeType&&n.documentElement&&(r=(T=n).documentElement,C=!ce.isXMLDoc(T),i=r.matches||r.webkitMatchesSelector||r.msMatchesSelector,r.msMatchesSelector&&ye!=T&&(t=T.defaultView)&&t.top!==t&&t.addEventListener("unload",M),le.getById=$(function(e){return r.appendChild(e).id=ce.expando,!T.getElementsByName||!T.getElementsByName(ce.expando).length}),le.disconnectedMatch=$(function(e){return i.call(e,"*")}),le.scope=$(function(){return T.querySelectorAll(":scope")}),le.cssHas=$(function(){try{return T.querySelector(":has(*,:jqfake)"),!1}catch(e){return!0}}),le.getById?(b.filter.ID=function(e){var t=e.replace(O,P);return function(e){return e.getAttribute("id")===t}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&C){var n=t.getElementById(e);return n?[n]:[]}}):(b.filter.ID=function(e){var n=e.replace(O,P);return function(e){var t="undefined"!=typeof e.getAttributeNode&&e.getAttributeNode("id");return t&&t.value===n}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&C){var n,r,i,o=t.getElementById(e);if(o){if((n=o.getAttributeNode("id"))&&n.value===e)return[o];i=t.getElementsByName(e),r=0;while(o=i[r++])if((n=o.getAttributeNode("id"))&&n.value===e)return[o]}return[]}}),b.find.TAG=function(e,t){return"undefined"!=typeof t.getElementsByTagName?t.getElementsByTagName(e):t.querySelectorAll(e)},b.find.CLASS=function(e,t){if("undefined"!=typeof t.getElementsByClassName&&C)return t.getElementsByClassName(e)},d=[],$(function(e){var t;r.appendChild(e).innerHTML="<a id='"+S+"' href='' disabled='disabled'></a><select id='"+S+"-\r\\' disabled='disabled'><option selected=''></option></select>",e.querySelectorAll("[selected]").length||d.push("\\["+ge+"*(?:value|"+f+")"),e.querySelectorAll("[id~="+S+"-]").length||d.push("~="),e.querySelectorAll("a#"+S+"+*").length||d.push(".#.+[+~]"),e.querySelectorAll(":checked").length||d.push(":checked"),(t=T.createElement("input")).setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),r.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&d.push(":enabled",":disabled"),(t=T.createElement("input")).setAttribute("name",""),e.appendChild(t),e.querySelectorAll("[name='']").length||d.push("\\["+ge+"*name"+ge+"*="+ge+"*(?:''|\"\")")}),le.cssHas||d.push(":has"),d=d.length&&new RegExp(d.join("|")),l=function(e,t){if(e===t)return a=!0,0;var n=!e.compareDocumentPosition-!t.compareDocumentPosition;return n||(1&(n=(e.ownerDocument||e)==(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!le.sortDetached&&t.compareDocumentPosition(e)===n?e===T||e.ownerDocument==ye&&I.contains(ye,e)?-1:t===T||t.ownerDocument==ye&&I.contains(ye,t)?1:o?se.call(o,e)-se.call(o,t):0:4&n?-1:1)}),T}for(e in I.matches=function(e,t){return I(e,null,null,t)},I.matchesSelector=function(e,t){if(V(e),C&&!h[t+" "]&&(!d||!d.test(t)))try{var n=i.call(e,t);if(n||le.disconnectedMatch||e.document&&11!==e.document.nodeType)return n}catch(e){h(t,!0)}return 0<I(t,T,null,[e]).length},I.contains=function(e,t){return(e.ownerDocument||e)!=T&&V(e),ce.contains(e,t)},I.attr=function(e,t){(e.ownerDocument||e)!=T&&V(e);var n=b.attrHandle[t.toLowerCase()],r=n&&ue.call(b.attrHandle,t.toLowerCase())?n(e,t,!C):void 0;return void 0!==r?r:e.getAttribute(t)},I.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},ce.uniqueSort=function(e){var t,n=[],r=0,i=0;if(a=!le.sortStable,o=!le.sortStable&&ae.call(e,0),de.call(e,l),a){while(t=e[i++])t===e[i]&&(r=n.push(i));while(r--)he.call(e,n[r],1)}return o=null,e},ce.fn.uniqueSort=function(){return this.pushStack(ce.uniqueSort(ae.apply(this)))},(b=ce.expr={cacheLength:50,createPseudo:F,match:D,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(O,P),e[3]=(e[3]||e[4]||e[5]||"").replace(O,P),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||I.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&I.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return D.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&j.test(n)&&(t=Y(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(O,P).toLowerCase();return"*"===e?function(){return!0}:function(e){return fe(e,t)}},CLASS:function(e){var t=s[e+" "];return t||(t=new RegExp("(^|"+ge+")"+e+"("+ge+"|$)"))&&s(e,function(e){return t.test("string"==typeof e.className&&e.className||"undefined"!=typeof e.getAttribute&&e.getAttribute("class")||"")})},ATTR:function(n,r,i){return function(e){var t=I.attr(e,n);return null==t?"!="===r:!r||(t+="","="===r?t===i:"!="===r?t!==i:"^="===r?i&&0===t.indexOf(i):"*="===r?i&&-1<t.indexOf(i):"$="===r?i&&t.slice(-i.length)===i:"~="===r?-1<(" "+t.replace(v," ")+" ").indexOf(i):"|="===r&&(t===i||t.slice(0,i.length+1)===i+"-"))}},CHILD:function(d,e,t,h,g){var v="nth"!==d.slice(0,3),y="last"!==d.slice(-4),m="of-type"===e;return 1===h&&0===g?function(e){return!!e.parentNode}:function(e,t,n){var r,i,o,a,s,u=v!==y?"nextSibling":"previousSibling",l=e.parentNode,c=m&&e.nodeName.toLowerCase(),f=!n&&!m,p=!1;if(l){if(v){while(u){o=e;while(o=o[u])if(m?fe(o,c):1===o.nodeType)return!1;s=u="only"===d&&!s&&"nextSibling"}return!0}if(s=[y?l.firstChild:l.lastChild],y&&f){p=(a=(r=(i=l[S]||(l[S]={}))[d]||[])[0]===E&&r[1])&&r[2],o=a&&l.childNodes[a];while(o=++a&&o&&o[u]||(p=a=0)||s.pop())if(1===o.nodeType&&++p&&o===e){i[d]=[E,a,p];break}}else if(f&&(p=a=(r=(i=e[S]||(e[S]={}))[d]||[])[0]===E&&r[1]),!1===p)while(o=++a&&o&&o[u]||(p=a=0)||s.pop())if((m?fe(o,c):1===o.nodeType)&&++p&&(f&&((i=o[S]||(o[S]={}))[d]=[E,p]),o===e))break;return(p-=g)===h||p%h==0&&0<=p/h}}},PSEUDO:function(e,o){var t,a=b.pseudos[e]||b.setFilters[e.toLowerCase()]||I.error("unsupported pseudo: "+e);return a[S]?a(o):1<a.length?(t=[e,e,"",o],b.setFilters.hasOwnProperty(e.toLowerCase())?F(function(e,t){var n,r=a(e,o),i=r.length;while(i--)e[n=se.call(e,r[i])]=!(t[n]=r[i])}):function(e){return a(e,0,t)}):a}},pseudos:{not:F(function(e){var r=[],i=[],s=ne(e.replace(ve,"$1"));return s[S]?F(function(e,t,n,r){var i,o=s(e,null,r,[]),a=e.length;while(a--)(i=o[a])&&(e[a]=!(t[a]=i))}):function(e,t,n){return r[0]=e,s(r,null,n,i),r[0]=null,!i.pop()}}),has:F(function(t){return function(e){return 0<I(t,e).length}}),contains:F(function(t){return t=t.replace(O,P),function(e){return-1<(e.textContent||ce.text(e)).indexOf(t)}}),lang:F(function(n){return A.test(n||"")||I.error("unsupported lang: "+n),n=n.replace(O,P).toLowerCase(),function(e){var t;do{if(t=C?e.lang:e.getAttribute("xml:lang")||e.getAttribute("lang"))return(t=t.toLowerCase())===n||0===t.indexOf(n+"-")}while((e=e.parentNode)&&1===e.nodeType);return!1}}),target:function(e){var t=ie.location&&ie.location.hash;return t&&t.slice(1)===e.id},root:function(e){return e===r},focus:function(e){return e===function(){try{return T.activeElement}catch(e){}}()&&T.hasFocus()&&!!(e.type||e.href||~e.tabIndex)},enabled:z(!1),disabled:z(!0),checked:function(e){return fe(e,"input")&&!!e.checked||fe(e,"option")&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!b.pseudos.empty(e)},header:function(e){return q.test(e.nodeName)},input:function(e){return N.test(e.nodeName)},button:function(e){return fe(e,"input")&&"button"===e.type||fe(e,"button")},text:function(e){var t;return fe(e,"input")&&"text"===e.type&&(null==(t=e.getAttribute("type"))||"text"===t.toLowerCase())},first:X(function(){return[0]}),last:X(function(e,t){return[t-1]}),eq:X(function(e,t,n){return[n<0?n+t:n]}),even:X(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:X(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:X(function(e,t,n){var r;for(r=n<0?n+t:t<n?t:n;0<=--r;)e.push(r);return e}),gt:X(function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e})}}).pseudos.nth=b.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})b.pseudos[e]=B(e);for(e in{submit:!0,reset:!0})b.pseudos[e]=_(e);function G(){}function Y(e,t){var n,r,i,o,a,s,u,l=c[e+" "];if(l)return t?0:l.slice(0);a=e,s=[],u=b.preFilter;while(a){for(o in n&&!(r=y.exec(a))||(r&&(a=a.slice(r[0].length)||a),s.push(i=[])),n=!1,(r=m.exec(a))&&(n=r.shift(),i.push({value:n,type:r[0].replace(ve," ")}),a=a.slice(n.length)),b.filter)!(r=D[o].exec(a))||u[o]&&!(r=u[o](r))||(n=r.shift(),i.push({value:n,type:o,matches:r}),a=a.slice(n.length));if(!n)break}return t?a.length:a?I.error(e):c(e,s).slice(0)}function Q(e){for(var t=0,n=e.length,r="";t<n;t++)r+=e[t].value;return r}function J(a,e,t){var s=e.dir,u=e.next,l=u||s,c=t&&"parentNode"===l,f=n++;return e.first?function(e,t,n){while(e=e[s])if(1===e.nodeType||c)return a(e,t,n);return!1}:function(e,t,n){var r,i,o=[E,f];if(n){while(e=e[s])if((1===e.nodeType||c)&&a(e,t,n))return!0}else while(e=e[s])if(1===e.nodeType||c)if(i=e[S]||(e[S]={}),u&&fe(e,u))e=e[s]||e;else{if((r=i[l])&&r[0]===E&&r[1]===f)return o[2]=r[2];if((i[l]=o)[2]=a(e,t,n))return!0}return!1}}function K(i){return 1<i.length?function(e,t,n){var r=i.length;while(r--)if(!i[r](e,t,n))return!1;return!0}:i[0]}function Z(e,t,n,r,i){for(var o,a=[],s=0,u=e.length,l=null!=t;s<u;s++)(o=e[s])&&(n&&!n(o,r,i)||(a.push(o),l&&t.push(s)));return a}function ee(d,h,g,v,y,e){return v&&!v[S]&&(v=ee(v)),y&&!y[S]&&(y=ee(y,e)),F(function(e,t,n,r){var i,o,a,s,u=[],l=[],c=t.length,f=e||function(e,t,n){for(var r=0,i=t.length;r<i;r++)I(e,t[r],n);return n}(h||"*",n.nodeType?[n]:n,[]),p=!d||!e&&h?f:Z(f,u,d,n,r);if(g?g(p,s=y||(e?d:c||v)?[]:t,n,r):s=p,v){i=Z(s,l),v(i,[],n,r),o=i.length;while(o--)(a=i[o])&&(s[l[o]]=!(p[l[o]]=a))}if(e){if(y||d){if(y){i=[],o=s.length;while(o--)(a=s[o])&&i.push(p[o]=a);y(null,s=[],i,r)}o=s.length;while(o--)(a=s[o])&&-1<(i=y?se.call(e,a):u[o])&&(e[i]=!(t[i]=a))}}else s=Z(s===t?s.splice(c,s.length):s),y?y(null,t,s,r):k.apply(t,s)})}function te(e){for(var i,t,n,r=e.length,o=b.relative[e[0].type],a=o||b.relative[" "],s=o?1:0,u=J(function(e){return e===i},a,!0),l=J(function(e){return-1<se.call(i,e)},a,!0),c=[function(e,t,n){var r=!o&&(n||t!=w)||((i=t).nodeType?u(e,t,n):l(e,t,n));return i=null,r}];s<r;s++)if(t=b.relative[e[s].type])c=[J(K(c),t)];else{if((t=b.filter[e[s].type].apply(null,e[s].matches))[S]){for(n=++s;n<r;n++)if(b.relative[e[n].type])break;return ee(1<s&&K(c),1<s&&Q(e.slice(0,s-1).concat({value:" "===e[s-2].type?"*":""})).replace(ve,"$1"),t,s<n&&te(e.slice(s,n)),n<r&&te(e=e.slice(n)),n<r&&Q(e))}c.push(t)}return K(c)}function ne(e,t){var n,v,y,m,x,r,i=[],o=[],a=u[e+" "];if(!a){t||(t=Y(e)),n=t.length;while(n--)(a=te(t[n]))[S]?i.push(a):o.push(a);(a=u(e,(v=o,m=0<(y=i).length,x=0<v.length,r=function(e,t,n,r,i){var o,a,s,u=0,l="0",c=e&&[],f=[],p=w,d=e||x&&b.find.TAG("*",i),h=E+=null==p?1:Math.random()||.1,g=d.length;for(i&&(w=t==T||t||i);l!==g&&null!=(o=d[l]);l++){if(x&&o){a=0,t||o.ownerDocument==T||(V(o),n=!C);while(s=v[a++])if(s(o,t||T,n)){k.call(r,o);break}i&&(E=h)}m&&((o=!s&&o)&&u--,e&&c.push(o))}if(u+=l,m&&l!==u){a=0;while(s=y[a++])s(c,f,t,n);if(e){if(0<u)while(l--)c[l]||f[l]||(f[l]=pe.call(r));f=Z(f)}k.apply(r,f),i&&!e&&0<f.length&&1<u+y.length&&ce.uniqueSort(r)}return i&&(E=h,w=p),c},m?F(r):r))).selector=e}return a}function re(e,t,n,r){var i,o,a,s,u,l="function"==typeof e&&e,c=!r&&Y(e=l.selector||e);if(n=n||[],1===c.length){if(2<(o=c[0]=c[0].slice(0)).length&&"ID"===(a=o[0]).type&&9===t.nodeType&&C&&b.relative[o[1].type]){if(!(t=(b.find.ID(a.matches[0].replace(O,P),t)||[])[0]))return n;l&&(t=t.parentNode),e=e.slice(o.shift().value.length)}i=D.needsContext.test(e)?0:o.length;while(i--){if(a=o[i],b.relative[s=a.type])break;if((u=b.find[s])&&(r=u(a.matches[0].replace(O,P),H.test(o[0].type)&&U(t.parentNode)||t))){if(o.splice(i,1),!(e=r.length&&Q(o)))return k.apply(n,r),n;break}}}return(l||ne(e,c))(r,t,!C,n,!t||H.test(e)&&U(t.parentNode)||t),n}G.prototype=b.filters=b.pseudos,b.setFilters=new G,le.sortStable=S.split("").sort(l).join("")===S,V(),le.sortDetached=$(function(e){return 1&e.compareDocumentPosition(T.createElement("fieldset"))}),ce.find=I,ce.expr[":"]=ce.expr.pseudos,ce.unique=ce.uniqueSort,I.compile=ne,I.select=re,I.setDocument=V,I.tokenize=Y,I.escape=ce.escapeSelector,I.getText=ce.text,I.isXML=ce.isXMLDoc,I.selectors=ce.expr,I.support=ce.support,I.uniqueSort=ce.uniqueSort}();var d=function(e,t,n){var r=[],i=void 0!==n;while((e=e[t])&&9!==e.nodeType)if(1===e.nodeType){if(i&&ce(e).is(n))break;r.push(e)}return r},h=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},b=ce.expr.match.needsContext,w=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function T(e,n,r){return v(n)?ce.grep(e,function(e,t){return!!n.call(e,t,e)!==r}):n.nodeType?ce.grep(e,function(e){return e===n!==r}):"string"!=typeof n?ce.grep(e,function(e){return-1<se.call(n,e)!==r}):ce.filter(n,e,r)}ce.filter=function(e,t,n){var r=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===r.nodeType?ce.find.matchesSelector(r,e)?[r]:[]:ce.find.matches(e,ce.grep(t,function(e){return 1===e.nodeType}))},ce.fn.extend({find:function(e){var t,n,r=this.length,i=this;if("string"!=typeof e)return this.pushStack(ce(e).filter(function(){for(t=0;t<r;t++)if(ce.contains(i[t],this))return!0}));for(n=this.pushStack([]),t=0;t<r;t++)ce.find(e,i[t],n);return 1<r?ce.uniqueSort(n):n},filter:function(e){return this.pushStack(T(this,e||[],!1))},not:function(e){return this.pushStack(T(this,e||[],!0))},is:function(e){return!!T(this,"string"==typeof e&&b.test(e)?ce(e):e||[],!1).length}});var k,S=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(ce.fn.init=function(e,t,n){var r,i;if(!e)return this;if(n=n||k,"string"==typeof e){if(!(r="<"===e[0]&&">"===e[e.length-1]&&3<=e.length?[null,e,null]:S.exec(e))||!r[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(r[1]){if(t=t instanceof ce?t[0]:t,ce.merge(this,ce.parseHTML(r[1],t&&t.nodeType?t.ownerDocument||t:C,!0)),w.test(r[1])&&ce.isPlainObject(t))for(r in t)v(this[r])?this[r](t[r]):this.attr(r,t[r]);return this}return(i=C.getElementById(r[2]))&&(this[0]=i,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):v(e)?void 0!==n.ready?n.ready(e):e(ce):ce.makeArray(e,this)}).prototype=ce.fn,k=ce(C);var E=/^(?:parents|prev(?:Until|All))/,j={children:!0,contents:!0,next:!0,prev:!0};function A(e,t){while((e=e[t])&&1!==e.nodeType);return e}ce.fn.extend({has:function(e){var t=ce(e,this),n=t.length;return this.filter(function(){for(var e=0;e<n;e++)if(ce.contains(this,t[e]))return!0})},closest:function(e,t){var n,r=0,i=this.length,o=[],a="string"!=typeof e&&ce(e);if(!b.test(e))for(;r<i;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?-1<a.index(n):1===n.nodeType&&ce.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(1<o.length?ce.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?se.call(ce(e),this[0]):se.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(ce.uniqueSort(ce.merge(this.get(),ce(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),ce.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return d(e,"parentNode")},parentsUntil:function(e,t,n){return d(e,"parentNode",n)},next:function(e){return A(e,"nextSibling")},prev:function(e){return A(e,"previousSibling")},nextAll:function(e){return d(e,"nextSibling")},prevAll:function(e){return d(e,"previousSibling")},nextUntil:function(e,t,n){return d(e,"nextSibling",n)},prevUntil:function(e,t,n){return d(e,"previousSibling",n)},siblings:function(e){return h((e.parentNode||{}).firstChild,e)},children:function(e){return h(e.firstChild)},contents:function(e){return null!=e.contentDocument&&r(e.contentDocument)?e.contentDocument:(fe(e,"template")&&(e=e.content||e),ce.merge([],e.childNodes))}},function(r,i){ce.fn[r]=function(e,t){var n=ce.map(this,i,e);return"Until"!==r.slice(-5)&&(t=e),t&&"string"==typeof t&&(n=ce.filter(t,n)),1<this.length&&(j[r]||ce.uniqueSort(n),E.test(r)&&n.reverse()),this.pushStack(n)}});var D=/[^\x20\t\r\n\f]+/g;function N(e){return e}function q(e){throw e}function L(e,t,n,r){var i;try{e&&v(i=e.promise)?i.call(e).done(t).fail(n):e&&v(i=e.then)?i.call(e,t,n):t.apply(void 0,[e].slice(r))}catch(e){n.apply(void 0,[e])}}ce.Callbacks=function(r){var e,n;r="string"==typeof r?(e=r,n={},ce.each(e.match(D)||[],function(e,t){n[t]=!0}),n):ce.extend({},r);var i,t,o,a,s=[],u=[],l=-1,c=function(){for(a=a||r.once,o=i=!0;u.length;l=-1){t=u.shift();while(++l<s.length)!1===s[l].apply(t[0],t[1])&&r.stopOnFalse&&(l=s.length,t=!1)}r.memory||(t=!1),i=!1,a&&(s=t?[]:"")},f={add:function(){return s&&(t&&!i&&(l=s.length-1,u.push(t)),function n(e){ce.each(e,function(e,t){v(t)?r.unique&&f.has(t)||s.push(t):t&&t.length&&"string"!==x(t)&&n(t)})}(arguments),t&&!i&&c()),this},remove:function(){return ce.each(arguments,function(e,t){var n;while(-1<(n=ce.inArray(t,s,n)))s.splice(n,1),n<=l&&l--}),this},has:function(e){return e?-1<ce.inArray(e,s):0<s.length},empty:function(){return s&&(s=[]),this},disable:function(){return a=u=[],s=t="",this},disabled:function(){return!s},lock:function(){return a=u=[],t||i||(s=t=""),this},locked:function(){return!!a},fireWith:function(e,t){return a||(t=[e,(t=t||[]).slice?t.slice():t],u.push(t),i||c()),this},fire:function(){return f.fireWith(this,arguments),this},fired:function(){return!!o}};return f},ce.extend({Deferred:function(e){var o=[["notify","progress",ce.Callbacks("memory"),ce.Callbacks("memory"),2],["resolve","done",ce.Callbacks("once memory"),ce.Callbacks("once memory"),0,"resolved"],["reject","fail",ce.Callbacks("once memory"),ce.Callbacks("once memory"),1,"rejected"]],i="pending",a={state:function(){return i},always:function(){return s.done(arguments).fail(arguments),this},"catch":function(e){return a.then(null,e)},pipe:function(){var i=arguments;return ce.Deferred(function(r){ce.each(o,function(e,t){var n=v(i[t[4]])&&i[t[4]];s[t[1]](function(){var e=n&&n.apply(this,arguments);e&&v(e.promise)?e.promise().progress(r.notify).done(r.resolve).fail(r.reject):r[t[0]+"With"](this,n?[e]:arguments)})}),i=null}).promise()},then:function(t,n,r){var u=0;function l(i,o,a,s){return function(){var n=this,r=arguments,e=function(){var e,t;if(!(i<u)){if((e=a.apply(n,r))===o.promise())throw new TypeError("Thenable self-resolution");t=e&&("object"==typeof e||"function"==typeof e)&&e.then,v(t)?s?t.call(e,l(u,o,N,s),l(u,o,q,s)):(u++,t.call(e,l(u,o,N,s),l(u,o,q,s),l(u,o,N,o.notifyWith))):(a!==N&&(n=void 0,r=[e]),(s||o.resolveWith)(n,r))}},t=s?e:function(){try{e()}catch(e){ce.Deferred.exceptionHook&&ce.Deferred.exceptionHook(e,t.error),u<=i+1&&(a!==q&&(n=void 0,r=[e]),o.rejectWith(n,r))}};i?t():(ce.Deferred.getErrorHook?t.error=ce.Deferred.getErrorHook():ce.Deferred.getStackHook&&(t.error=ce.Deferred.getStackHook()),ie.setTimeout(t))}}return ce.Deferred(function(e){o[0][3].add(l(0,e,v(r)?r:N,e.notifyWith)),o[1][3].add(l(0,e,v(t)?t:N)),o[2][3].add(l(0,e,v(n)?n:q))}).promise()},promise:function(e){return null!=e?ce.extend(e,a):a}},s={};return ce.each(o,function(e,t){var n=t[2],r=t[5];a[t[1]]=n.add,r&&n.add(function(){i=r},o[3-e][2].disable,o[3-e][3].disable,o[0][2].lock,o[0][3].lock),n.add(t[3].fire),s[t[0]]=function(){return s[t[0]+"With"](this===s?void 0:this,arguments),this},s[t[0]+"With"]=n.fireWith}),a.promise(s),e&&e.call(s,s),s},when:function(e){var n=arguments.length,t=n,r=Array(t),i=ae.call(arguments),o=ce.Deferred(),a=function(t){return function(e){r[t]=this,i[t]=1<arguments.length?ae.call(arguments):e,--n||o.resolveWith(r,i)}};if(n<=1&&(L(e,o.done(a(t)).resolve,o.reject,!n),"pending"===o.state()||v(i[t]&&i[t].then)))return o.then();while(t--)L(i[t],a(t),o.reject);return o.promise()}});var H=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;ce.Deferred.exceptionHook=function(e,t){ie.console&&ie.console.warn&&e&&H.test(e.name)&&ie.console.warn("jQuery.Deferred exception: "+e.message,e.stack,t)},ce.readyException=function(e){ie.setTimeout(function(){throw e})};var O=ce.Deferred();function P(){C.removeEventListener("DOMContentLoaded",P),ie.removeEventListener("load",P),ce.ready()}ce.fn.ready=function(e){return O.then(e)["catch"](function(e){ce.readyException(e)}),this},ce.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--ce.readyWait:ce.isReady)||(ce.isReady=!0)!==e&&0<--ce.readyWait||O.resolveWith(C,[ce])}}),ce.ready.then=O.then,"complete"===C.readyState||"loading"!==C.readyState&&!C.documentElement.doScroll?ie.setTimeout(ce.ready):(C.addEventListener("DOMContentLoaded",P),ie.addEventListener("load",P));var M=function(e,t,n,r,i,o,a){var s=0,u=e.length,l=null==n;if("object"===x(n))for(s in i=!0,n)M(e,t,s,n[s],!0,o,a);else if(void 0!==r&&(i=!0,v(r)||(a=!0),l&&(a?(t.call(e,r),t=null):(l=t,t=function(e,t,n){return l.call(ce(e),n)})),t))for(;s<u;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return i?e:l?t.call(e):u?t(e[0],n):o},R=/^-ms-/,I=/-([a-z])/g;function W(e,t){return t.toUpperCase()}function F(e){return e.replace(R,"ms-").replace(I,W)}var $=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function B(){this.expando=ce.expando+B.uid++}B.uid=1,B.prototype={cache:function(e){var t=e[this.expando];return t||(t={},$(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var r,i=this.cache(e);if("string"==typeof t)i[F(t)]=n;else for(r in t)i[F(r)]=t[r];return i},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][F(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,r=e[this.expando];if(void 0!==r){if(void 0!==t){n=(t=Array.isArray(t)?t.map(F):(t=F(t))in r?[t]:t.match(D)||[]).length;while(n--)delete r[t[n]]}(void 0===t||ce.isEmptyObject(r))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!ce.isEmptyObject(t)}};var _=new B,z=new B,X=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,U=/[A-Z]/g;function V(e,t,n){var r,i;if(void 0===n&&1===e.nodeType)if(r="data-"+t.replace(U,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(r))){try{n="true"===(i=n)||"false"!==i&&("null"===i?null:i===+i+""?+i:X.test(i)?JSON.parse(i):i)}catch(e){}z.set(e,t,n)}else n=void 0;return n}ce.extend({hasData:function(e){return z.hasData(e)||_.hasData(e)},data:function(e,t,n){return z.access(e,t,n)},removeData:function(e,t){z.remove(e,t)},_data:function(e,t,n){return _.access(e,t,n)},_removeData:function(e,t){_.remove(e,t)}}),ce.fn.extend({data:function(n,e){var t,r,i,o=this[0],a=o&&o.attributes;if(void 0===n){if(this.length&&(i=z.get(o),1===o.nodeType&&!_.get(o,"hasDataAttrs"))){t=a.length;while(t--)a[t]&&0===(r=a[t].name).indexOf("data-")&&(r=F(r.slice(5)),V(o,r,i[r]));_.set(o,"hasDataAttrs",!0)}return i}return"object"==typeof n?this.each(function(){z.set(this,n)}):M(this,function(e){var t;if(o&&void 0===e)return void 0!==(t=z.get(o,n))?t:void 0!==(t=V(o,n))?t:void 0;this.each(function(){z.set(this,n,e)})},null,e,1<arguments.length,null,!0)},removeData:function(e){return this.each(function(){z.remove(this,e)})}}),ce.extend({queue:function(e,t,n){var r;if(e)return t=(t||"fx")+"queue",r=_.get(e,t),n&&(!r||Array.isArray(n)?r=_.access(e,t,ce.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||"fx";var n=ce.queue(e,t),r=n.length,i=n.shift(),o=ce._queueHooks(e,t);"inprogress"===i&&(i=n.shift(),r--),i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,function(){ce.dequeue(e,t)},o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return _.get(e,n)||_.access(e,n,{empty:ce.Callbacks("once memory").add(function(){_.remove(e,[t+"queue",n])})})}}),ce.fn.extend({queue:function(t,n){var e=2;return"string"!=typeof t&&(n=t,t="fx",e--),arguments.length<e?ce.queue(this[0],t):void 0===n?this:this.each(function(){var e=ce.queue(this,t,n);ce._queueHooks(this,t),"fx"===t&&"inprogress"!==e[0]&&ce.dequeue(this,t)})},dequeue:function(e){return this.each(function(){ce.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,r=1,i=ce.Deferred(),o=this,a=this.length,s=function(){--r||i.resolveWith(o,[o])};"string"!=typeof e&&(t=e,e=void 0),e=e||"fx";while(a--)(n=_.get(o[a],e+"queueHooks"))&&n.empty&&(r++,n.empty.add(s));return s(),i.promise(t)}});var G=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,Y=new RegExp("^(?:([+-])=|)("+G+")([a-z%]*)$","i"),Q=["Top","Right","Bottom","Left"],J=C.documentElement,K=function(e){return ce.contains(e.ownerDocument,e)},Z={composed:!0};J.getRootNode&&(K=function(e){return ce.contains(e.ownerDocument,e)||e.getRootNode(Z)===e.ownerDocument});var ee=function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&K(e)&&"none"===ce.css(e,"display")};function te(e,t,n,r){var i,o,a=20,s=r?function(){return r.cur()}:function(){return ce.css(e,t,"")},u=s(),l=n&&n[3]||(ce.cssNumber[t]?"":"px"),c=e.nodeType&&(ce.cssNumber[t]||"px"!==l&&+u)&&Y.exec(ce.css(e,t));if(c&&c[3]!==l){u/=2,l=l||c[3],c=+u||1;while(a--)ce.style(e,t,c+l),(1-o)*(1-(o=s()/u||.5))<=0&&(a=0),c/=o;c*=2,ce.style(e,t,c+l),n=n||[]}return n&&(c=+c||+u||0,i=n[1]?c+(n[1]+1)*n[2]:+n[2],r&&(r.unit=l,r.start=c,r.end=i)),i}var ne={};function re(e,t){for(var n,r,i,o,a,s,u,l=[],c=0,f=e.length;c<f;c++)(r=e[c]).style&&(n=r.style.display,t?("none"===n&&(l[c]=_.get(r,"display")||null,l[c]||(r.style.display="")),""===r.style.display&&ee(r)&&(l[c]=(u=a=o=void 0,a=(i=r).ownerDocument,s=i.nodeName,(u=ne[s])||(o=a.body.appendChild(a.createElement(s)),u=ce.css(o,"display"),o.parentNode.removeChild(o),"none"===u&&(u="block"),ne[s]=u)))):"none"!==n&&(l[c]="none",_.set(r,"display",n)));for(c=0;c<f;c++)null!=l[c]&&(e[c].style.display=l[c]);return e}ce.fn.extend({show:function(){return re(this,!0)},hide:function(){return re(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each(function(){ee(this)?ce(this).show():ce(this).hide()})}});var xe,be,we=/^(?:checkbox|radio)$/i,Te=/<([a-z][^\/\0>\x20\t\r\n\f]*)/i,Ce=/^$|^module$|\/(?:java|ecma)script/i;xe=C.createDocumentFragment().appendChild(C.createElement("div")),(be=C.createElement("input")).setAttribute("type","radio"),be.setAttribute("checked","checked"),be.setAttribute("name","t"),xe.appendChild(be),le.checkClone=xe.cloneNode(!0).cloneNode(!0).lastChild.checked,xe.innerHTML="<textarea>x</textarea>",le.noCloneChecked=!!xe.cloneNode(!0).lastChild.defaultValue,xe.innerHTML="<option></option>",le.option=!!xe.lastChild;var ke={thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};function Se(e,t){var n;return n="undefined"!=typeof e.getElementsByTagName?e.getElementsByTagName(t||"*"):"undefined"!=typeof e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&fe(e,t)?ce.merge([e],n):n}function Ee(e,t){for(var n=0,r=e.length;n<r;n++)_.set(e[n],"globalEval",!t||_.get(t[n],"globalEval"))}ke.tbody=ke.tfoot=ke.colgroup=ke.caption=ke.thead,ke.th=ke.td,le.option||(ke.optgroup=ke.option=[1,"<select multiple='multiple'>","</select>"]);var je=/<|&#?\w+;/;function Ae(e,t,n,r,i){for(var o,a,s,u,l,c,f=t.createDocumentFragment(),p=[],d=0,h=e.length;d<h;d++)if((o=e[d])||0===o)if("object"===x(o))ce.merge(p,o.nodeType?[o]:o);else if(je.test(o)){a=a||f.appendChild(t.createElement("div")),s=(Te.exec(o)||["",""])[1].toLowerCase(),u=ke[s]||ke._default,a.innerHTML=u[1]+ce.htmlPrefilter(o)+u[2],c=u[0];while(c--)a=a.lastChild;ce.merge(p,a.childNodes),(a=f.firstChild).textContent=""}else p.push(t.createTextNode(o));f.textContent="",d=0;while(o=p[d++])if(r&&-1<ce.inArray(o,r))i&&i.push(o);else if(l=K(o),a=Se(f.appendChild(o),"script"),l&&Ee(a),n){c=0;while(o=a[c++])Ce.test(o.type||"")&&n.push(o)}return f}var De=/^([^.]*)(?:\.(.+)|)/;function Ne(){return!0}function qe(){return!1}function Le(e,t,n,r,i,o){var a,s;if("object"==typeof t){for(s in"string"!=typeof n&&(r=r||n,n=void 0),t)Le(e,s,n,r,t[s],o);return e}if(null==r&&null==i?(i=n,r=n=void 0):null==i&&("string"==typeof n?(i=r,r=void 0):(i=r,r=n,n=void 0)),!1===i)i=qe;else if(!i)return e;return 1===o&&(a=i,(i=function(e){return ce().off(e),a.apply(this,arguments)}).guid=a.guid||(a.guid=ce.guid++)),e.each(function(){ce.event.add(this,t,i,r,n)})}function He(e,r,t){t?(_.set(e,r,!1),ce.event.add(e,r,{namespace:!1,handler:function(e){var t,n=_.get(this,r);if(1&e.isTrigger&&this[r]){if(n)(ce.event.special[r]||{}).delegateType&&e.stopPropagation();else if(n=ae.call(arguments),_.set(this,r,n),this[r](),t=_.get(this,r),_.set(this,r,!1),n!==t)return e.stopImmediatePropagation(),e.preventDefault(),t}else n&&(_.set(this,r,ce.event.trigger(n[0],n.slice(1),this)),e.stopPropagation(),e.isImmediatePropagationStopped=Ne)}})):void 0===_.get(e,r)&&ce.event.add(e,r,Ne)}ce.event={global:{},add:function(t,e,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=_.get(t);if($(t)){n.handler&&(n=(o=n).handler,i=o.selector),i&&ce.find.matchesSelector(J,i),n.guid||(n.guid=ce.guid++),(u=v.events)||(u=v.events=Object.create(null)),(a=v.handle)||(a=v.handle=function(e){return"undefined"!=typeof ce&&ce.event.triggered!==e.type?ce.event.dispatch.apply(t,arguments):void 0}),l=(e=(e||"").match(D)||[""]).length;while(l--)d=g=(s=De.exec(e[l])||[])[1],h=(s[2]||"").split(".").sort(),d&&(f=ce.event.special[d]||{},d=(i?f.delegateType:f.bindType)||d,f=ce.event.special[d]||{},c=ce.extend({type:d,origType:g,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&ce.expr.match.needsContext.test(i),namespace:h.join(".")},o),(p=u[d])||((p=u[d]=[]).delegateCount=0,f.setup&&!1!==f.setup.call(t,r,h,a)||t.addEventListener&&t.addEventListener(d,a)),f.add&&(f.add.call(t,c),c.handler.guid||(c.handler.guid=n.guid)),i?p.splice(p.delegateCount++,0,c):p.push(c),ce.event.global[d]=!0)}},remove:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=_.hasData(e)&&_.get(e);if(v&&(u=v.events)){l=(t=(t||"").match(D)||[""]).length;while(l--)if(d=g=(s=De.exec(t[l])||[])[1],h=(s[2]||"").split(".").sort(),d){f=ce.event.special[d]||{},p=u[d=(r?f.delegateType:f.bindType)||d]||[],s=s[2]&&new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),a=o=p.length;while(o--)c=p[o],!i&&g!==c.origType||n&&n.guid!==c.guid||s&&!s.test(c.namespace)||r&&r!==c.selector&&("**"!==r||!c.selector)||(p.splice(o,1),c.selector&&p.delegateCount--,f.remove&&f.remove.call(e,c));a&&!p.length&&(f.teardown&&!1!==f.teardown.call(e,h,v.handle)||ce.removeEvent(e,d,v.handle),delete u[d])}else for(d in u)ce.event.remove(e,d+t[l],n,r,!0);ce.isEmptyObject(u)&&_.remove(e,"handle events")}},dispatch:function(e){var t,n,r,i,o,a,s=new Array(arguments.length),u=ce.event.fix(e),l=(_.get(this,"events")||Object.create(null))[u.type]||[],c=ce.event.special[u.type]||{};for(s[0]=u,t=1;t<arguments.length;t++)s[t]=arguments[t];if(u.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,u)){a=ce.event.handlers.call(this,u,l),t=0;while((i=a[t++])&&!u.isPropagationStopped()){u.currentTarget=i.elem,n=0;while((o=i.handlers[n++])&&!u.isImmediatePropagationStopped())u.rnamespace&&!1!==o.namespace&&!u.rnamespace.test(o.namespace)||(u.handleObj=o,u.data=o.data,void 0!==(r=((ce.event.special[o.origType]||{}).handle||o.handler).apply(i.elem,s))&&!1===(u.result=r)&&(u.preventDefault(),u.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,u),u.result}},handlers:function(e,t){var n,r,i,o,a,s=[],u=t.delegateCount,l=e.target;if(u&&l.nodeType&&!("click"===e.type&&1<=e.button))for(;l!==this;l=l.parentNode||this)if(1===l.nodeType&&("click"!==e.type||!0!==l.disabled)){for(o=[],a={},n=0;n<u;n++)void 0===a[i=(r=t[n]).selector+" "]&&(a[i]=r.needsContext?-1<ce(i,this).index(l):ce.find(i,this,null,[l]).length),a[i]&&o.push(r);o.length&&s.push({elem:l,handlers:o})}return l=this,u<t.length&&s.push({elem:l,handlers:t.slice(u)}),s},addProp:function(t,e){Object.defineProperty(ce.Event.prototype,t,{enumerable:!0,configurable:!0,get:v(e)?function(){if(this.originalEvent)return e(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[t]},set:function(e){Object.defineProperty(this,t,{enumerable:!0,configurable:!0,writable:!0,value:e})}})},fix:function(e){return e[ce.expando]?e:new ce.Event(e)},special:{load:{noBubble:!0},click:{setup:function(e){var t=this||e;return we.test(t.type)&&t.click&&fe(t,"input")&&He(t,"click",!0),!1},trigger:function(e){var t=this||e;return we.test(t.type)&&t.click&&fe(t,"input")&&He(t,"click"),!0},_default:function(e){var t=e.target;return we.test(t.type)&&t.click&&fe(t,"input")&&_.get(t,"click")||fe(t,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},ce.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},ce.Event=function(e,t){if(!(this instanceof ce.Event))return new ce.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?Ne:qe,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&ce.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[ce.expando]=!0},ce.Event.prototype={constructor:ce.Event,isDefaultPrevented:qe,isPropagationStopped:qe,isImmediatePropagationStopped:qe,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=Ne,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=Ne,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=Ne,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},ce.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:!0},ce.event.addProp),ce.each({focus:"focusin",blur:"focusout"},function(r,i){function o(e){if(C.documentMode){var t=_.get(this,"handle"),n=ce.event.fix(e);n.type="focusin"===e.type?"focus":"blur",n.isSimulated=!0,t(e),n.target===n.currentTarget&&t(n)}else ce.event.simulate(i,e.target,ce.event.fix(e))}ce.event.special[r]={setup:function(){var e;if(He(this,r,!0),!C.documentMode)return!1;(e=_.get(this,i))||this.addEventListener(i,o),_.set(this,i,(e||0)+1)},trigger:function(){return He(this,r),!0},teardown:function(){var e;if(!C.documentMode)return!1;(e=_.get(this,i)-1)?_.set(this,i,e):(this.removeEventListener(i,o),_.remove(this,i))},_default:function(e){return _.get(e.target,r)},delegateType:i},ce.event.special[i]={setup:function(){var e=this.ownerDocument||this.document||this,t=C.documentMode?this:e,n=_.get(t,i);n||(C.documentMode?this.addEventListener(i,o):e.addEventListener(r,o,!0)),_.set(t,i,(n||0)+1)},teardown:function(){var e=this.ownerDocument||this.document||this,t=C.documentMode?this:e,n=_.get(t,i)-1;n?_.set(t,i,n):(C.documentMode?this.removeEventListener(i,o):e.removeEventListener(r,o,!0),_.remove(t,i))}}}),ce.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(e,i){ce.event.special[e]={delegateType:i,bindType:i,handle:function(e){var t,n=e.relatedTarget,r=e.handleObj;return n&&(n===this||ce.contains(this,n))||(e.type=r.origType,t=r.handler.apply(this,arguments),e.type=i),t}}}),ce.fn.extend({on:function(e,t,n,r){return Le(this,e,t,n,r)},one:function(e,t,n,r){return Le(this,e,t,n,r,1)},off:function(e,t,n){var r,i;if(e&&e.preventDefault&&e.handleObj)return r=e.handleObj,ce(e.delegateTarget).off(r.namespace?r.origType+"."+r.namespace:r.origType,r.selector,r.handler),this;if("object"==typeof e){for(i in e)this.off(i,t,e[i]);return this}return!1!==t&&"function"!=typeof t||(n=t,t=void 0),!1===n&&(n=qe),this.each(function(){ce.event.remove(this,e,n,t)})}});var Oe=/<script|<style|<link/i,Pe=/checked\s*(?:[^=]|=\s*.checked.)/i,Me=/^\s*<!\[CDATA\[|\]\]>\s*$/g;function Re(e,t){return fe(e,"table")&&fe(11!==t.nodeType?t:t.firstChild,"tr")&&ce(e).children("tbody")[0]||e}function Ie(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function We(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function Fe(e,t){var n,r,i,o,a,s;if(1===t.nodeType){if(_.hasData(e)&&(s=_.get(e).events))for(i in _.remove(t,"handle events"),s)for(n=0,r=s[i].length;n<r;n++)ce.event.add(t,i,s[i][n]);z.hasData(e)&&(o=z.access(e),a=ce.extend({},o),z.set(t,a))}}function $e(n,r,i,o){r=g(r);var e,t,a,s,u,l,c=0,f=n.length,p=f-1,d=r[0],h=v(d);if(h||1<f&&"string"==typeof d&&!le.checkClone&&Pe.test(d))return n.each(function(e){var t=n.eq(e);h&&(r[0]=d.call(this,e,t.html())),$e(t,r,i,o)});if(f&&(t=(e=Ae(r,n[0].ownerDocument,!1,n,o)).firstChild,1===e.childNodes.length&&(e=t),t||o)){for(s=(a=ce.map(Se(e,"script"),Ie)).length;c<f;c++)u=e,c!==p&&(u=ce.clone(u,!0,!0),s&&ce.merge(a,Se(u,"script"))),i.call(n[c],u,c);if(s)for(l=a[a.length-1].ownerDocument,ce.map(a,We),c=0;c<s;c++)u=a[c],Ce.test(u.type||"")&&!_.access(u,"globalEval")&&ce.contains(l,u)&&(u.src&&"module"!==(u.type||"").toLowerCase()?ce._evalUrl&&!u.noModule&&ce._evalUrl(u.src,{nonce:u.nonce||u.getAttribute("nonce")},l):m(u.textContent.replace(Me,""),u,l))}return n}function Be(e,t,n){for(var r,i=t?ce.filter(t,e):e,o=0;null!=(r=i[o]);o++)n||1!==r.nodeType||ce.cleanData(Se(r)),r.parentNode&&(n&&K(r)&&Ee(Se(r,"script")),r.parentNode.removeChild(r));return e}ce.extend({htmlPrefilter:function(e){return e},clone:function(e,t,n){var r,i,o,a,s,u,l,c=e.cloneNode(!0),f=K(e);if(!(le.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||ce.isXMLDoc(e)))for(a=Se(c),r=0,i=(o=Se(e)).length;r<i;r++)s=o[r],u=a[r],void 0,"input"===(l=u.nodeName.toLowerCase())&&we.test(s.type)?u.checked=s.checked:"input"!==l&&"textarea"!==l||(u.defaultValue=s.defaultValue);if(t)if(n)for(o=o||Se(e),a=a||Se(c),r=0,i=o.length;r<i;r++)Fe(o[r],a[r]);else Fe(e,c);return 0<(a=Se(c,"script")).length&&Ee(a,!f&&Se(e,"script")),c},cleanData:function(e){for(var t,n,r,i=ce.event.special,o=0;void 0!==(n=e[o]);o++)if($(n)){if(t=n[_.expando]){if(t.events)for(r in t.events)i[r]?ce.event.remove(n,r):ce.removeEvent(n,r,t.handle);n[_.expando]=void 0}n[z.expando]&&(n[z.expando]=void 0)}}}),ce.fn.extend({detach:function(e){return Be(this,e,!0)},remove:function(e){return Be(this,e)},text:function(e){return M(this,function(e){return void 0===e?ce.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)})},null,e,arguments.length)},append:function(){return $e(this,arguments,function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||Re(this,e).appendChild(e)})},prepend:function(){return $e(this,arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=Re(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return $e(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return $e(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(ce.cleanData(Se(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return ce.clone(this,e,t)})},html:function(e){return M(this,function(e){var t=this[0]||{},n=0,r=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!Oe.test(e)&&!ke[(Te.exec(e)||["",""])[1].toLowerCase()]){e=ce.htmlPrefilter(e);try{for(;n<r;n++)1===(t=this[n]||{}).nodeType&&(ce.cleanData(Se(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var n=[];return $e(this,arguments,function(e){var t=this.parentNode;ce.inArray(this,n)<0&&(ce.cleanData(Se(this)),t&&t.replaceChild(e,this))},n)}}),ce.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,a){ce.fn[e]=function(e){for(var t,n=[],r=ce(e),i=r.length-1,o=0;o<=i;o++)t=o===i?this:this.clone(!0),ce(r[o])[a](t),s.apply(n,t.get());return this.pushStack(n)}});var _e=new RegExp("^("+G+")(?!px)[a-z%]+$","i"),ze=/^--/,Xe=function(e){var t=e.ownerDocument.defaultView;return t&&t.opener||(t=ie),t.getComputedStyle(e)},Ue=function(e,t,n){var r,i,o={};for(i in t)o[i]=e.style[i],e.style[i]=t[i];for(i in r=n.call(e),t)e.style[i]=o[i];return r},Ve=new RegExp(Q.join("|"),"i");function Ge(e,t,n){var r,i,o,a,s=ze.test(t),u=e.style;return(n=n||Xe(e))&&(a=n.getPropertyValue(t)||n[t],s&&a&&(a=a.replace(ve,"$1")||void 0),""!==a||K(e)||(a=ce.style(e,t)),!le.pixelBoxStyles()&&_e.test(a)&&Ve.test(t)&&(r=u.width,i=u.minWidth,o=u.maxWidth,u.minWidth=u.maxWidth=u.width=a,a=n.width,u.width=r,u.minWidth=i,u.maxWidth=o)),void 0!==a?a+"":a}function Ye(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}!function(){function e(){if(l){u.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",l.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",J.appendChild(u).appendChild(l);var e=ie.getComputedStyle(l);n="1%"!==e.top,s=12===t(e.marginLeft),l.style.right="60%",o=36===t(e.right),r=36===t(e.width),l.style.position="absolute",i=12===t(l.offsetWidth/3),J.removeChild(u),l=null}}function t(e){return Math.round(parseFloat(e))}var n,r,i,o,a,s,u=C.createElement("div"),l=C.createElement("div");l.style&&(l.style.backgroundClip="content-box",l.cloneNode(!0).style.backgroundClip="",le.clearCloneStyle="content-box"===l.style.backgroundClip,ce.extend(le,{boxSizingReliable:function(){return e(),r},pixelBoxStyles:function(){return e(),o},pixelPosition:function(){return e(),n},reliableMarginLeft:function(){return e(),s},scrollboxSize:function(){return e(),i},reliableTrDimensions:function(){var e,t,n,r;return null==a&&(e=C.createElement("table"),t=C.createElement("tr"),n=C.createElement("div"),e.style.cssText="position:absolute;left:-11111px;border-collapse:separate",t.style.cssText="box-sizing:content-box;border:1px solid",t.style.height="1px",n.style.height="9px",n.style.display="block",J.appendChild(e).appendChild(t).appendChild(n),r=ie.getComputedStyle(t),a=parseInt(r.height,10)+parseInt(r.borderTopWidth,10)+parseInt(r.borderBottomWidth,10)===t.offsetHeight,J.removeChild(e)),a}}))}();var Qe=["Webkit","Moz","ms"],Je=C.createElement("div").style,Ke={};function Ze(e){var t=ce.cssProps[e]||Ke[e];return t||(e in Je?e:Ke[e]=function(e){var t=e[0].toUpperCase()+e.slice(1),n=Qe.length;while(n--)if((e=Qe[n]+t)in Je)return e}(e)||e)}var et=/^(none|table(?!-c[ea]).+)/,tt={position:"absolute",visibility:"hidden",display:"block"},nt={letterSpacing:"0",fontWeight:"400"};function rt(e,t,n){var r=Y.exec(t);return r?Math.max(0,r[2]-(n||0))+(r[3]||"px"):t}function it(e,t,n,r,i,o){var a="width"===t?1:0,s=0,u=0,l=0;if(n===(r?"border":"content"))return 0;for(;a<4;a+=2)"margin"===n&&(l+=ce.css(e,n+Q[a],!0,i)),r?("content"===n&&(u-=ce.css(e,"padding"+Q[a],!0,i)),"margin"!==n&&(u-=ce.css(e,"border"+Q[a]+"Width",!0,i))):(u+=ce.css(e,"padding"+Q[a],!0,i),"padding"!==n?u+=ce.css(e,"border"+Q[a]+"Width",!0,i):s+=ce.css(e,"border"+Q[a]+"Width",!0,i));return!r&&0<=o&&(u+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-u-s-.5))||0),u+l}function ot(e,t,n){var r=Xe(e),i=(!le.boxSizingReliable()||n)&&"border-box"===ce.css(e,"boxSizing",!1,r),o=i,a=Ge(e,t,r),s="offset"+t[0].toUpperCase()+t.slice(1);if(_e.test(a)){if(!n)return a;a="auto"}return(!le.boxSizingReliable()&&i||!le.reliableTrDimensions()&&fe(e,"tr")||"auto"===a||!parseFloat(a)&&"inline"===ce.css(e,"display",!1,r))&&e.getClientRects().length&&(i="border-box"===ce.css(e,"boxSizing",!1,r),(o=s in e)&&(a=e[s])),(a=parseFloat(a)||0)+it(e,t,n||(i?"border":"content"),o,r,a)+"px"}function at(e,t,n,r,i){return new at.prototype.init(e,t,n,r,i)}ce.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=Ge(e,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,aspectRatio:!0,borderImageSlice:!0,columnCount:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,gridArea:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnStart:!0,gridRow:!0,gridRowEnd:!0,gridRowStart:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,scale:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeMiterlimit:!0,strokeOpacity:!0},cssProps:{},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var i,o,a,s=F(t),u=ze.test(t),l=e.style;if(u||(t=Ze(s)),a=ce.cssHooks[t]||ce.cssHooks[s],void 0===n)return a&&"get"in a&&void 0!==(i=a.get(e,!1,r))?i:l[t];"string"===(o=typeof n)&&(i=Y.exec(n))&&i[1]&&(n=te(e,t,i),o="number"),null!=n&&n==n&&("number"!==o||u||(n+=i&&i[3]||(ce.cssNumber[s]?"":"px")),le.clearCloneStyle||""!==n||0!==t.indexOf("background")||(l[t]="inherit"),a&&"set"in a&&void 0===(n=a.set(e,n,r))||(u?l.setProperty(t,n):l[t]=n))}},css:function(e,t,n,r){var i,o,a,s=F(t);return ze.test(t)||(t=Ze(s)),(a=ce.cssHooks[t]||ce.cssHooks[s])&&"get"in a&&(i=a.get(e,!0,n)),void 0===i&&(i=Ge(e,t,r)),"normal"===i&&t in nt&&(i=nt[t]),""===n||n?(o=parseFloat(i),!0===n||isFinite(o)?o||0:i):i}}),ce.each(["height","width"],function(e,u){ce.cssHooks[u]={get:function(e,t,n){if(t)return!et.test(ce.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?ot(e,u,n):Ue(e,tt,function(){return ot(e,u,n)})},set:function(e,t,n){var r,i=Xe(e),o=!le.scrollboxSize()&&"absolute"===i.position,a=(o||n)&&"border-box"===ce.css(e,"boxSizing",!1,i),s=n?it(e,u,n,a,i):0;return a&&o&&(s-=Math.ceil(e["offset"+u[0].toUpperCase()+u.slice(1)]-parseFloat(i[u])-it(e,u,"border",!1,i)-.5)),s&&(r=Y.exec(t))&&"px"!==(r[3]||"px")&&(e.style[u]=t,t=ce.css(e,u)),rt(0,t,s)}}}),ce.cssHooks.marginLeft=Ye(le.reliableMarginLeft,function(e,t){if(t)return(parseFloat(Ge(e,"marginLeft"))||e.getBoundingClientRect().left-Ue(e,{marginLeft:0},function(){return e.getBoundingClientRect().left}))+"px"}),ce.each({margin:"",padding:"",border:"Width"},function(i,o){ce.cssHooks[i+o]={expand:function(e){for(var t=0,n={},r="string"==typeof e?e.split(" "):[e];t<4;t++)n[i+Q[t]+o]=r[t]||r[t-2]||r[0];return n}},"margin"!==i&&(ce.cssHooks[i+o].set=rt)}),ce.fn.extend({css:function(e,t){return M(this,function(e,t,n){var r,i,o={},a=0;if(Array.isArray(t)){for(r=Xe(e),i=t.length;a<i;a++)o[t[a]]=ce.css(e,t[a],!1,r);return o}return void 0!==n?ce.style(e,t,n):ce.css(e,t)},e,t,1<arguments.length)}}),((ce.Tween=at).prototype={constructor:at,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||ce.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(ce.cssNumber[n]?"":"px")},cur:function(){var e=at.propHooks[this.prop];return e&&e.get?e.get(this):at.propHooks._default.get(this)},run:function(e){var t,n=at.propHooks[this.prop];return this.options.duration?this.pos=t=ce.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):at.propHooks._default.set(this),this}}).init.prototype=at.prototype,(at.propHooks={_default:{get:function(e){var t;return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(t=ce.css(e.elem,e.prop,""))&&"auto"!==t?t:0},set:function(e){ce.fx.step[e.prop]?ce.fx.step[e.prop](e):1!==e.elem.nodeType||!ce.cssHooks[e.prop]&&null==e.elem.style[Ze(e.prop)]?e.elem[e.prop]=e.now:ce.style(e.elem,e.prop,e.now+e.unit)}}}).scrollTop=at.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},ce.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},_default:"swing"},ce.fx=at.prototype.init,ce.fx.step={};var st,ut,lt,ct,ft=/^(?:toggle|show|hide)$/,pt=/queueHooks$/;function dt(){ut&&(!1===C.hidden&&ie.requestAnimationFrame?ie.requestAnimationFrame(dt):ie.setTimeout(dt,ce.fx.interval),ce.fx.tick())}function ht(){return ie.setTimeout(function(){st=void 0}),st=Date.now()}function gt(e,t){var n,r=0,i={height:e};for(t=t?1:0;r<4;r+=2-t)i["margin"+(n=Q[r])]=i["padding"+n]=e;return t&&(i.opacity=i.width=e),i}function vt(e,t,n){for(var r,i=(yt.tweeners[t]||[]).concat(yt.tweeners["*"]),o=0,a=i.length;o<a;o++)if(r=i[o].call(n,t,e))return r}function yt(o,e,t){var n,a,r=0,i=yt.prefilters.length,s=ce.Deferred().always(function(){delete u.elem}),u=function(){if(a)return!1;for(var e=st||ht(),t=Math.max(0,l.startTime+l.duration-e),n=1-(t/l.duration||0),r=0,i=l.tweens.length;r<i;r++)l.tweens[r].run(n);return s.notifyWith(o,[l,n,t]),n<1&&i?t:(i||s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l]),!1)},l=s.promise({elem:o,props:ce.extend({},e),opts:ce.extend(!0,{specialEasing:{},easing:ce.easing._default},t),originalProperties:e,originalOptions:t,startTime:st||ht(),duration:t.duration,tweens:[],createTween:function(e,t){var n=ce.Tween(o,l.opts,e,t,l.opts.specialEasing[e]||l.opts.easing);return l.tweens.push(n),n},stop:function(e){var t=0,n=e?l.tweens.length:0;if(a)return this;for(a=!0;t<n;t++)l.tweens[t].run(1);return e?(s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l,e])):s.rejectWith(o,[l,e]),this}}),c=l.props;for(!function(e,t){var n,r,i,o,a;for(n in e)if(i=t[r=F(n)],o=e[n],Array.isArray(o)&&(i=o[1],o=e[n]=o[0]),n!==r&&(e[r]=o,delete e[n]),(a=ce.cssHooks[r])&&"expand"in a)for(n in o=a.expand(o),delete e[r],o)n in e||(e[n]=o[n],t[n]=i);else t[r]=i}(c,l.opts.specialEasing);r<i;r++)if(n=yt.prefilters[r].call(l,o,c,l.opts))return v(n.stop)&&(ce._queueHooks(l.elem,l.opts.queue).stop=n.stop.bind(n)),n;return ce.map(c,vt,l),v(l.opts.start)&&l.opts.start.call(o,l),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always),ce.fx.timer(ce.extend(u,{elem:o,anim:l,queue:l.opts.queue})),l}ce.Animation=ce.extend(yt,{tweeners:{"*":[function(e,t){var n=this.createTween(e,t);return te(n.elem,e,Y.exec(t),n),n}]},tweener:function(e,t){v(e)?(t=e,e=["*"]):e=e.match(D);for(var n,r=0,i=e.length;r<i;r++)n=e[r],yt.tweeners[n]=yt.tweeners[n]||[],yt.tweeners[n].unshift(t)},prefilters:[function(e,t,n){var r,i,o,a,s,u,l,c,f="width"in t||"height"in t,p=this,d={},h=e.style,g=e.nodeType&&ee(e),v=_.get(e,"fxshow");for(r in n.queue||(null==(a=ce._queueHooks(e,"fx")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s()}),a.unqueued++,p.always(function(){p.always(function(){a.unqueued--,ce.queue(e,"fx").length||a.empty.fire()})})),t)if(i=t[r],ft.test(i)){if(delete t[r],o=o||"toggle"===i,i===(g?"hide":"show")){if("show"!==i||!v||void 0===v[r])continue;g=!0}d[r]=v&&v[r]||ce.style(e,r)}if((u=!ce.isEmptyObject(t))||!ce.isEmptyObject(d))for(r in f&&1===e.nodeType&&(n.overflow=[h.overflow,h.overflowX,h.overflowY],null==(l=v&&v.display)&&(l=_.get(e,"display")),"none"===(c=ce.css(e,"display"))&&(l?c=l:(re([e],!0),l=e.style.display||l,c=ce.css(e,"display"),re([e]))),("inline"===c||"inline-block"===c&&null!=l)&&"none"===ce.css(e,"float")&&(u||(p.done(function(){h.display=l}),null==l&&(c=h.display,l="none"===c?"":c)),h.display="inline-block")),n.overflow&&(h.overflow="hidden",p.always(function(){h.overflow=n.overflow[0],h.overflowX=n.overflow[1],h.overflowY=n.overflow[2]})),u=!1,d)u||(v?"hidden"in v&&(g=v.hidden):v=_.access(e,"fxshow",{display:l}),o&&(v.hidden=!g),g&&re([e],!0),p.done(function(){for(r in g||re([e]),_.remove(e,"fxshow"),d)ce.style(e,r,d[r])})),u=vt(g?v[r]:0,r,p),r in v||(v[r]=u.start,g&&(u.end=u.start,u.start=0))}],prefilter:function(e,t){t?yt.prefilters.unshift(e):yt.prefilters.push(e)}}),ce.speed=function(e,t,n){var r=e&&"object"==typeof e?ce.extend({},e):{complete:n||!n&&t||v(e)&&e,duration:e,easing:n&&t||t&&!v(t)&&t};return ce.fx.off?r.duration=0:"number"!=typeof r.duration&&(r.duration in ce.fx.speeds?r.duration=ce.fx.speeds[r.duration]:r.duration=ce.fx.speeds._default),null!=r.queue&&!0!==r.queue||(r.queue="fx"),r.old=r.complete,r.complete=function(){v(r.old)&&r.old.call(this),r.queue&&ce.dequeue(this,r.queue)},r},ce.fn.extend({fadeTo:function(e,t,n,r){return this.filter(ee).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(t,e,n,r){var i=ce.isEmptyObject(t),o=ce.speed(e,n,r),a=function(){var e=yt(this,ce.extend({},t),o);(i||_.get(this,"finish"))&&e.stop(!0)};return a.finish=a,i||!1===o.queue?this.each(a):this.queue(o.queue,a)},stop:function(i,e,o){var a=function(e){var t=e.stop;delete e.stop,t(o)};return"string"!=typeof i&&(o=e,e=i,i=void 0),e&&this.queue(i||"fx",[]),this.each(function(){var e=!0,t=null!=i&&i+"queueHooks",n=ce.timers,r=_.get(this);if(t)r[t]&&r[t].stop&&a(r[t]);else for(t in r)r[t]&&r[t].stop&&pt.test(t)&&a(r[t]);for(t=n.length;t--;)n[t].elem!==this||null!=i&&n[t].queue!==i||(n[t].anim.stop(o),e=!1,n.splice(t,1));!e&&o||ce.dequeue(this,i)})},finish:function(a){return!1!==a&&(a=a||"fx"),this.each(function(){var e,t=_.get(this),n=t[a+"queue"],r=t[a+"queueHooks"],i=ce.timers,o=n?n.length:0;for(t.finish=!0,ce.queue(this,a,[]),r&&r.stop&&r.stop.call(this,!0),e=i.length;e--;)i[e].elem===this&&i[e].queue===a&&(i[e].anim.stop(!0),i.splice(e,1));for(e=0;e<o;e++)n[e]&&n[e].finish&&n[e].finish.call(this);delete t.finish})}}),ce.each(["toggle","show","hide"],function(e,r){var i=ce.fn[r];ce.fn[r]=function(e,t,n){return null==e||"boolean"==typeof e?i.apply(this,arguments):this.animate(gt(r,!0),e,t,n)}}),ce.each({slideDown:gt("show"),slideUp:gt("hide"),slideToggle:gt("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,r){ce.fn[e]=function(e,t,n){return this.animate(r,e,t,n)}}),ce.timers=[],ce.fx.tick=function(){var e,t=0,n=ce.timers;for(st=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||ce.fx.stop(),st=void 0},ce.fx.timer=function(e){ce.timers.push(e),ce.fx.start()},ce.fx.interval=13,ce.fx.start=function(){ut||(ut=!0,dt())},ce.fx.stop=function(){ut=null},ce.fx.speeds={slow:600,fast:200,_default:400},ce.fn.delay=function(r,e){return r=ce.fx&&ce.fx.speeds[r]||r,e=e||"fx",this.queue(e,function(e,t){var n=ie.setTimeout(e,r);t.stop=function(){ie.clearTimeout(n)}})},lt=C.createElement("input"),ct=C.createElement("select").appendChild(C.createElement("option")),lt.type="checkbox",le.checkOn=""!==lt.value,le.optSelected=ct.selected,(lt=C.createElement("input")).value="t",lt.type="radio",le.radioValue="t"===lt.value;var mt,xt=ce.expr.attrHandle;ce.fn.extend({attr:function(e,t){return M(this,ce.attr,e,t,1<arguments.length)},removeAttr:function(e){return this.each(function(){ce.removeAttr(this,e)})}}),ce.extend({attr:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return"undefined"==typeof e.getAttribute?ce.prop(e,t,n):(1===o&&ce.isXMLDoc(e)||(i=ce.attrHooks[t.toLowerCase()]||(ce.expr.match.bool.test(t)?mt:void 0)),void 0!==n?null===n?void ce.removeAttr(e,t):i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:(e.setAttribute(t,n+""),n):i&&"get"in i&&null!==(r=i.get(e,t))?r:null==(r=ce.find.attr(e,t))?void 0:r)},attrHooks:{type:{set:function(e,t){if(!le.radioValue&&"radio"===t&&fe(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,r=0,i=t&&t.match(D);if(i&&1===e.nodeType)while(n=i[r++])e.removeAttribute(n)}}),mt={set:function(e,t,n){return!1===t?ce.removeAttr(e,n):e.setAttribute(n,n),n}},ce.each(ce.expr.match.bool.source.match(/\w+/g),function(e,t){var a=xt[t]||ce.find.attr;xt[t]=function(e,t,n){var r,i,o=t.toLowerCase();return n||(i=xt[o],xt[o]=r,r=null!=a(e,t,n)?o:null,xt[o]=i),r}});var bt=/^(?:input|select|textarea|button)$/i,wt=/^(?:a|area)$/i;function Tt(e){return(e.match(D)||[]).join(" ")}function Ct(e){return e.getAttribute&&e.getAttribute("class")||""}function kt(e){return Array.isArray(e)?e:"string"==typeof e&&e.match(D)||[]}ce.fn.extend({prop:function(e,t){return M(this,ce.prop,e,t,1<arguments.length)},removeProp:function(e){return this.each(function(){delete this[ce.propFix[e]||e]})}}),ce.extend({prop:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&ce.isXMLDoc(e)||(t=ce.propFix[t]||t,i=ce.propHooks[t]),void 0!==n?i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:e[t]=n:i&&"get"in i&&null!==(r=i.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=ce.find.attr(e,"tabindex");return t?parseInt(t,10):bt.test(e.nodeName)||wt.test(e.nodeName)&&e.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),le.optSelected||(ce.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),ce.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){ce.propFix[this.toLowerCase()]=this}),ce.fn.extend({addClass:function(t){var e,n,r,i,o,a;return v(t)?this.each(function(e){ce(this).addClass(t.call(this,e,Ct(this)))}):(e=kt(t)).length?this.each(function(){if(r=Ct(this),n=1===this.nodeType&&" "+Tt(r)+" "){for(o=0;o<e.length;o++)i=e[o],n.indexOf(" "+i+" ")<0&&(n+=i+" ");a=Tt(n),r!==a&&this.setAttribute("class",a)}}):this},removeClass:function(t){var e,n,r,i,o,a;return v(t)?this.each(function(e){ce(this).removeClass(t.call(this,e,Ct(this)))}):arguments.length?(e=kt(t)).length?this.each(function(){if(r=Ct(this),n=1===this.nodeType&&" "+Tt(r)+" "){for(o=0;o<e.length;o++){i=e[o];while(-1<n.indexOf(" "+i+" "))n=n.replace(" "+i+" "," ")}a=Tt(n),r!==a&&this.setAttribute("class",a)}}):this:this.attr("class","")},toggleClass:function(t,n){var e,r,i,o,a=typeof t,s="string"===a||Array.isArray(t);return v(t)?this.each(function(e){ce(this).toggleClass(t.call(this,e,Ct(this),n),n)}):"boolean"==typeof n&&s?n?this.addClass(t):this.removeClass(t):(e=kt(t),this.each(function(){if(s)for(o=ce(this),i=0;i<e.length;i++)r=e[i],o.hasClass(r)?o.removeClass(r):o.addClass(r);else void 0!==t&&"boolean"!==a||((r=Ct(this))&&_.set(this,"__className__",r),this.setAttribute&&this.setAttribute("class",r||!1===t?"":_.get(this,"__className__")||""))}))},hasClass:function(e){var t,n,r=0;t=" "+e+" ";while(n=this[r++])if(1===n.nodeType&&-1<(" "+Tt(Ct(n))+" ").indexOf(t))return!0;return!1}});var St=/\r/g;ce.fn.extend({val:function(n){var r,e,i,t=this[0];return arguments.length?(i=v(n),this.each(function(e){var t;1===this.nodeType&&(null==(t=i?n.call(this,e,ce(this).val()):n)?t="":"number"==typeof t?t+="":Array.isArray(t)&&(t=ce.map(t,function(e){return null==e?"":e+""})),(r=ce.valHooks[this.type]||ce.valHooks[this.nodeName.toLowerCase()])&&"set"in r&&void 0!==r.set(this,t,"value")||(this.value=t))})):t?(r=ce.valHooks[t.type]||ce.valHooks[t.nodeName.toLowerCase()])&&"get"in r&&void 0!==(e=r.get(t,"value"))?e:"string"==typeof(e=t.value)?e.replace(St,""):null==e?"":e:void 0}}),ce.extend({valHooks:{option:{get:function(e){var t=ce.find.attr(e,"value");return null!=t?t:Tt(ce.text(e))}},select:{get:function(e){var t,n,r,i=e.options,o=e.selectedIndex,a="select-one"===e.type,s=a?null:[],u=a?o+1:i.length;for(r=o<0?u:a?o:0;r<u;r++)if(((n=i[r]).selected||r===o)&&!n.disabled&&(!n.parentNode.disabled||!fe(n.parentNode,"optgroup"))){if(t=ce(n).val(),a)return t;s.push(t)}return s},set:function(e,t){var n,r,i=e.options,o=ce.makeArray(t),a=i.length;while(a--)((r=i[a]).selected=-1<ce.inArray(ce.valHooks.option.get(r),o))&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),ce.each(["radio","checkbox"],function(){ce.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=-1<ce.inArray(ce(e).val(),t)}},le.checkOn||(ce.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})});var Et=ie.location,jt={guid:Date.now()},At=/\?/;ce.parseXML=function(e){var t,n;if(!e||"string"!=typeof e)return null;try{t=(new ie.DOMParser).parseFromString(e,"text/xml")}catch(e){}return n=t&&t.getElementsByTagName("parsererror")[0],t&&!n||ce.error("Invalid XML: "+(n?ce.map(n.childNodes,function(e){return e.textContent}).join("\n"):e)),t};var Dt=/^(?:focusinfocus|focusoutblur)$/,Nt=function(e){e.stopPropagation()};ce.extend(ce.event,{trigger:function(e,t,n,r){var i,o,a,s,u,l,c,f,p=[n||C],d=ue.call(e,"type")?e.type:e,h=ue.call(e,"namespace")?e.namespace.split("."):[];if(o=f=a=n=n||C,3!==n.nodeType&&8!==n.nodeType&&!Dt.test(d+ce.event.triggered)&&(-1<d.indexOf(".")&&(d=(h=d.split(".")).shift(),h.sort()),u=d.indexOf(":")<0&&"on"+d,(e=e[ce.expando]?e:new ce.Event(d,"object"==typeof e&&e)).isTrigger=r?2:3,e.namespace=h.join("."),e.rnamespace=e.namespace?new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,e.result=void 0,e.target||(e.target=n),t=null==t?[e]:ce.makeArray(t,[e]),c=ce.event.special[d]||{},r||!c.trigger||!1!==c.trigger.apply(n,t))){if(!r&&!c.noBubble&&!y(n)){for(s=c.delegateType||d,Dt.test(s+d)||(o=o.parentNode);o;o=o.parentNode)p.push(o),a=o;a===(n.ownerDocument||C)&&p.push(a.defaultView||a.parentWindow||ie)}i=0;while((o=p[i++])&&!e.isPropagationStopped())f=o,e.type=1<i?s:c.bindType||d,(l=(_.get(o,"events")||Object.create(null))[e.type]&&_.get(o,"handle"))&&l.apply(o,t),(l=u&&o[u])&&l.apply&&$(o)&&(e.result=l.apply(o,t),!1===e.result&&e.preventDefault());return e.type=d,r||e.isDefaultPrevented()||c._default&&!1!==c._default.apply(p.pop(),t)||!$(n)||u&&v(n[d])&&!y(n)&&((a=n[u])&&(n[u]=null),ce.event.triggered=d,e.isPropagationStopped()&&f.addEventListener(d,Nt),n[d](),e.isPropagationStopped()&&f.removeEventListener(d,Nt),ce.event.triggered=void 0,a&&(n[u]=a)),e.result}},simulate:function(e,t,n){var r=ce.extend(new ce.Event,n,{type:e,isSimulated:!0});ce.event.trigger(r,null,t)}}),ce.fn.extend({trigger:function(e,t){return this.each(function(){ce.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return ce.event.trigger(e,t,n,!0)}});var qt=/\[\]$/,Lt=/\r?\n/g,Ht=/^(?:submit|button|image|reset|file)$/i,Ot=/^(?:input|select|textarea|keygen)/i;function Pt(n,e,r,i){var t;if(Array.isArray(e))ce.each(e,function(e,t){r||qt.test(n)?i(n,t):Pt(n+"["+("object"==typeof t&&null!=t?e:"")+"]",t,r,i)});else if(r||"object"!==x(e))i(n,e);else for(t in e)Pt(n+"["+t+"]",e[t],r,i)}ce.param=function(e,t){var n,r=[],i=function(e,t){var n=v(t)?t():t;r[r.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(null==e)return"";if(Array.isArray(e)||e.jquery&&!ce.isPlainObject(e))ce.each(e,function(){i(this.name,this.value)});else for(n in e)Pt(n,e[n],t,i);return r.join("&")},ce.fn.extend({serialize:function(){return ce.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=ce.prop(this,"elements");return e?ce.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!ce(this).is(":disabled")&&Ot.test(this.nodeName)&&!Ht.test(e)&&(this.checked||!we.test(e))}).map(function(e,t){var n=ce(this).val();return null==n?null:Array.isArray(n)?ce.map(n,function(e){return{name:t.name,value:e.replace(Lt,"\r\n")}}):{name:t.name,value:n.replace(Lt,"\r\n")}}).get()}});var Mt=/%20/g,Rt=/#.*$/,It=/([?&])_=[^&]*/,Wt=/^(.*?):[ \t]*([^\r\n]*)$/gm,Ft=/^(?:GET|HEAD)$/,$t=/^\/\//,Bt={},_t={},zt="*/".concat("*"),Xt=C.createElement("a");function Ut(o){return function(e,t){"string"!=typeof e&&(t=e,e="*");var n,r=0,i=e.toLowerCase().match(D)||[];if(v(t))while(n=i[r++])"+"===n[0]?(n=n.slice(1)||"*",(o[n]=o[n]||[]).unshift(t)):(o[n]=o[n]||[]).push(t)}}function Vt(t,i,o,a){var s={},u=t===_t;function l(e){var r;return s[e]=!0,ce.each(t[e]||[],function(e,t){var n=t(i,o,a);return"string"!=typeof n||u||s[n]?u?!(r=n):void 0:(i.dataTypes.unshift(n),l(n),!1)}),r}return l(i.dataTypes[0])||!s["*"]&&l("*")}function Gt(e,t){var n,r,i=ce.ajaxSettings.flatOptions||{};for(n in t)void 0!==t[n]&&((i[n]?e:r||(r={}))[n]=t[n]);return r&&ce.extend(!0,e,r),e}Xt.href=Et.href,ce.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:Et.href,type:"GET",isLocal:/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Et.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":zt,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":ce.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?Gt(Gt(e,ce.ajaxSettings),t):Gt(ce.ajaxSettings,e)},ajaxPrefilter:Ut(Bt),ajaxTransport:Ut(_t),ajax:function(e,t){"object"==typeof e&&(t=e,e=void 0),t=t||{};var c,f,p,n,d,r,h,g,i,o,v=ce.ajaxSetup({},t),y=v.context||v,m=v.context&&(y.nodeType||y.jquery)?ce(y):ce.event,x=ce.Deferred(),b=ce.Callbacks("once memory"),w=v.statusCode||{},a={},s={},u="canceled",T={readyState:0,getResponseHeader:function(e){var t;if(h){if(!n){n={};while(t=Wt.exec(p))n[t[1].toLowerCase()+" "]=(n[t[1].toLowerCase()+" "]||[]).concat(t[2])}t=n[e.toLowerCase()+" "]}return null==t?null:t.join(", ")},getAllResponseHeaders:function(){return h?p:null},setRequestHeader:function(e,t){return null==h&&(e=s[e.toLowerCase()]=s[e.toLowerCase()]||e,a[e]=t),this},overrideMimeType:function(e){return null==h&&(v.mimeType=e),this},statusCode:function(e){var t;if(e)if(h)T.always(e[T.status]);else for(t in e)w[t]=[w[t],e[t]];return this},abort:function(e){var t=e||u;return c&&c.abort(t),l(0,t),this}};if(x.promise(T),v.url=((e||v.url||Et.href)+"").replace($t,Et.protocol+"//"),v.type=t.method||t.type||v.method||v.type,v.dataTypes=(v.dataType||"*").toLowerCase().match(D)||[""],null==v.crossDomain){r=C.createElement("a");try{r.href=v.url,r.href=r.href,v.crossDomain=Xt.protocol+"//"+Xt.host!=r.protocol+"//"+r.host}catch(e){v.crossDomain=!0}}if(v.data&&v.processData&&"string"!=typeof v.data&&(v.data=ce.param(v.data,v.traditional)),Vt(Bt,v,t,T),h)return T;for(i in(g=ce.event&&v.global)&&0==ce.active++&&ce.event.trigger("ajaxStart"),v.type=v.type.toUpperCase(),v.hasContent=!Ft.test(v.type),f=v.url.replace(Rt,""),v.hasContent?v.data&&v.processData&&0===(v.contentType||"").indexOf("application/x-www-form-urlencoded")&&(v.data=v.data.replace(Mt,"+")):(o=v.url.slice(f.length),v.data&&(v.processData||"string"==typeof v.data)&&(f+=(At.test(f)?"&":"?")+v.data,delete v.data),!1===v.cache&&(f=f.replace(It,"$1"),o=(At.test(f)?"&":"?")+"_="+jt.guid+++o),v.url=f+o),v.ifModified&&(ce.lastModified[f]&&T.setRequestHeader("If-Modified-Since",ce.lastModified[f]),ce.etag[f]&&T.setRequestHeader("If-None-Match",ce.etag[f])),(v.data&&v.hasContent&&!1!==v.contentType||t.contentType)&&T.setRequestHeader("Content-Type",v.contentType),T.setRequestHeader("Accept",v.dataTypes[0]&&v.accepts[v.dataTypes[0]]?v.accepts[v.dataTypes[0]]+("*"!==v.dataTypes[0]?", "+zt+"; q=0.01":""):v.accepts["*"]),v.headers)T.setRequestHeader(i,v.headers[i]);if(v.beforeSend&&(!1===v.beforeSend.call(y,T,v)||h))return T.abort();if(u="abort",b.add(v.complete),T.done(v.success),T.fail(v.error),c=Vt(_t,v,t,T)){if(T.readyState=1,g&&m.trigger("ajaxSend",[T,v]),h)return T;v.async&&0<v.timeout&&(d=ie.setTimeout(function(){T.abort("timeout")},v.timeout));try{h=!1,c.send(a,l)}catch(e){if(h)throw e;l(-1,e)}}else l(-1,"No Transport");function l(e,t,n,r){var i,o,a,s,u,l=t;h||(h=!0,d&&ie.clearTimeout(d),c=void 0,p=r||"",T.readyState=0<e?4:0,i=200<=e&&e<300||304===e,n&&(s=function(e,t,n){var r,i,o,a,s=e.contents,u=e.dataTypes;while("*"===u[0])u.shift(),void 0===r&&(r=e.mimeType||t.getResponseHeader("Content-Type"));if(r)for(i in s)if(s[i]&&s[i].test(r)){u.unshift(i);break}if(u[0]in n)o=u[0];else{for(i in n){if(!u[0]||e.converters[i+" "+u[0]]){o=i;break}a||(a=i)}o=o||a}if(o)return o!==u[0]&&u.unshift(o),n[o]}(v,T,n)),!i&&-1<ce.inArray("script",v.dataTypes)&&ce.inArray("json",v.dataTypes)<0&&(v.converters["text script"]=function(){}),s=function(e,t,n,r){var i,o,a,s,u,l={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)l[a.toLowerCase()]=e.converters[a];o=c.shift();while(o)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!u&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u=o,o=c.shift())if("*"===o)o=u;else if("*"!==u&&u!==o){if(!(a=l[u+" "+o]||l["* "+o]))for(i in l)if((s=i.split(" "))[1]===o&&(a=l[u+" "+s[0]]||l["* "+s[0]])){!0===a?a=l[i]:!0!==l[i]&&(o=s[0],c.unshift(s[1]));break}if(!0!==a)if(a&&e["throws"])t=a(t);else try{t=a(t)}catch(e){return{state:"parsererror",error:a?e:"No conversion from "+u+" to "+o}}}return{state:"success",data:t}}(v,s,T,i),i?(v.ifModified&&((u=T.getResponseHeader("Last-Modified"))&&(ce.lastModified[f]=u),(u=T.getResponseHeader("etag"))&&(ce.etag[f]=u)),204===e||"HEAD"===v.type?l="nocontent":304===e?l="notmodified":(l=s.state,o=s.data,i=!(a=s.error))):(a=l,!e&&l||(l="error",e<0&&(e=0))),T.status=e,T.statusText=(t||l)+"",i?x.resolveWith(y,[o,l,T]):x.rejectWith(y,[T,l,a]),T.statusCode(w),w=void 0,g&&m.trigger(i?"ajaxSuccess":"ajaxError",[T,v,i?o:a]),b.fireWith(y,[T,l]),g&&(m.trigger("ajaxComplete",[T,v]),--ce.active||ce.event.trigger("ajaxStop")))}return T},getJSON:function(e,t,n){return ce.get(e,t,n,"json")},getScript:function(e,t){return ce.get(e,void 0,t,"script")}}),ce.each(["get","post"],function(e,i){ce[i]=function(e,t,n,r){return v(t)&&(r=r||n,n=t,t=void 0),ce.ajax(ce.extend({url:e,type:i,dataType:r,data:t,success:n},ce.isPlainObject(e)&&e))}}),ce.ajaxPrefilter(function(e){var t;for(t in e.headers)"content-type"===t.toLowerCase()&&(e.contentType=e.headers[t]||"")}),ce._evalUrl=function(e,t,n){return ce.ajax({url:e,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,converters:{"text script":function(){}},dataFilter:function(e){ce.globalEval(e,t,n)}})},ce.fn.extend({wrapAll:function(e){var t;return this[0]&&(v(e)&&(e=e.call(this[0])),t=ce(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstElementChild)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(n){return v(n)?this.each(function(e){ce(this).wrapInner(n.call(this,e))}):this.each(function(){var e=ce(this),t=e.contents();t.length?t.wrapAll(n):e.append(n)})},wrap:function(t){var n=v(t);return this.each(function(e){ce(this).wrapAll(n?t.call(this,e):t)})},unwrap:function(e){return this.parent(e).not("body").each(function(){ce(this).replaceWith(this.childNodes)}),this}}),ce.expr.pseudos.hidden=function(e){return!ce.expr.pseudos.visible(e)},ce.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},ce.ajaxSettings.xhr=function(){try{return new ie.XMLHttpRequest}catch(e){}};var Yt={0:200,1223:204},Qt=ce.ajaxSettings.xhr();le.cors=!!Qt&&"withCredentials"in Qt,le.ajax=Qt=!!Qt,ce.ajaxTransport(function(i){var o,a;if(le.cors||Qt&&!i.crossDomain)return{send:function(e,t){var n,r=i.xhr();if(r.open(i.type,i.url,i.async,i.username,i.password),i.xhrFields)for(n in i.xhrFields)r[n]=i.xhrFields[n];for(n in i.mimeType&&r.overrideMimeType&&r.overrideMimeType(i.mimeType),i.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest"),e)r.setRequestHeader(n,e[n]);o=function(e){return function(){o&&(o=a=r.onload=r.onerror=r.onabort=r.ontimeout=r.onreadystatechange=null,"abort"===e?r.abort():"error"===e?"number"!=typeof r.status?t(0,"error"):t(r.status,r.statusText):t(Yt[r.status]||r.status,r.statusText,"text"!==(r.responseType||"text")||"string"!=typeof r.responseText?{binary:r.response}:{text:r.responseText},r.getAllResponseHeaders()))}},r.onload=o(),a=r.onerror=r.ontimeout=o("error"),void 0!==r.onabort?r.onabort=a:r.onreadystatechange=function(){4===r.readyState&&ie.setTimeout(function(){o&&a()})},o=o("abort");try{r.send(i.hasContent&&i.data||null)}catch(e){if(o)throw e}},abort:function(){o&&o()}}}),ce.ajaxPrefilter(function(e){e.crossDomain&&(e.contents.script=!1)}),ce.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(e){return ce.globalEval(e),e}}}),ce.ajaxPrefilter("script",function(e){void 0===e.cache&&(e.cache=!1),e.crossDomain&&(e.type="GET")}),ce.ajaxTransport("script",function(n){var r,i;if(n.crossDomain||n.scriptAttrs)return{send:function(e,t){r=ce("<script>").attr(n.scriptAttrs||{}).prop({charset:n.scriptCharset,src:n.url}).on("load error",i=function(e){r.remove(),i=null,e&&t("error"===e.type?404:200,e.type)}),C.head.appendChild(r[0])},abort:function(){i&&i()}}});var Jt,Kt=[],Zt=/(=)\?(?=&|$)|\?\?/;ce.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=Kt.pop()||ce.expando+"_"+jt.guid++;return this[e]=!0,e}}),ce.ajaxPrefilter("json jsonp",function(e,t,n){var r,i,o,a=!1!==e.jsonp&&(Zt.test(e.url)?"url":"string"==typeof e.data&&0===(e.contentType||"").indexOf("application/x-www-form-urlencoded")&&Zt.test(e.data)&&"data");if(a||"jsonp"===e.dataTypes[0])return r=e.jsonpCallback=v(e.jsonpCallback)?e.jsonpCallback():e.jsonpCallback,a?e[a]=e[a].replace(Zt,"$1"+r):!1!==e.jsonp&&(e.url+=(At.test(e.url)?"&":"?")+e.jsonp+"="+r),e.converters["script json"]=function(){return o||ce.error(r+" was not called"),o[0]},e.dataTypes[0]="json",i=ie[r],ie[r]=function(){o=arguments},n.always(function(){void 0===i?ce(ie).removeProp(r):ie[r]=i,e[r]&&(e.jsonpCallback=t.jsonpCallback,Kt.push(r)),o&&v(i)&&i(o[0]),o=i=void 0}),"script"}),le.createHTMLDocument=((Jt=C.implementation.createHTMLDocument("").body).innerHTML="<form></form><form></form>",2===Jt.childNodes.length),ce.parseHTML=function(e,t,n){return"string"!=typeof e?[]:("boolean"==typeof t&&(n=t,t=!1),t||(le.createHTMLDocument?((r=(t=C.implementation.createHTMLDocument("")).createElement("base")).href=C.location.href,t.head.appendChild(r)):t=C),o=!n&&[],(i=w.exec(e))?[t.createElement(i[1])]:(i=Ae([e],t,o),o&&o.length&&ce(o).remove(),ce.merge([],i.childNodes)));var r,i,o},ce.fn.load=function(e,t,n){var r,i,o,a=this,s=e.indexOf(" ");return-1<s&&(r=Tt(e.slice(s)),e=e.slice(0,s)),v(t)?(n=t,t=void 0):t&&"object"==typeof t&&(i="POST"),0<a.length&&ce.ajax({url:e,type:i||"GET",dataType:"html",data:t}).done(function(e){o=arguments,a.html(r?ce("<div>").append(ce.parseHTML(e)).find(r):e)}).always(n&&function(e,t){a.each(function(){n.apply(this,o||[e.responseText,t,e])})}),this},ce.expr.pseudos.animated=function(t){return ce.grep(ce.timers,function(e){return t===e.elem}).length},ce.offset={setOffset:function(e,t,n){var r,i,o,a,s,u,l=ce.css(e,"position"),c=ce(e),f={};"static"===l&&(e.style.position="relative"),s=c.offset(),o=ce.css(e,"top"),u=ce.css(e,"left"),("absolute"===l||"fixed"===l)&&-1<(o+u).indexOf("auto")?(a=(r=c.position()).top,i=r.left):(a=parseFloat(o)||0,i=parseFloat(u)||0),v(t)&&(t=t.call(e,n,ce.extend({},s))),null!=t.top&&(f.top=t.top-s.top+a),null!=t.left&&(f.left=t.left-s.left+i),"using"in t?t.using.call(e,f):c.css(f)}},ce.fn.extend({offset:function(t){if(arguments.length)return void 0===t?this:this.each(function(e){ce.offset.setOffset(this,t,e)});var e,n,r=this[0];return r?r.getClientRects().length?(e=r.getBoundingClientRect(),n=r.ownerDocument.defaultView,{top:e.top+n.pageYOffset,left:e.left+n.pageXOffset}):{top:0,left:0}:void 0},position:function(){if(this[0]){var e,t,n,r=this[0],i={top:0,left:0};if("fixed"===ce.css(r,"position"))t=r.getBoundingClientRect();else{t=this.offset(),n=r.ownerDocument,e=r.offsetParent||n.documentElement;while(e&&(e===n.body||e===n.documentElement)&&"static"===ce.css(e,"position"))e=e.parentNode;e&&e!==r&&1===e.nodeType&&((i=ce(e).offset()).top+=ce.css(e,"borderTopWidth",!0),i.left+=ce.css(e,"borderLeftWidth",!0))}return{top:t.top-i.top-ce.css(r,"marginTop",!0),left:t.left-i.left-ce.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent;while(e&&"static"===ce.css(e,"position"))e=e.offsetParent;return e||J})}}),ce.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(t,i){var o="pageYOffset"===i;ce.fn[t]=function(e){return M(this,function(e,t,n){var r;if(y(e)?r=e:9===e.nodeType&&(r=e.defaultView),void 0===n)return r?r[i]:e[t];r?r.scrollTo(o?r.pageXOffset:n,o?n:r.pageYOffset):e[t]=n},t,e,arguments.length)}}),ce.each(["top","left"],function(e,n){ce.cssHooks[n]=Ye(le.pixelPosition,function(e,t){if(t)return t=Ge(e,n),_e.test(t)?ce(e).position()[n]+"px":t})}),ce.each({Height:"height",Width:"width"},function(a,s){ce.each({padding:"inner"+a,content:s,"":"outer"+a},function(r,o){ce.fn[o]=function(e,t){var n=arguments.length&&(r||"boolean"!=typeof e),i=r||(!0===e||!0===t?"margin":"border");return M(this,function(e,t,n){var r;return y(e)?0===o.indexOf("outer")?e["inner"+a]:e.document.documentElement["client"+a]:9===e.nodeType?(r=e.documentElement,Math.max(e.body["scroll"+a],r["scroll"+a],e.body["offset"+a],r["offset"+a],r["client"+a])):void 0===n?ce.css(e,t,i):ce.style(e,t,n,i)},s,n?e:void 0,n)}})}),ce.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){ce.fn[t]=function(e){return this.on(t,e)}}),ce.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)},hover:function(e,t){return this.on("mouseenter",e).on("mouseleave",t||e)}}),ce.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(e,n){ce.fn[n]=function(e,t){return 0<arguments.length?this.on(n,null,e,t):this.trigger(n)}});var en=/^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;ce.proxy=function(e,t){var n,r,i;if("string"==typeof t&&(n=e[t],t=e,e=n),v(e))return r=ae.call(arguments,2),(i=function(){return e.apply(t||this,r.concat(ae.call(arguments)))}).guid=e.guid=e.guid||ce.guid++,i},ce.holdReady=function(e){e?ce.readyWait++:ce.ready(!0)},ce.isArray=Array.isArray,ce.parseJSON=JSON.parse,ce.nodeName=fe,ce.isFunction=v,ce.isWindow=y,ce.camelCase=F,ce.type=x,ce.now=Date.now,ce.isNumeric=function(e){var t=ce.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},ce.trim=function(e){return null==e?"":(e+"").replace(en,"$1")},"function"==typeof define&&define.amd&&define("jquery",[],function(){return ce});var tn=ie.jQuery,nn=ie.$;return ce.noConflict=function(e){return ie.$===ce&&(ie.$=nn),e&&ie.jQuery===ce&&(ie.jQuery=tn),ce},"undefined"==typeof e&&(ie.jQuery=ie.$=ce),ce});

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): util.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Util = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Private TransitionEnd Helpers
   * ------------------------------------------------------------------------
   */

  var transition = false;

  var MAX_UID = 1000000;

  var TransitionEndEvent = {
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'transitionend',
    OTransition: 'oTransitionEnd otransitionend',
    transition: 'transitionend'
  };

  // shoutout AngusCroll (https://goo.gl/pxwQGp)
  function toType(obj) {
    return {}.toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
  }

  function isElement(obj) {
    return (obj[0] || obj).nodeType;
  }

  function getSpecialTransitionEndEvent() {
    return {
      bindType: transition.end,
      delegateType: transition.end,
      handle: function handle(event) {
        if ($(event.target).is(this)) {
          return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
        }
        return undefined;
      }
    };
  }

  function transitionEndTest() {
    if (window.QUnit) {
      return false;
    }

    var el = document.createElement('bootstrap');

    for (var name in TransitionEndEvent) {
      if (el.style[name] !== undefined) {
        return {
          end: TransitionEndEvent[name]
        };
      }
    }

    return false;
  }

  function transitionEndEmulator(duration) {
    var _this = this;

    var called = false;

    $(this).one(Util.TRANSITION_END, function () {
      called = true;
    });

    setTimeout(function () {
      if (!called) {
        Util.triggerTransitionEnd(_this);
      }
    }, duration);

    return this;
  }

  function setTransitionEndSupport() {
    transition = transitionEndTest();

    $.fn.emulateTransitionEnd = transitionEndEmulator;

    if (Util.supportsTransitionEnd()) {
      $.event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
    }
  }

  /**
   * --------------------------------------------------------------------------
   * Public Util Api
   * --------------------------------------------------------------------------
   */

  var Util = {

    TRANSITION_END: 'bsTransitionEnd',

    getUID: function getUID(prefix) {
      do {
        // eslint-disable-next-line no-bitwise
        prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
      } while (document.getElementById(prefix));
      return prefix;
    },
    getSelectorFromElement: function getSelectorFromElement(element) {
      var selector = element.getAttribute('data-target');

      if (!selector) {
        selector = element.getAttribute('href') || '';
        selector = /^#[a-z]/i.test(selector) ? selector : null;
      }

      return selector;
    },
    reflow: function reflow(element) {
      return element.offsetHeight;
    },
    triggerTransitionEnd: function triggerTransitionEnd(element) {
      $(element).trigger(transition.end);
    },
    supportsTransitionEnd: function supportsTransitionEnd() {
      return Boolean(transition);
    },
    typeCheckConfig: function typeCheckConfig(componentName, config, configTypes) {
      for (var property in configTypes) {
        if (configTypes.hasOwnProperty(property)) {
          var expectedTypes = configTypes[property];
          var value = config[property];
          var valueType = value && isElement(value) ? 'element' : toType(value);

          if (!new RegExp(expectedTypes).test(valueType)) {
            throw new Error(componentName.toUpperCase() + ': ' + ('Option "' + property + '" provided type "' + valueType + '" ') + ('but expected type "' + expectedTypes + '".'));
          }
        }
      }
    }
  };

  setTransitionEndSupport();

  return Util;
}(jQuery);
//# sourceMappingURL=util.js.map

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Dropdown = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'dropdown';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.dropdown';
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key
  var ARROW_UP_KEYCODE = 38; // KeyboardEvent.which value for up arrow key
  var ARROW_DOWN_KEYCODE = 40; // KeyboardEvent.which value for down arrow key
  var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming a right-handed mouse)

  var Event = {
    HIDE: 'hide' + EVENT_KEY,
    HIDDEN: 'hidden' + EVENT_KEY,
    SHOW: 'show' + EVENT_KEY,
    SHOWN: 'shown' + EVENT_KEY,
    CLICK: 'click' + EVENT_KEY,
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY,
    FOCUSIN_DATA_API: 'focusin' + EVENT_KEY + DATA_API_KEY,
    KEYDOWN_DATA_API: 'keydown' + EVENT_KEY + DATA_API_KEY
  };

  var ClassName = {
    BACKDROP: 'dropdown-backdrop',
    DISABLED: 'disabled',
    SHOW: 'show'
  };

  var Selector = {
    BACKDROP: '.dropdown-backdrop',
    DATA_TOGGLE: '[data-toggle="dropdown"]',
    FORM_CHILD: '.dropdown form',
    ROLE_MENU: '[role="menu"]',
    ROLE_LISTBOX: '[role="listbox"]',
    NAVBAR_NAV: '.navbar-nav',
    VISIBLE_ITEMS: '[role="menu"] li:not(.disabled) a, ' + '[role="listbox"] li:not(.disabled) a'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  var Dropdown = function () {
    function Dropdown(element) {
      _classCallCheck(this, Dropdown);

      this._element = element;

      this._addEventListeners();
    }

    // getters

    // public

    Dropdown.prototype.toggle = function toggle() {
      if (this.disabled || $(this).hasClass(ClassName.DISABLED)) {
        return false;
      }

      var parent = Dropdown._getParentFromElement(this);
      var isActive = $(parent).hasClass(ClassName.SHOW);

      Dropdown._clearMenus();

      if (isActive) {
        return false;
      }

      if ('ontouchstart' in document.documentElement && !$(parent).closest(Selector.NAVBAR_NAV).length) {

        // if mobile we use a backdrop because click events don't delegate
        var dropdown = document.createElement('div');
        dropdown.className = ClassName.BACKDROP;
        $(dropdown).insertBefore(this);
        $(dropdown).on('click', Dropdown._clearMenus);
      }

      var relatedTarget = {
        relatedTarget: this
      };
      var showEvent = $.Event(Event.SHOW, relatedTarget);

      $(parent).trigger(showEvent);

      if (showEvent.isDefaultPrevented()) {
        return false;
      }

      this.focus();
      this.setAttribute('aria-expanded', true);

      $(parent).toggleClass(ClassName.SHOW);
      $(parent).trigger($.Event(Event.SHOWN, relatedTarget));

      return false;
    };

    Dropdown.prototype.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY);
      $(this._element).off(EVENT_KEY);
      this._element = null;
    };

    // private

    Dropdown.prototype._addEventListeners = function _addEventListeners() {
      $(this._element).on(Event.CLICK, this.toggle);
    };

    // static

    Dropdown._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        if (!data) {
          data = new Dropdown(this);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (data[config] === undefined) {
            throw new Error('No method named "' + config + '"');
          }
          data[config].call(this);
        }
      });
    };

    Dropdown._clearMenus = function _clearMenus(event) {
      if (event && event.which === RIGHT_MOUSE_BUTTON_WHICH) {
        return;
      }

      var backdrop = $(Selector.BACKDROP)[0];
      if (backdrop) {
        backdrop.parentNode.removeChild(backdrop);
      }

      var toggles = $.makeArray($(Selector.DATA_TOGGLE));

      for (var i = 0; i < toggles.length; i++) {
        var parent = Dropdown._getParentFromElement(toggles[i]);
        var relatedTarget = {
          relatedTarget: toggles[i]
        };

        if (!$(parent).hasClass(ClassName.SHOW)) {
          continue;
        }

        if (event && (event.type === 'click' && /input|textarea/i.test(event.target.tagName) || event.type === 'focusin') && $.contains(parent, event.target)) {
          continue;
        }

        var hideEvent = $.Event(Event.HIDE, relatedTarget);
        $(parent).trigger(hideEvent);
        if (hideEvent.isDefaultPrevented()) {
          continue;
        }

        toggles[i].setAttribute('aria-expanded', 'false');

        $(parent).removeClass(ClassName.SHOW).trigger($.Event(Event.HIDDEN, relatedTarget));
      }
    };

    Dropdown._getParentFromElement = function _getParentFromElement(element) {
      var parent = void 0;
      var selector = Util.getSelectorFromElement(element);

      if (selector) {
        parent = $(selector)[0];
      }

      return parent || element.parentNode;
    };

    Dropdown._dataApiKeydownHandler = function _dataApiKeydownHandler(event) {
      if (!/(38|40|27|32)/.test(event.which) || /input|textarea/i.test(event.target.tagName)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (this.disabled || $(this).hasClass(ClassName.DISABLED)) {
        return;
      }

      var parent = Dropdown._getParentFromElement(this);
      var isActive = $(parent).hasClass(ClassName.SHOW);

      if (!isActive && event.which !== ESCAPE_KEYCODE || isActive && event.which === ESCAPE_KEYCODE) {

        if (event.which === ESCAPE_KEYCODE) {
          var toggle = $(parent).find(Selector.DATA_TOGGLE)[0];
          $(toggle).trigger('focus');
        }

        $(this).trigger('click');
        return;
      }

      var items = $(parent).find(Selector.VISIBLE_ITEMS).get();

      if (!items.length) {
        return;
      }

      var index = items.indexOf(event.target);

      if (event.which === ARROW_UP_KEYCODE && index > 0) {
        // up
        index--;
      }

      if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) {
        // down
        index++;
      }

      if (index < 0) {
        index = 0;
      }

      items[index].focus();
    };

    _createClass(Dropdown, null, [{
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }]);

    return Dropdown;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(document).on(Event.KEYDOWN_DATA_API, Selector.DATA_TOGGLE, Dropdown._dataApiKeydownHandler).on(Event.KEYDOWN_DATA_API, Selector.ROLE_MENU, Dropdown._dataApiKeydownHandler).on(Event.KEYDOWN_DATA_API, Selector.ROLE_LISTBOX, Dropdown._dataApiKeydownHandler).on(Event.CLICK_DATA_API + ' ' + Event.FOCUSIN_DATA_API, Dropdown._clearMenus).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, Dropdown.prototype.toggle).on(Event.CLICK_DATA_API, Selector.FORM_CHILD, function (e) {
    e.stopPropagation();
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Dropdown._jQueryInterface;
  $.fn[NAME].Constructor = Dropdown;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Dropdown._jQueryInterface;
  };

  return Dropdown;
}(jQuery);
//# sourceMappingURL=dropdown.js.map

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Button = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'button';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.button';
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var ClassName = {
    ACTIVE: 'active',
    BUTTON: 'btn',
    FOCUS: 'focus'
  };

  var Selector = {
    DATA_TOGGLE_CARROT: '[data-toggle^="button"]',
    DATA_TOGGLE: '[data-toggle="buttons"]',
    INPUT: 'input',
    ACTIVE: '.active',
    BUTTON: '.btn'
  };

  var Event = {
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY,
    FOCUS_BLUR_DATA_API: 'focus' + EVENT_KEY + DATA_API_KEY + ' ' + ('blur' + EVENT_KEY + DATA_API_KEY)
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  var Button = function () {
    function Button(element) {
      _classCallCheck(this, Button);

      this._element = element;
    }

    // getters

    // public

    Button.prototype.toggle = function toggle() {
      var triggerChangeEvent = true;
      var rootElement = $(this._element).closest(Selector.DATA_TOGGLE)[0];

      if (rootElement) {
        var input = $(this._element).find(Selector.INPUT)[0];

        if (input) {
          if (input.type === 'radio') {
            if (input.checked && $(this._element).hasClass(ClassName.ACTIVE)) {
              triggerChangeEvent = false;
            } else {
              var activeElement = $(rootElement).find(Selector.ACTIVE)[0];

              if (activeElement) {
                $(activeElement).removeClass(ClassName.ACTIVE);
              }
            }
          }

          if (triggerChangeEvent) {
            input.checked = !$(this._element).hasClass(ClassName.ACTIVE);
            $(input).trigger('change');
          }

          input.focus();
        }
      }

      this._element.setAttribute('aria-pressed', !$(this._element).hasClass(ClassName.ACTIVE));

      if (triggerChangeEvent) {
        $(this._element).toggleClass(ClassName.ACTIVE);
      }
    };

    Button.prototype.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY);
      this._element = null;
    };

    // static

    Button._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        if (!data) {
          data = new Button(this);
          $(this).data(DATA_KEY, data);
        }

        if (config === 'toggle') {
          data[config]();
        }
      });
    };

    _createClass(Button, null, [{
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }]);

    return Button;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE_CARROT, function (event) {
    event.preventDefault();

    var button = event.target;

    if (!$(button).hasClass(ClassName.BUTTON)) {
      button = $(button).closest(Selector.BUTTON);
    }

    Button._jQueryInterface.call($(button), 'toggle');
  }).on(Event.FOCUS_BLUR_DATA_API, Selector.DATA_TOGGLE_CARROT, function (event) {
    var button = $(event.target).closest(Selector.BUTTON)[0];
    $(button).toggleClass(ClassName.FOCUS, /^focus(in)?$/.test(event.type));
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Button._jQueryInterface;
  $.fn[NAME].Constructor = Button;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Button._jQueryInterface;
  };

  return Button;
}(jQuery);
//# sourceMappingURL=button.js.map

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Modal = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'modal';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.modal';
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var TRANSITION_DURATION = 300;
  var BACKDROP_TRANSITION_DURATION = 150;
  var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key

  var Default = {
    backdrop: true,
    keyboard: true,
    focus: true,
    show: true
  };

  var DefaultType = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    focus: 'boolean',
    show: 'boolean'
  };

  var Event = {
    HIDE: 'hide' + EVENT_KEY,
    HIDDEN: 'hidden' + EVENT_KEY,
    SHOW: 'show' + EVENT_KEY,
    SHOWN: 'shown' + EVENT_KEY,
    FOCUSIN: 'focusin' + EVENT_KEY,
    RESIZE: 'resize' + EVENT_KEY,
    CLICK_DISMISS: 'click.dismiss' + EVENT_KEY,
    KEYDOWN_DISMISS: 'keydown.dismiss' + EVENT_KEY,
    MOUSEUP_DISMISS: 'mouseup.dismiss' + EVENT_KEY,
    MOUSEDOWN_DISMISS: 'mousedown.dismiss' + EVENT_KEY,
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
  };

  var ClassName = {
    SCROLLBAR_MEASURER: 'modal-scrollbar-measure',
    BACKDROP: 'modal-backdrop',
    OPEN: 'modal-open',
    FADE: 'fade',
    SHOW: 'show'
  };

  var Selector = {
    DIALOG: '.modal-dialog',
    DATA_TOGGLE: '[data-toggle="modal"]',
    DATA_DISMISS: '[data-dismiss="modal"]',
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  var Modal = function () {
    function Modal(element, config) {
      _classCallCheck(this, Modal);

      this._config = this._getConfig(config);
      this._element = element;
      this._dialog = $(element).find(Selector.DIALOG)[0];
      this._backdrop = null;
      this._isShown = false;
      this._isBodyOverflowing = false;
      this._ignoreBackdropClick = false;
      this._isTransitioning = false;
      this._originalBodyPadding = 0;
      this._scrollbarWidth = 0;
    }

    // getters

    // public

    Modal.prototype.toggle = function toggle(relatedTarget) {
      return this._isShown ? this.hide() : this.show(relatedTarget);
    };

    Modal.prototype.show = function show(relatedTarget) {
      var _this = this;

      if (this._isTransitioning) {
        throw new Error('Modal is transitioning');
      }

      if (Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE)) {
        this._isTransitioning = true;
      }
      var showEvent = $.Event(Event.SHOW, {
        relatedTarget: relatedTarget
      });

      $(this._element).trigger(showEvent);

      if (this._isShown || showEvent.isDefaultPrevented()) {
        return;
      }

      this._isShown = true;

      this._checkScrollbar();
      this._setScrollbar();

      $(document.body).addClass(ClassName.OPEN);

      this._setEscapeEvent();
      this._setResizeEvent();

      $(this._element).on(Event.CLICK_DISMISS, Selector.DATA_DISMISS, function (event) {
        return _this.hide(event);
      });

      $(this._dialog).on(Event.MOUSEDOWN_DISMISS, function () {
        $(_this._element).one(Event.MOUSEUP_DISMISS, function (event) {
          if ($(event.target).is(_this._element)) {
            _this._ignoreBackdropClick = true;
          }
        });
      });

      this._showBackdrop(function () {
        return _this._showElement(relatedTarget);
      });
    };

    Modal.prototype.hide = function hide(event) {
      var _this2 = this;

      if (event) {
        event.preventDefault();
      }

      if (this._isTransitioning) {
        throw new Error('Modal is transitioning');
      }

      var transition = Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE);
      if (transition) {
        this._isTransitioning = true;
      }

      var hideEvent = $.Event(Event.HIDE);
      $(this._element).trigger(hideEvent);

      if (!this._isShown || hideEvent.isDefaultPrevented()) {
        return;
      }

      this._isShown = false;

      this._setEscapeEvent();
      this._setResizeEvent();

      $(document).off(Event.FOCUSIN);

      $(this._element).removeClass(ClassName.SHOW);

      $(this._element).off(Event.CLICK_DISMISS);
      $(this._dialog).off(Event.MOUSEDOWN_DISMISS);

      if (transition) {
        $(this._element).one(Util.TRANSITION_END, function (event) {
          return _this2._hideModal(event);
        }).emulateTransitionEnd(TRANSITION_DURATION);
      } else {
        this._hideModal();
      }
    };

    Modal.prototype.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY);

      $(window, document, this._element, this._backdrop).off(EVENT_KEY);

      this._config = null;
      this._element = null;
      this._dialog = null;
      this._backdrop = null;
      this._isShown = null;
      this._isBodyOverflowing = null;
      this._ignoreBackdropClick = null;
      this._originalBodyPadding = null;
      this._scrollbarWidth = null;
    };

    // private

    Modal.prototype._getConfig = function _getConfig(config) {
      config = $.extend({}, Default, config);
      Util.typeCheckConfig(NAME, config, DefaultType);
      return config;
    };

    Modal.prototype._showElement = function _showElement(relatedTarget) {
      var _this3 = this;

      var transition = Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE);

      if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) {
        // don't move modals dom position
        document.body.appendChild(this._element);
      }

      this._element.style.display = 'block';
      this._element.removeAttribute('aria-hidden');
      this._element.scrollTop = 0;

      if (transition) {
        Util.reflow(this._element);
      }

      $(this._element).addClass(ClassName.SHOW);

      if (this._config.focus) {
        this._enforceFocus();
      }

      var shownEvent = $.Event(Event.SHOWN, {
        relatedTarget: relatedTarget
      });

      var transitionComplete = function transitionComplete() {
        if (_this3._config.focus) {
          _this3._element.focus();
        }
        _this3._isTransitioning = false;
        $(_this3._element).trigger(shownEvent);
      };

      if (transition) {
        $(this._dialog).one(Util.TRANSITION_END, transitionComplete).emulateTransitionEnd(TRANSITION_DURATION);
      } else {
        transitionComplete();
      }
    };

    Modal.prototype._enforceFocus = function _enforceFocus() {
      var _this4 = this;

      $(document).off(Event.FOCUSIN) // guard against infinite focus loop
      .on(Event.FOCUSIN, function (event) {
        if (document !== event.target && _this4._element !== event.target && !$(_this4._element).has(event.target).length) {
          _this4._element.focus();
        }
      });
    };

    Modal.prototype._setEscapeEvent = function _setEscapeEvent() {
      var _this5 = this;

      if (this._isShown && this._config.keyboard) {
        $(this._element).on(Event.KEYDOWN_DISMISS, function (event) {
          if (event.which === ESCAPE_KEYCODE) {
            _this5.hide();
          }
        });
      } else if (!this._isShown) {
        $(this._element).off(Event.KEYDOWN_DISMISS);
      }
    };

    Modal.prototype._setResizeEvent = function _setResizeEvent() {
      var _this6 = this;

      if (this._isShown) {
        $(window).on(Event.RESIZE, function (event) {
          return _this6._handleUpdate(event);
        });
      } else {
        $(window).off(Event.RESIZE);
      }
    };

    Modal.prototype._hideModal = function _hideModal() {
      var _this7 = this;

      this._element.style.display = 'none';
      this._element.setAttribute('aria-hidden', 'true');
      this._isTransitioning = false;
      this._showBackdrop(function () {
        $(document.body).removeClass(ClassName.OPEN);
        _this7._resetAdjustments();
        _this7._resetScrollbar();
        $(_this7._element).trigger(Event.HIDDEN);
      });
    };

    Modal.prototype._removeBackdrop = function _removeBackdrop() {
      if (this._backdrop) {
        $(this._backdrop).remove();
        this._backdrop = null;
      }
    };

    Modal.prototype._showBackdrop = function _showBackdrop(callback) {
      var _this8 = this;

      var animate = $(this._element).hasClass(ClassName.FADE) ? ClassName.FADE : '';

      if (this._isShown && this._config.backdrop) {
        var doAnimate = Util.supportsTransitionEnd() && animate;

        this._backdrop = document.createElement('div');
        this._backdrop.className = ClassName.BACKDROP;

        if (animate) {
          $(this._backdrop).addClass(animate);
        }

        $(this._backdrop).appendTo(document.body);

        $(this._element).on(Event.CLICK_DISMISS, function (event) {
          if (_this8._ignoreBackdropClick) {
            _this8._ignoreBackdropClick = false;
            return;
          }
          if (event.target !== event.currentTarget) {
            return;
          }
          if (_this8._config.backdrop === 'static') {
            _this8._element.focus();
          } else {
            _this8.hide();
          }
        });

        if (doAnimate) {
          Util.reflow(this._backdrop);
        }

        $(this._backdrop).addClass(ClassName.SHOW);

        if (!callback) {
          return;
        }

        if (!doAnimate) {
          callback();
          return;
        }

        $(this._backdrop).one(Util.TRANSITION_END, callback).emulateTransitionEnd(BACKDROP_TRANSITION_DURATION);
      } else if (!this._isShown && this._backdrop) {
        $(this._backdrop).removeClass(ClassName.SHOW);

        var callbackRemove = function callbackRemove() {
          _this8._removeBackdrop();
          if (callback) {
            callback();
          }
        };

        if (Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE)) {
          $(this._backdrop).one(Util.TRANSITION_END, callbackRemove).emulateTransitionEnd(BACKDROP_TRANSITION_DURATION);
        } else {
          callbackRemove();
        }
      } else if (callback) {
        callback();
      }
    };

    // ----------------------------------------------------------------------
    // the following methods are used to handle overflowing modals
    // todo (fat): these should probably be refactored out of modal.js
    // ----------------------------------------------------------------------

    Modal.prototype._handleUpdate = function _handleUpdate() {
      this._adjustDialog();
    };

    Modal.prototype._adjustDialog = function _adjustDialog() {
      var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;

      if (!this._isBodyOverflowing && isModalOverflowing) {
        this._element.style.paddingLeft = this._scrollbarWidth + 'px';
      }

      if (this._isBodyOverflowing && !isModalOverflowing) {
        this._element.style.paddingRight = this._scrollbarWidth + 'px';
      }
    };

    Modal.prototype._resetAdjustments = function _resetAdjustments() {
      this._element.style.paddingLeft = '';
      this._element.style.paddingRight = '';
    };

    Modal.prototype._checkScrollbar = function _checkScrollbar() {
      this._isBodyOverflowing = document.body.clientWidth < window.innerWidth;
      this._scrollbarWidth = this._getScrollbarWidth();
    };

    Modal.prototype._setScrollbar = function _setScrollbar() {
      var bodyPadding = parseInt($(Selector.FIXED_CONTENT).css('padding-right') || 0, 10);

      this._originalBodyPadding = document.body.style.paddingRight || '';

      if (this._isBodyOverflowing) {
        document.body.style.paddingRight = bodyPadding + this._scrollbarWidth + 'px';
      }
    };

    Modal.prototype._resetScrollbar = function _resetScrollbar() {
      document.body.style.paddingRight = this._originalBodyPadding;
    };

    Modal.prototype._getScrollbarWidth = function _getScrollbarWidth() {
      // thx d.walsh
      var scrollDiv = document.createElement('div');
      scrollDiv.className = ClassName.SCROLLBAR_MEASURER;
      document.body.appendChild(scrollDiv);
      var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
      return scrollbarWidth;
    };

    // static

    Modal._jQueryInterface = function _jQueryInterface(config, relatedTarget) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);
        var _config = $.extend({}, Modal.Default, $(this).data(), (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config);

        if (!data) {
          data = new Modal(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (data[config] === undefined) {
            throw new Error('No method named "' + config + '"');
          }
          data[config](relatedTarget);
        } else if (_config.show) {
          data.show(relatedTarget);
        }
      });
    };

    _createClass(Modal, null, [{
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }, {
      key: 'Default',
      get: function get() {
        return Default;
      }
    }]);

    return Modal;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
    var _this9 = this;

    var target = void 0;
    var selector = Util.getSelectorFromElement(this);

    if (selector) {
      target = $(selector)[0];
    }

    var config = $(target).data(DATA_KEY) ? 'toggle' : $.extend({}, $(target).data(), $(this).data());

    if (this.tagName === 'A' || this.tagName === 'AREA') {
      event.preventDefault();
    }

    var $target = $(target).one(Event.SHOW, function (showEvent) {
      if (showEvent.isDefaultPrevented()) {
        // only register focus restorer if modal will actually get shown
        return;
      }

      $target.one(Event.HIDDEN, function () {
        if ($(_this9).is(':visible')) {
          _this9.focus();
        }
      });
    });

    Modal._jQueryInterface.call($(target), config, this);
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Modal._jQueryInterface;
  $.fn[NAME].Constructor = Modal;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Modal._jQueryInterface;
  };

  return Modal;
}(jQuery);
//# sourceMappingURL=modal.js.map

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Collapse = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'collapse';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.collapse';
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var TRANSITION_DURATION = 600;

  var Default = {
    toggle: true,
    parent: ''
  };

  var DefaultType = {
    toggle: 'boolean',
    parent: 'string'
  };

  var Event = {
    SHOW: 'show' + EVENT_KEY,
    SHOWN: 'shown' + EVENT_KEY,
    HIDE: 'hide' + EVENT_KEY,
    HIDDEN: 'hidden' + EVENT_KEY,
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
  };

  var ClassName = {
    SHOW: 'show',
    COLLAPSE: 'collapse',
    COLLAPSING: 'collapsing',
    COLLAPSED: 'collapsed'
  };

  var Dimension = {
    WIDTH: 'width',
    HEIGHT: 'height'
  };

  var Selector = {
    ACTIVES: '.card > .show, .card > .collapsing',
    DATA_TOGGLE: '[data-toggle="collapse"]'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  var Collapse = function () {
    function Collapse(element, config) {
      _classCallCheck(this, Collapse);

      this._isTransitioning = false;
      this._element = element;
      this._config = this._getConfig(config);
      this._triggerArray = $.makeArray($('[data-toggle="collapse"][href="#' + element.id + '"],' + ('[data-toggle="collapse"][data-target="#' + element.id + '"]')));

      this._parent = this._config.parent ? this._getParent() : null;

      if (!this._config.parent) {
        this._addAriaAndCollapsedClass(this._element, this._triggerArray);
      }

      if (this._config.toggle) {
        this.toggle();
      }
    }

    // getters

    // public

    Collapse.prototype.toggle = function toggle() {
      if ($(this._element).hasClass(ClassName.SHOW)) {
        this.hide();
      } else {
        this.show();
      }
    };

    Collapse.prototype.show = function show() {
      var _this = this;

      if (this._isTransitioning) {
        throw new Error('Collapse is transitioning');
      }

      if ($(this._element).hasClass(ClassName.SHOW)) {
        return;
      }

      var actives = void 0;
      var activesData = void 0;

      if (this._parent) {
        actives = $.makeArray($(this._parent).find(Selector.ACTIVES));
        if (!actives.length) {
          actives = null;
        }
      }

      if (actives) {
        activesData = $(actives).data(DATA_KEY);
        if (activesData && activesData._isTransitioning) {
          return;
        }
      }

      var startEvent = $.Event(Event.SHOW);
      $(this._element).trigger(startEvent);
      if (startEvent.isDefaultPrevented()) {
        return;
      }

      if (actives) {
        Collapse._jQueryInterface.call($(actives), 'hide');
        if (!activesData) {
          $(actives).data(DATA_KEY, null);
        }
      }

      var dimension = this._getDimension();

      $(this._element).removeClass(ClassName.COLLAPSE).addClass(ClassName.COLLAPSING);

      this._element.style[dimension] = 0;
      this._element.setAttribute('aria-expanded', true);

      if (this._triggerArray.length) {
        $(this._triggerArray).removeClass(ClassName.COLLAPSED).attr('aria-expanded', true);
      }

      this.setTransitioning(true);

      var complete = function complete() {
        $(_this._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).addClass(ClassName.SHOW);

        _this._element.style[dimension] = '';

        _this.setTransitioning(false);

        $(_this._element).trigger(Event.SHOWN);
      };

      if (!Util.supportsTransitionEnd()) {
        complete();
        return;
      }

      var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
      var scrollSize = 'scroll' + capitalizedDimension;

      $(this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);

      this._element.style[dimension] = this._element[scrollSize] + 'px';
    };

    Collapse.prototype.hide = function hide() {
      var _this2 = this;

      if (this._isTransitioning) {
        throw new Error('Collapse is transitioning');
      }

      if (!$(this._element).hasClass(ClassName.SHOW)) {
        return;
      }

      var startEvent = $.Event(Event.HIDE);
      $(this._element).trigger(startEvent);
      if (startEvent.isDefaultPrevented()) {
        return;
      }

      var dimension = this._getDimension();
      var offsetDimension = dimension === Dimension.WIDTH ? 'offsetWidth' : 'offsetHeight';

      this._element.style[dimension] = this._element[offsetDimension] + 'px';

      Util.reflow(this._element);

      $(this._element).addClass(ClassName.COLLAPSING).removeClass(ClassName.COLLAPSE).removeClass(ClassName.SHOW);

      this._element.setAttribute('aria-expanded', false);

      if (this._triggerArray.length) {
        $(this._triggerArray).addClass(ClassName.COLLAPSED).attr('aria-expanded', false);
      }

      this.setTransitioning(true);

      var complete = function complete() {
        _this2.setTransitioning(false);
        $(_this2._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).trigger(Event.HIDDEN);
      };

      this._element.style[dimension] = '';

      if (!Util.supportsTransitionEnd()) {
        complete();
        return;
      }

      $(this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
    };

    Collapse.prototype.setTransitioning = function setTransitioning(isTransitioning) {
      this._isTransitioning = isTransitioning;
    };

    Collapse.prototype.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY);

      this._config = null;
      this._parent = null;
      this._element = null;
      this._triggerArray = null;
      this._isTransitioning = null;
    };

    // private

    Collapse.prototype._getConfig = function _getConfig(config) {
      config = $.extend({}, Default, config);
      config.toggle = Boolean(config.toggle); // coerce string values
      Util.typeCheckConfig(NAME, config, DefaultType);
      return config;
    };

    Collapse.prototype._getDimension = function _getDimension() {
      var hasWidth = $(this._element).hasClass(Dimension.WIDTH);
      return hasWidth ? Dimension.WIDTH : Dimension.HEIGHT;
    };

    Collapse.prototype._getParent = function _getParent() {
      var _this3 = this;

      var parent = $(this._config.parent)[0];
      var selector = '[data-toggle="collapse"][data-parent="' + this._config.parent + '"]';

      $(parent).find(selector).each(function (i, element) {
        _this3._addAriaAndCollapsedClass(Collapse._getTargetFromElement(element), [element]);
      });

      return parent;
    };

    Collapse.prototype._addAriaAndCollapsedClass = function _addAriaAndCollapsedClass(element, triggerArray) {
      if (element) {
        var isOpen = $(element).hasClass(ClassName.SHOW);
        element.setAttribute('aria-expanded', isOpen);

        if (triggerArray.length) {
          $(triggerArray).toggleClass(ClassName.COLLAPSED, !isOpen).attr('aria-expanded', isOpen);
        }
      }
    };

    // static

    Collapse._getTargetFromElement = function _getTargetFromElement(element) {
      var selector = Util.getSelectorFromElement(element);
      return selector ? $(selector)[0] : null;
    };

    Collapse._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $this = $(this);
        var data = $this.data(DATA_KEY);
        var _config = $.extend({}, Default, $this.data(), (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config);

        if (!data && _config.toggle && /show|hide/.test(config)) {
          _config.toggle = false;
        }

        if (!data) {
          data = new Collapse(this, _config);
          $this.data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (data[config] === undefined) {
            throw new Error('No method named "' + config + '"');
          }
          data[config]();
        }
      });
    };

    _createClass(Collapse, null, [{
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }, {
      key: 'Default',
      get: function get() {
        return Default;
      }
    }]);

    return Collapse;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
    event.preventDefault();

    var target = Collapse._getTargetFromElement(this);
    var data = $(target).data(DATA_KEY);
    var config = data ? 'toggle' : $(this).data();

    Collapse._jQueryInterface.call($(target), config);
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Collapse._jQueryInterface;
  $.fn[NAME].Constructor = Collapse;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Collapse._jQueryInterface;
  };

  return Collapse;
}(jQuery);
//# sourceMappingURL=collapse.js.map


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



/*! flatpickr v2.4.2, @license MIT */

function Flatpickr(element, config) {

	var self = this;



	self.changeMonth = changeMonth;

	self.changeYear = changeYear;

	self.clear = clear;

	self.close = close;

	self._createElement = createElement;

	self.destroy = destroy;

	self.formatDate = formatDate;

	self.isEnabled = isEnabled;

	self.jumpToDate = jumpToDate;

	self.open = open;

	self.redraw = redraw;

	self.set = set;

	self.setDate = setDate;

	self.toggle = toggle;



	function init() {

		if (element._flatpickr) destroy(element._flatpickr);



		element._flatpickr = self;



		self.element = element;

		self.instanceConfig = config || {};

		self.parseDate = Flatpickr.prototype.parseDate.bind(self);



		setupFormats();



		parseConfig();

		setupLocale();

		setupInputs();

		setupDates();

		setupHelperFunctions();



		self.isOpen = self.config.inline;



		self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable.length && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);



		if (!self.isMobile) build();



		bind();



		if (!self.isMobile) {

			Object.defineProperty(self, "dateIsPicked", {

				set: function set(bool) {

					toggleClass(self.calendarContainer, "dateIsPicked", bool);

				}

			});

		}



		self.dateIsPicked = self.selectedDates.length > 0 || self.config.noCalendar;



		if (self.selectedDates.length) {

			if (self.config.enableTime) setHoursFromDate();

			updateValue();

		}



		if (self.config.weekNumbers) {

			self.calendarContainer.style.width = self.days.clientWidth + self.weekWrapper.clientWidth + "px";

		}



		triggerEvent("Ready");

	}



	function updateTime(e) {

		if (self.config.noCalendar && !self.selectedDates.length)

			// picking time only

			self.selectedDates = [self.now];



		timeWrapper(e);



		if (!self.selectedDates.length) return;



		if (!self.minDateHasTime || e.type !== "input" || e.target.value.length >= 2) {

			setHoursFromInputs();

			updateValue();

		} else {

			setTimeout(function () {

				setHoursFromInputs();

				updateValue();

			}, 1000);

		}

	}



	function setHoursFromInputs() {

		if (!self.config.enableTime) return;



		var hours = parseInt(self.hourElement.value, 10) || 0,

		    minutes = parseInt(self.minuteElement.value, 10) || 0,

		    seconds = self.config.enableSeconds ? parseInt(self.secondElement.value, 10) || 0 : 0;



		if (self.amPM) hours = hours % 12 + 12 * (self.amPM.textContent === "PM");



		if (self.minDateHasTime && compareDates(self.latestSelectedDateObj, self.config.minDate) === 0) {



			hours = Math.max(hours, self.config.minDate.getHours());

			if (hours === self.config.minDate.getHours()) minutes = Math.max(minutes, self.config.minDate.getMinutes());

		}



		if (self.maxDateHasTime && compareDates(self.latestSelectedDateObj, self.config.maxDate) === 0) {

			hours = Math.min(hours, self.config.maxDate.getHours());

			if (hours === self.config.maxDate.getHours()) minutes = Math.min(minutes, self.config.maxDate.getMinutes());

		}



		setHours(hours, minutes, seconds);

	}



	function setHoursFromDate(dateObj) {

		var date = dateObj || self.latestSelectedDateObj;



		if (date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());

	}



	function setHours(hours, minutes, seconds) {

		if (self.selectedDates.length) {

			self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);

		}



		if (!self.config.enableTime || self.isMobile) return;



		self.hourElement.value = self.pad(!self.config.time_24hr ? (12 + hours) % 12 + 12 * (hours % 12 === 0) : hours);



		self.minuteElement.value = self.pad(minutes);



		if (!self.config.time_24hr && self.selectedDates.length) self.amPM.textContent = self.latestSelectedDateObj.getHours() >= 12 ? "PM" : "AM";



		if (self.config.enableSeconds) self.secondElement.value = self.pad(seconds);

	}



	function onYearInput(event) {

		var year = event.target.value;

		if (year.length === 4) {

			self.currentYearElement.blur();

			if (!/[^\d]/.test(year)) changeYear(year);

		}

	}



	function onMonthScroll(e) {

		e.preventDefault();

		self.changeMonth(Math.max(-1, Math.min(1, e.wheelDelta || -e.deltaY)));

	}



	function bind() {

		if (self.config.wrap) {

			["open", "close", "toggle", "clear"].forEach(function (el) {

				var toggles = self.element.querySelectorAll("[data-" + el + "]");

				for (var i = 0; i < toggles.length; i++) {

					toggles[i].addEventListener("click", self[el]);

				}

			});

		}



		if (window.document.createEvent !== undefined) {

			self.changeEvent = window.document.createEvent("HTMLEvents");

			self.changeEvent.initEvent("change", false, true);

		}



		if (self.isMobile) return setupMobile();



		self.debouncedResize = debounce(onResize, 50);

		self.triggerChange = function () {

			triggerEvent("Change");

		};

		self.debouncedChange = debounce(self.triggerChange, 300);



		if (self.config.mode === "range" && self.days) self.days.addEventListener("mouseover", onMouseOver);



		window.document.addEventListener("keydown", onKeyDown);



		if (!self.config.inline && !self.config.static) window.addEventListener("resize", self.debouncedResize);



		if (window.ontouchstart) window.document.addEventListener("touchstart", documentClick);



		window.document.addEventListener("click", documentClick);

		window.document.addEventListener("blur", documentClick);



		if (self.config.clickOpens) (self.altInput || self.input).addEventListener("focus", open);



		if (!self.config.noCalendar) {

			self.prevMonthNav.addEventListener("click", function () {

				return changeMonth(-1);

			});

			self.nextMonthNav.addEventListener("click", function () {

				return changeMonth(1);

			});



			self.currentMonthElement.addEventListener("wheel", function (e) {

				return debounce(onMonthScroll(e), 50);

			});

			self.currentYearElement.addEventListener("wheel", function (e) {

				return debounce(yearScroll(e), 50);

			});

			self.currentYearElement.addEventListener("focus", function () {

				self.currentYearElement.select();

			});



			self.currentYearElement.addEventListener("input", onYearInput);

			self.currentYearElement.addEventListener("increment", onYearInput);



			self.days.addEventListener("click", selectDate);

		}



		if (self.config.enableTime) {

			self.timeContainer.addEventListener("transitionend", positionCalendar);

			self.timeContainer.addEventListener("wheel", function (e) {

				return debounce(updateTime(e), 5);

			});

			self.timeContainer.addEventListener("input", updateTime);

			self.timeContainer.addEventListener("increment", updateTime);

			self.timeContainer.addEventListener("increment", self.debouncedChange);



			self.timeContainer.addEventListener("wheel", self.debouncedChange);

			self.timeContainer.addEventListener("input", self.triggerChange);



			self.hourElement.addEventListener("focus", function () {

				self.hourElement.select();

			});

			self.minuteElement.addEventListener("focus", function () {

				self.minuteElement.select();

			});



			if (self.secondElement) {

				self.secondElement.addEventListener("focus", function () {

					self.secondElement.select();

				});

			}



			if (self.amPM) {

				self.amPM.addEventListener("click", function (e) {

					updateTime(e);

					self.triggerChange(e);

				});

			}

		}

	}



	function jumpToDate(jumpDate) {

		jumpDate = jumpDate ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);



		try {

			self.currentYear = jumpDate.getFullYear();

			self.currentMonth = jumpDate.getMonth();

		} catch (e) {

			/* istanbul ignore next */

			console.error(e.stack);

			/* istanbul ignore next */

			console.warn("Invalid date supplied: " + jumpDate);

		}



		self.redraw();

	}



	function incrementNumInput(e, delta) {

		var input = e.target.parentNode.childNodes[0];

		input.value = parseInt(input.value, 10) + delta * (input.step || 1);



		try {

			input.dispatchEvent(new Event("increment", { "bubbles": true }));

		} catch (e) {

			var ev = window.document.createEvent("CustomEvent");

			ev.initCustomEvent("increment", true, true, {});

			input.dispatchEvent(ev);

		}

	}



	function createNumberInput(inputClassName) {

		var wrapper = createElement("div", "numInputWrapper"),

		    numInput = createElement("input", "numInput " + inputClassName),

		    arrowUp = createElement("span", "arrowUp"),

		    arrowDown = createElement("span", "arrowDown");



		numInput.type = "text";

		numInput.pattern = "\\d*";

		wrapper.appendChild(numInput);

		wrapper.appendChild(arrowUp);

		wrapper.appendChild(arrowDown);



		arrowUp.addEventListener("click", function (e) {

			return incrementNumInput(e, 1);

		});

		arrowDown.addEventListener("click", function (e) {

			return incrementNumInput(e, -1);

		});

		return wrapper;

	}



	function build() {

		var fragment = window.document.createDocumentFragment();

		self.calendarContainer = createElement("div", "flatpickr-calendar");

		self.numInputType = navigator.userAgent.indexOf("MSIE 9.0") > 0 ? "text" : "number";



		if (!self.config.noCalendar) {

			fragment.appendChild(buildMonthNav());

			self.innerContainer = createElement("div", "flatpickr-innerContainer");



			if (self.config.weekNumbers) self.innerContainer.appendChild(buildWeeks());



			self.rContainer = createElement("div", "flatpickr-rContainer");

			self.rContainer.appendChild(buildWeekdays());



			if (!self.days) {

				self.days = createElement("div", "flatpickr-days");

				self.days.tabIndex = -1;

			}



			buildDays();

			self.rContainer.appendChild(self.days);



			self.innerContainer.appendChild(self.rContainer);

			fragment.appendChild(self.innerContainer);

		}



		if (self.config.enableTime) fragment.appendChild(buildTime());



		if (self.config.mode === "range") self.calendarContainer.classList.add("rangeMode");



		self.calendarContainer.appendChild(fragment);



		var customAppend = self.config.appendTo && self.config.appendTo.nodeType;



		if (self.config.inline || self.config.static) {

			self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");

			positionCalendar();



			if (self.config.inline && !customAppend) {

				return self.element.parentNode.insertBefore(self.calendarContainer, (self.altInput || self.input).nextSibling);

			}



			if (self.config.static) {

				var wrapper = createElement("div", "flatpickr-wrapper");

				self.element.parentNode.insertBefore(wrapper, self.element);

				wrapper.appendChild(self.element);

				wrapper.appendChild(self.calendarContainer);

				return;

			}

		}



		(customAppend ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);

	}



	function createDay(className, date, dayNumber) {

		var dateIsEnabled = isEnabled(date, true),

		    dayElement = createElement("span", "flatpickr-day " + className, date.getDate());



		dayElement.dateObj = date;



		toggleClass(dayElement, "today", compareDates(date, self.now) === 0);



		if (dateIsEnabled) {

			dayElement.tabIndex = 0;



			if (isDateSelected(date)) {

				dayElement.classList.add("selected");

				self.selectedDateElem = dayElement;

				if (self.config.mode === "range") {

					toggleClass(dayElement, "startRange", compareDates(date, self.selectedDates[0]) === 0);



					toggleClass(dayElement, "endRange", compareDates(date, self.selectedDates[1]) === 0);

				}

			}

		} else {

			dayElement.classList.add("disabled");

			if (self.selectedDates[0] && date > self.minRangeDate && date < self.selectedDates[0]) self.minRangeDate = date;else if (self.selectedDates[0] && date < self.maxRangeDate && date > self.selectedDates[0]) self.maxRangeDate = date;

		}



		if (self.config.mode === "range") {

			if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");



			if (self.selectedDates.length === 1 && (date < self.minRangeDate || date > self.maxRangeDate)) dayElement.classList.add("notAllowed");

		}



		if (self.config.weekNumbers && className !== "prevMonthDay" && dayNumber % 7 === 1) {

			self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='disabled flatpickr-day'>" + self.config.getWeek(date) + "</span>");

		}



		triggerEvent("DayCreate", dayElement);



		return dayElement;

	}



	function buildDays(year, month) {

		var firstOfMonth = (new Date(self.currentYear, self.currentMonth, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7,

		    isRangeMode = self.config.mode === "range";



		self.prevMonthDays = self.utils.getDaysinMonth((self.currentMonth - 1 + 12) % 12);



		var daysInMonth = self.utils.getDaysinMonth(),

		    days = window.document.createDocumentFragment();



		var dayNumber = self.prevMonthDays + 1 - firstOfMonth;



		if (self.config.weekNumbers && self.weekNumbers.firstChild) self.weekNumbers.textContent = "";



		if (isRangeMode) {

			// const dateLimits = self.config.enable.length || self.config.disable.length || self.config.mixDate || self.config.maxDate;

			self.minRangeDate = new Date(self.currentYear, self.currentMonth - 1, dayNumber);

			self.maxRangeDate = new Date(self.currentYear, self.currentMonth + 1, (42 - firstOfMonth) % daysInMonth);

		}



		if (self.days.firstChild) self.days.textContent = "";



		// prepend days from the ending of previous month

		for (var i = 0; dayNumber <= self.prevMonthDays; i++, dayNumber++) {

			days.appendChild(createDay("prevMonthDay", new Date(self.currentYear, self.currentMonth - 1, dayNumber), dayNumber));

		}



		// Start at 1 since there is no 0th day

		for (dayNumber = 1; dayNumber <= daysInMonth; dayNumber++) {

			days.appendChild(createDay("", new Date(self.currentYear, self.currentMonth, dayNumber), dayNumber));

		}



		// append days from the next month

		for (var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth; dayNum++) {

			days.appendChild(createDay("nextMonthDay", new Date(self.currentYear, self.currentMonth + 1, dayNum % daysInMonth), dayNum));

		}



		if (isRangeMode && self.selectedDates.length === 1 && days.childNodes[0]) {

			self._hidePrevMonthArrow = self._hidePrevMonthArrow || self.minRangeDate > days.childNodes[0].dateObj;



			self._hideNextMonthArrow = self._hideNextMonthArrow || self.maxRangeDate < days.childNodes[41].dateObj;

		} else updateNavigationCurrentMonth();



		self.days.appendChild(days);

		return self.days;

	}



	function buildMonthNav() {

		var monthNavFragment = window.document.createDocumentFragment();

		self.monthNav = createElement("div", "flatpickr-month");



		self.prevMonthNav = createElement("span", "flatpickr-prev-month");

		self.prevMonthNav.innerHTML = self.config.prevArrow;



		self.currentMonthElement = createElement("span", "cur-month");

		self.currentMonthElement.title = self.l10n.scrollTitle;



		var yearInput = createNumberInput("cur-year");

		self.currentYearElement = yearInput.childNodes[0];

		self.currentYearElement.title = self.l10n.scrollTitle;



		if (self.config.minDate) self.currentYearElement.min = self.config.minDate.getFullYear();



		if (self.config.maxDate) {

			self.currentYearElement.max = self.config.maxDate.getFullYear();



			self.currentYearElement.disabled = self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();

		}



		self.nextMonthNav = createElement("span", "flatpickr-next-month");

		self.nextMonthNav.innerHTML = self.config.nextArrow;



		self.navigationCurrentMonth = createElement("span", "flatpickr-current-month");

		self.navigationCurrentMonth.appendChild(self.currentMonthElement);

		self.navigationCurrentMonth.appendChild(yearInput);



		monthNavFragment.appendChild(self.prevMonthNav);

		monthNavFragment.appendChild(self.navigationCurrentMonth);

		monthNavFragment.appendChild(self.nextMonthNav);

		self.monthNav.appendChild(monthNavFragment);



		Object.defineProperty(self, "_hidePrevMonthArrow", {

			get: function get() {

				return this.__hidePrevMonthArrow;

			},

			set: function set(bool) {

				if (this.__hidePrevMonthArrow !== bool) self.prevMonthNav.style.display = bool ? "none" : "block";

				this.__hidePrevMonthArrow = bool;

			}

		});



		Object.defineProperty(self, "_hideNextMonthArrow", {

			get: function get() {

				return this.__hideNextMonthArrow;

			},

			set: function set(bool) {

				if (this.__hideNextMonthArrow !== bool) self.nextMonthNav.style.display = bool ? "none" : "block";

				this.__hideNextMonthArrow = bool;

			}

		});



		updateNavigationCurrentMonth();



		return self.monthNav;

	}



	function buildTime() {

		self.calendarContainer.classList.add("hasTime");

		if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");

		self.timeContainer = createElement("div", "flatpickr-time");

		self.timeContainer.tabIndex = -1;

		var separator = createElement("span", "flatpickr-time-separator", ":");



		var hourInput = createNumberInput("flatpickr-hour");

		self.hourElement = hourInput.childNodes[0];



		var minuteInput = createNumberInput("flatpickr-minute");

		self.minuteElement = minuteInput.childNodes[0];



		self.hourElement.tabIndex = self.minuteElement.tabIndex = 0;



		self.hourElement.value = self.pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.defaultHour);



		self.minuteElement.value = self.pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : self.config.defaultMinute);



		self.hourElement.step = self.config.hourIncrement;

		self.minuteElement.step = self.config.minuteIncrement;



		self.hourElement.min = self.config.time_24hr ? 0 : 1;

		self.hourElement.max = self.config.time_24hr ? 23 : 12;



		self.minuteElement.min = 0;

		self.minuteElement.max = 59;



		self.hourElement.title = self.minuteElement.title = self.l10n.scrollTitle;



		self.timeContainer.appendChild(hourInput);

		self.timeContainer.appendChild(separator);

		self.timeContainer.appendChild(minuteInput);



		if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");



		if (self.config.enableSeconds) {

			self.timeContainer.classList.add("hasSeconds");



			var secondInput = createNumberInput("flatpickr-second");

			self.secondElement = secondInput.childNodes[0];



			self.secondElement.value = self.latestSelectedDateObj ? self.pad(self.latestSelectedDateObj.getSeconds()) : "00";



			self.secondElement.step = self.minuteElement.step;

			self.secondElement.min = self.minuteElement.min;

			self.secondElement.max = self.minuteElement.max;



			self.timeContainer.appendChild(createElement("span", "flatpickr-time-separator", ":"));

			self.timeContainer.appendChild(secondInput);

		}



		if (!self.config.time_24hr) {

			// add self.amPM if appropriate

			self.amPM = createElement("span", "flatpickr-am-pm", ["AM", "PM"][self.hourElement.value > 11 | 0]);

			self.amPM.title = self.l10n.toggleTitle;

			self.amPM.tabIndex = 0;

			self.timeContainer.appendChild(self.amPM);

		}



		return self.timeContainer;

	}



	function buildWeekdays() {

		if (!self.weekdayContainer) self.weekdayContainer = createElement("div", "flatpickr-weekdays");



		var firstDayOfWeek = self.l10n.firstDayOfWeek;

		var weekdays = self.l10n.weekdays.shorthand.slice();



		if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) {

			weekdays = [].concat(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));

		}



		self.weekdayContainer.innerHTML = "\n\t\t<span class=flatpickr-weekday>\n\t\t\t" + weekdays.join("</span><span class=flatpickr-weekday>") + "\n\t\t</span>\n\t\t";



		return self.weekdayContainer;

	}



	/* istanbul ignore next */

	function buildWeeks() {

		self.calendarContainer.classList.add("hasWeeks");

		self.weekWrapper = createElement("div", "flatpickr-weekwrapper");

		self.weekWrapper.appendChild(createElement("span", "flatpickr-weekday", self.l10n.weekAbbreviation));

		self.weekNumbers = createElement("div", "flatpickr-weeks");

		self.weekWrapper.appendChild(self.weekNumbers);



		return self.weekWrapper;

	}



	function changeMonth(value, is_offset) {

		is_offset = typeof is_offset === "undefined" || is_offset;

		var delta = is_offset ? value : value - self.currentMonth;



		if (delta < 0 && self._hidePrevMonthArrow || delta > 0 && self._hideNextMonthArrow) return;



		self.currentMonth += delta;



		if (self.currentMonth < 0 || self.currentMonth > 11) {

			self.currentYear += self.currentMonth > 11 ? 1 : -1;

			self.currentMonth = (self.currentMonth + 12) % 12;



			triggerEvent("YearChange");

		}



		updateNavigationCurrentMonth();

		buildDays();



		if (!self.config.noCalendar) self.days.focus();



		triggerEvent("MonthChange");

	}



	function clear(triggerChangeEvent) {

		self.input.value = "";



		if (self.altInput) self.altInput.value = "";



		if (self.mobileInput) self.mobileInput.value = "";



		self.selectedDates = [];

		self.latestSelectedDateObj = null;

		self.dateIsPicked = false;



		self.redraw();



		if (triggerChangeEvent !== false)

			// triggerChangeEvent is true (default) or an Event

			triggerEvent("Change");

	}



	function close() {

		self.isOpen = false;



		if (!self.isMobile) {

			self.calendarContainer.classList.remove("open");

			(self.altInput || self.input).classList.remove("active");

		}



		triggerEvent("Close");

	}



	function destroy(instance) {

		instance = instance || self;

		instance.clear(false);



		window.document.removeEventListener("keydown", onKeyDown);

		window.removeEventListener("resize", instance.debouncedResize);



		window.document.removeEventListener("click", documentClick);

		window.document.removeEventListener("touchstart", documentClick);

		window.document.removeEventListener("blur", documentClick);



		if (instance.timeContainer) instance.timeContainer.removeEventListener("transitionend", positionCalendar);



		if (instance.mobileInput) {

			if (instance.mobileInput.parentNode) instance.mobileInput.parentNode.removeChild(instance.mobileInput);

			delete instance.mobileInput;

		} else if (instance.calendarContainer && instance.calendarContainer.parentNode) instance.calendarContainer.parentNode.removeChild(instance.calendarContainer);



		if (instance.altInput) {

			instance.input.type = "text";

			if (instance.altInput.parentNode) instance.altInput.parentNode.removeChild(instance.altInput);

			delete instance.altInput;

		}



		instance.input.type = instance.input._type;

		instance.input.classList.remove("flatpickr-input");

		instance.input.removeEventListener("focus", open);

		instance.input.removeAttribute("readonly");



		delete instance.input._flatpickr;

	}



	function isCalendarElem(elem) {

		if (self.config.appendTo && self.config.appendTo.contains(elem)) return true;



		return self.calendarContainer.contains(elem);

	}



	function documentClick(e) {

		var isInput = self.element.contains(e.target) || e.target === self.input || e.target === self.altInput ||

		// web components

		e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput));



		if (self.isOpen && !self.config.inline && !isCalendarElem(e.target) && !isInput) {

			e.preventDefault();

			self.close();



			if (self.config.mode === "range" && self.selectedDates.length === 1) {

				self.clear();

				self.redraw();

			}

		}

	}



	function formatDate(frmt, dateObj) {

		if (self.config.formatDate) return self.config.formatDate(frmt, dateObj);



		var chars = frmt.split("");

		return chars.map(function (c, i) {

			return self.formats[c] && chars[i - 1] !== "\\" ? self.formats[c](dateObj) : c !== "\\" ? c : "";

		}).join("");

	}



	function changeYear(newYear) {

		if (!newYear || self.currentYearElement.min && newYear < self.currentYearElement.min || self.currentYearElement.max && newYear > self.currentYearElement.max) return;



		var newYearNum = parseInt(newYear, 10),

		    isNewYear = self.currentYear !== newYearNum;



		self.currentYear = newYearNum || self.currentYear;



		if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) {

			self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);

		} else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) {

			self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);

		}



		if (isNewYear) {

			self.redraw();

			triggerEvent("YearChange");

		}

	}



	function isEnabled(date, timeless) {

		var ltmin = compareDates(date, self.config.minDate, typeof timeless !== "undefined" ? timeless : !self.minDateHasTime) < 0;

		var gtmax = compareDates(date, self.config.maxDate, typeof timeless !== "undefined" ? timeless : !self.maxDateHasTime) > 0;



		if (ltmin || gtmax) return false;



		if (!self.config.enable.length && !self.config.disable.length) return true;



		var dateToCheck = self.parseDate(date, true); // timeless



		var bool = self.config.enable.length > 0,

		    array = bool ? self.config.enable : self.config.disable;



		for (var i = 0, d; i < array.length; i++) {

			d = array[i];



			if (d instanceof Function && d(dateToCheck)) // disabled by function

				return bool;else if (d instanceof Date && d.getTime() === dateToCheck.getTime())

				// disabled by date

				return bool;else if (typeof d === "string" && self.parseDate(d, true).getTime() === dateToCheck.getTime())

				// disabled by date string

				return bool;else if ( // disabled by range

			(typeof d === "undefined" ? "undefined" : _typeof(d)) === "object" && d.from && d.to && dateToCheck >= d.from && dateToCheck <= d.to) return bool;

		}



		return !bool;

	}



	function onKeyDown(e) {

		if (e.target === (self.altInput || self.input) && e.which === 13) selectDate(e);else if (self.isOpen && isCalendarElem(e.target)) {

			switch (e.which) {

				case 13:

					if (self.timeContainer && self.timeContainer.contains(e.target)) updateValue();else selectDate(e);



					break;



				case 27:

					// escape

					self.close();

					break;



				case 37:

					if (e.target !== self.input & e.target !== self.altInput) {

						changeMonth(-1);

						self.currentMonthElement.focus();

					}

					break;



				case 38:

					if (!self.timeContainer || !self.timeContainer.contains(e.target)) {

						e.preventDefault();

						self.currentYear++;

						self.redraw();

					} else updateTime(e);



					break;



				case 39:

					if (e.target !== self.input & e.target !== self.altInput) {

						changeMonth(1);

						self.currentMonthElement.focus();

					}

					break;



				case 40:

					if (!self.timeContainer || !self.timeContainer.contains(e.target)) {

						e.preventDefault();

						self.currentYear--;

						self.redraw();

					} else updateTime(e);



					break;



				default:

					break;



			}

		}

	}



	function onMouseOver(e) {

		if (self.selectedDates.length !== 1 || !e.target.classList.contains("flatpickr-day")) return;



		var hoverDate = e.target.dateObj,

		    initialDate = self.parseDate(self.selectedDates[0], true),

		    rangeStartDate = Math.min(hoverDate.getTime(), self.selectedDates[0].getTime()),

		    rangeEndDate = Math.max(hoverDate.getTime(), self.selectedDates[0].getTime()),

		    containsDisabled = false;



		for (var t = rangeStartDate; t < rangeEndDate; t += self.utils.duration.DAY) {

			if (!isEnabled(new Date(t))) {

				containsDisabled = true;

				break;

			}

		}



		var _loop = function _loop(timestamp, i) {

			var outOfRange = timestamp < self.minRangeDate.getTime() || timestamp > self.maxRangeDate.getTime();



			if (outOfRange) {

				self.days.childNodes[i].classList.add("notAllowed");

				["inRange", "startRange", "endRange"].forEach(function (c) {

					self.days.childNodes[i].classList.remove(c);

				});

				return "continue";

			} else if (containsDisabled && !outOfRange) return "continue";



			["startRange", "inRange", "endRange", "notAllowed"].forEach(function (c) {

				self.days.childNodes[i].classList.remove(c);

			});



			var minRangeDate = Math.max(self.minRangeDate.getTime(), rangeStartDate),

			    maxRangeDate = Math.min(self.maxRangeDate.getTime(), rangeEndDate);



			e.target.classList.add(hoverDate < self.selectedDates[0] ? "startRange" : "endRange");



			if (initialDate > hoverDate && timestamp === initialDate.getTime()) self.days.childNodes[i].classList.add("endRange");else if (initialDate < hoverDate && timestamp === initialDate.getTime()) self.days.childNodes[i].classList.add("startRange");else if (timestamp > minRangeDate && timestamp < maxRangeDate) self.days.childNodes[i].classList.add("inRange");

		};



		for (var timestamp = self.days.childNodes[0].dateObj.getTime(), i = 0; i < 42; i++, timestamp += self.utils.duration.DAY) {

			var _ret = _loop(timestamp, i);



			if (_ret === "continue") continue;

		}

	}



	function onResize() {

		if (self.isOpen && !self.config.static && !self.config.inline) positionCalendar();

	}



	function open(e) {

		if (self.isMobile) {

			if (e) {

				e.preventDefault();

				e.target.blur();

			}



			setTimeout(function () {

				self.mobileInput.click();

			}, 0);



			triggerEvent("Open");

			return;

		} else if (self.isOpen || (self.altInput || self.input).disabled || self.config.inline) return;



		self.calendarContainer.classList.add("open");



		if (!self.config.static && !self.config.inline) positionCalendar();



		self.isOpen = true;



		if (!self.config.allowInput) {

			(self.altInput || self.input).blur();

			(self.config.noCalendar ? self.timeContainer : self.selectedDateElem ? self.selectedDateElem : self.days).focus();

		}



		(self.altInput || self.input).classList.add("active");

		triggerEvent("Open");

	}



	function minMaxDateSetter(type) {

		return function (date) {

			var dateObj = self.config["_" + type + "Date"] = self.parseDate(date);

			var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];

			var isValidDate = date && dateObj instanceof Date;



			if (self.selectedDates) {

				self.selectedDates = self.selectedDates.filter(isEnabled);

				updateValue();

			}



			if (self.days) redraw();



			if (isValidDate) {

				self[type + "DateHasTime"] = dateObj.getHours() || dateObj.getMinutes() || dateObj.getSeconds();

			}



			if (self.currentYearElement) {

				if (isValidDate) self.currentYearElement[type] = dateObj.getFullYear();else self.currentYearElement.removeAttribute(type);



				self.currentYearElement.disabled = inverseDateObj && dateObj && inverseDateObj.getFullYear() === dateObj.getFullYear();

			}

		};

	}



	function parseConfig() {

		var boolOpts = ["utc", "wrap", "weekNumbers", "allowInput", "clickOpens", "time_24hr", "enableTime", "noCalendar", "altInput", "shorthandCurrentMonth", "inline", "static", "enableSeconds", "disableMobile"];



		var hooks = ["onChange", "onClose", "onDayCreate", "onMonthChange", "onOpen", "onReady", "onValueUpdate", "onYearChange"];



		self.config = Object.create(Flatpickr.defaultConfig);



		Object.defineProperty(self.config, "minDate", {

			get: function get() {

				return this._minDate;

			},

			set: minMaxDateSetter("min")

		});



		Object.defineProperty(self.config, "maxDate", {

			get: function get() {

				return this._maxDate;

			},

			set: minMaxDateSetter("max")

		});



		var userConfig = _extends({}, self.instanceConfig, JSON.parse(JSON.stringify(self.element.dataset || {})));



		self.config.parseDate = userConfig.parseDate;

		self.config.formatDate = userConfig.formatDate;



		_extends(self.config, userConfig);



		for (var i = 0; i < boolOpts.length; i++) {

			self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";

		}for (var _i = 0; _i < hooks.length; _i++) {

			self.config[hooks[_i]] = arrayify(self.config[hooks[_i]] || []);

		}



		if (!userConfig.dateFormat && userConfig.enableTime) {

			self.config.dateFormat = self.config.noCalendar ? "H:i" + (self.config.enableSeconds ? ":S" : "") : Flatpickr.defaultConfig.dateFormat + " H:i" + (self.config.enableSeconds ? ":S" : "");

		}



		if (userConfig.altInput && userConfig.enableTime && !userConfig.altFormat) {

			self.config.altFormat = self.config.noCalendar ? "h:i" + (self.config.enableSeconds ? ":S K" : " K") : Flatpickr.defaultConfig.altFormat + (" h:i" + (self.config.enableSeconds ? ":S" : "") + " K");

		}



		for (var _i2 = 0; _i2 < self.config.plugins.length; _i2++) {

			var pluginConf = self.config.plugins[_i2](self) || {};

			for (var key in pluginConf) {

				if (Array.isArray(self.config[key])) self.config[key] = arrayify(pluginConf[key]).concat(self.config[key]);else if (userConfig[key] !== undefined) self.config[key] = pluginConf[key];

			}

		}

	}



	function setupLocale() {

		if (_typeof(self.config.locale) !== "object" && typeof Flatpickr.l10ns[self.config.locale] === "undefined") console.warn("flatpickr: invalid locale " + self.config.locale);



		self.l10n = _extends(Object.create(Flatpickr.l10ns.default), _typeof(self.config.locale) === "object" ? self.config.locale : self.config.locale !== "default" ? Flatpickr.l10ns[self.config.locale] || {} : {});

	}



	function positionCalendar(e) {

		if (e && e.target !== self.timeContainer) return;



		var calendarHeight = self.calendarContainer.offsetHeight,

		    calendarWidth = self.calendarContainer.offsetWidth,

		    input = self.altInput || self.input,

		    inputBounds = input.getBoundingClientRect(),

		    distanceFromBottom = window.innerHeight - inputBounds.bottom + input.offsetHeight,

		    bottomCalendar = distanceFromBottom < calendarHeight + 60;



		var top = window.pageYOffset + inputBounds.top + (!bottomCalendar ? input.offsetHeight + 2 : -calendarHeight - 2);



		toggleClass(self.calendarContainer, "arrowTop", !bottomCalendar);

		toggleClass(self.calendarContainer, "arrowBottom", bottomCalendar);



		if (self.config.inline) return;



		var left = window.pageXOffset + inputBounds.left;

		var right = window.document.body.offsetWidth - inputBounds.right;

		var rightMost = left + calendarWidth > window.document.body.offsetWidth;



		toggleClass(self.calendarContainer, "rightMost", rightMost);



		if (self.config.static) return;



		self.calendarContainer.style.top = top + "px";



		if (!rightMost) {

			self.calendarContainer.style.left = left + "px";

			self.calendarContainer.style.right = "auto";

		} else {

			self.calendarContainer.style.left = "auto";

			self.calendarContainer.style.right = right + "px";

		}

	}



	function redraw() {

		if (self.config.noCalendar || self.isMobile) return;



		buildWeekdays();

		updateNavigationCurrentMonth();

		buildDays();

	}



	function selectDate(e) {

		e.preventDefault();

		e.stopPropagation();



		if (self.config.allowInput && e.which === 13 && e.target === (self.altInput || self.input)) return self.setDate((self.altInput || self.input).value), e.target.blur();



		if (!e.target.classList.contains("flatpickr-day") || e.target.classList.contains("disabled") || e.target.classList.contains("notAllowed")) return;



		var selectedDate = self.latestSelectedDateObj = new Date(e.target.dateObj.getTime());



		self.selectedDateElem = e.target;



		if (self.config.mode === "single") self.selectedDates = [selectedDate];else if (self.config.mode === "multiple") {

			var selectedIndex = isDateSelected(selectedDate);

			if (selectedIndex) self.selectedDates.splice(selectedIndex, 1);else self.selectedDates.push(selectedDate);

		} else if (self.config.mode === "range") {

			if (self.selectedDates.length === 2) self.clear();



			self.selectedDates.push(selectedDate);



			// unless selecting same date twice, sort ascendingly

			if (compareDates(selectedDate, self.selectedDates[0], true) !== 0) self.selectedDates.sort(function (a, b) {

				return a.getTime() - b.getTime();

			});

		}



		setHoursFromInputs();



		if (selectedDate.getMonth() !== self.currentMonth && self.config.mode !== "range") {

			var isNewYear = self.currentYear !== selectedDate.getFullYear();

			self.currentYear = selectedDate.getFullYear();

			self.currentMonth = selectedDate.getMonth();



			if (isNewYear) triggerEvent("YearChange");



			triggerEvent("MonthChange");

		}



		buildDays();



		if (self.minDateHasTime && self.config.enableTime && compareDates(selectedDate, self.config.minDate) === 0) setHoursFromDate(self.config.minDate);



		updateValue();



		setTimeout(function () {

			return self.dateIsPicked = true;

		}, 50);



		if (self.config.mode === "range") {

			if (self.selectedDates.length === 1) {

				onMouseOver(e);



				self._hidePrevMonthArrow = self._hidePrevMonthArrow || self.minRangeDate > self.days.childNodes[0].dateObj;



				self._hideNextMonthArrow = self._hideNextMonthArrow || self.maxRangeDate < self.days.childNodes[41].dateObj;

			} else updateNavigationCurrentMonth();

		}



		if (e.which === 13 && self.config.enableTime) setTimeout(function () {

			return self.hourElement.focus();

		}, 451);



		if (self.config.mode === "single" && !self.config.enableTime) self.close();



		triggerEvent("Change");

	}



	function set(option, value) {

		self.config[option] = value;

		self.redraw();

		jumpToDate();

	}



	function setSelectedDate(inputDate) {

		if (Array.isArray(inputDate)) self.selectedDates = inputDate.map(self.parseDate);else if (inputDate instanceof Date || !isNaN(inputDate)) self.selectedDates = [self.parseDate(inputDate)];else if (inputDate && inputDate.substring) {

			switch (self.config.mode) {

				case "single":

					self.selectedDates = [self.parseDate(inputDate)];

					break;



				case "multiple":

					self.selectedDates = inputDate.split("; ").map(self.parseDate);

					break;



				case "range":

					self.selectedDates = inputDate.split(self.l10n.rangeSeparator).map(self.parseDate);



					break;



				default:

					break;

			}

		}



		self.selectedDates = self.selectedDates.filter(function (d) {

			return d instanceof Date && d.getTime() && isEnabled(d, false);

		});



		self.selectedDates.sort(function (a, b) {

			return a.getTime() - b.getTime();

		});

	}



	function setDate(date, triggerChange) {

		if (!date) return self.clear();



		setSelectedDate(date);



		if (self.selectedDates.length > 0) {

			self.dateIsPicked = true;

			self.latestSelectedDateObj = self.selectedDates[0];

		} else self.latestSelectedDateObj = null;



		self.redraw();

		jumpToDate();



		setHoursFromDate();

		updateValue();



		if (triggerChange !== false) triggerEvent("Change");

	}



	function setupDates() {

		function parseDateRules(arr) {

			for (var i = arr.length; i--;) {

				if (typeof arr[i] === "string" || +arr[i]) arr[i] = self.parseDate(arr[i], true);else if (arr[i] && arr[i].from && arr[i].to) {

					arr[i].from = self.parseDate(arr[i].from);

					arr[i].to = self.parseDate(arr[i].to);

				}

			}



			return arr.filter(function (x) {

				return x;

			}); // remove falsy values

		}



		self.selectedDates = [];

		self.now = new Date();



		if (self.config.disable.length) self.config.disable = parseDateRules(self.config.disable);



		if (self.config.enable.length) self.config.enable = parseDateRules(self.config.enable);



		setSelectedDate(self.config.defaultDate || self.input.value);



		var initialDate = self.selectedDates.length ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now ? self.config.maxDate : self.now;



		self.currentYear = initialDate.getFullYear();

		self.currentMonth = initialDate.getMonth();



		if (self.selectedDates.length) self.latestSelectedDateObj = self.selectedDates[0];



		self.minDateHasTime = self.config.minDate && (self.config.minDate.getHours() || self.config.minDate.getMinutes() || self.config.minDate.getSeconds());



		self.maxDateHasTime = self.config.maxDate && (self.config.maxDate.getHours() || self.config.maxDate.getMinutes() || self.config.maxDate.getSeconds());



		Object.defineProperty(self, "latestSelectedDateObj", {

			get: function get() {

				return self._selectedDateObj || self.selectedDates[self.selectedDates.length - 1] || null;

			},

			set: function set(date) {

				self._selectedDateObj = date;

			}

		});

	}



	function setupHelperFunctions() {

		self.utils = {

			duration: {

				DAY: 86400000

			},

			getDaysinMonth: function getDaysinMonth(month, yr) {

				month = typeof month === "undefined" ? self.currentMonth : month;



				yr = typeof yr === "undefined" ? self.currentYear : yr;



				if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;



				return self.l10n.daysInMonth[month];

			},

			monthToStr: function monthToStr(monthNumber, shorthand) {

				shorthand = typeof shorthand === "undefined" ? self.config.shorthandCurrentMonth : shorthand;



				return self.l10n.months[(shorthand ? "short" : "long") + "hand"][monthNumber];

			}

		};

	}



	/* istanbul ignore next */

	function setupFormats() {

		self.formats = {

			// get the date in UTC

			Z: function Z(date) {

				return date.toISOString();

			},



			// weekday name, short, e.g. Thu

			D: function D(date) {

				return self.l10n.weekdays.shorthand[self.formats.w(date)];

			},



			// full month name e.g. January

			F: function F(date) {

				return self.utils.monthToStr(self.formats.n(date) - 1, false);

			},



			// hours with leading zero e.g. 03

			H: function H(date) {

				return Flatpickr.prototype.pad(date.getHours());

			},



			// day (1-30) with ordinal suffix e.g. 1st, 2nd

			J: function J(date) {

				return date.getDate() + self.l10n.ordinal(date.getDate());

			},



			// AM/PM

			K: function K(date) {

				return date.getHours() > 11 ? "PM" : "AM";

			},



			// shorthand month e.g. Jan, Sep, Oct, etc

			M: function M(date) {

				return self.utils.monthToStr(date.getMonth(), true);

			},



			// seconds 00-59

			S: function S(date) {

				return Flatpickr.prototype.pad(date.getSeconds());

			},



			// unix timestamp

			U: function U(date) {

				return date.getTime() / 1000;

			},



			// full year e.g. 2016

			Y: function Y(date) {

				return date.getFullYear();

			},



			// day in month, padded (01-30)

			d: function d(date) {

				return Flatpickr.prototype.pad(self.formats.j(date));

			},



			// hour from 1-12 (am/pm)

			h: function h(date) {

				return date.getHours() % 12 ? date.getHours() % 12 : 12;

			},



			// minutes, padded with leading zero e.g. 09

			i: function i(date) {

				return Flatpickr.prototype.pad(date.getMinutes());

			},



			// day in month (1-30)

			j: function j(date) {

				return date.getDate();

			},



			// weekday name, full, e.g. Thursday

			l: function l(date) {

				return self.l10n.weekdays.longhand[self.formats.w(date)];

			},



			// padded month number (01-12)

			m: function m(date) {

				return Flatpickr.prototype.pad(self.formats.n(date));

			},



			// the month number (1-12)

			n: function n(date) {

				return date.getMonth() + 1;

			},



			// seconds 0-59

			s: function s(date) {

				return date.getSeconds();

			},



			// number of the day of the week

			w: function w(date) {

				return date.getDay();

			},



			// last two digits of year e.g. 16 for 2016

			y: function y(date) {

				return String(self.formats.Y(date)).substring(2);

			}

		};

	}



	function setupInputs() {

		self.input = self.config.wrap ? self.element.querySelector("[data-input]") : self.element;



		/* istanbul ignore next */

		if (!self.input) return console.warn("Error: invalid input element specified", self.input);



		self.input._type = self.input.type;

		self.input.type = "text";

		self.input.classList.add("flatpickr-input");



		if (self.config.altInput) {

			// replicate self.element

			self.altInput = createElement(self.input.nodeName, self.input.className + " " + self.config.altInputClass);

			self.altInput.placeholder = self.input.placeholder;

			self.altInput.type = "text";



			self.input.type = "hidden";

			if (self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);

		}



		if (!self.config.allowInput) (self.altInput || self.input).setAttribute("readonly", "readonly");

	}



	function setupMobile() {

		var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";



		self.mobileInput = createElement("input", self.input.className + " flatpickr-mobile");

		self.mobileInput.step = "any";

		self.mobileInput.tabIndex = 1;

		self.mobileInput.type = inputType;

		self.mobileInput.disabled = self.input.disabled;

		self.mobileInput.placeholder = self.input.placeholder;



		self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";



		if (self.selectedDates.length) {

			self.mobileInput.defaultValue = self.mobileInput.value = formatDate(self.mobileFormatStr, self.selectedDates[0]);

		}



		if (self.config.minDate) self.mobileInput.min = formatDate("Y-m-d", self.config.minDate);



		if (self.config.maxDate) self.mobileInput.max = formatDate("Y-m-d", self.config.maxDate);



		self.input.type = "hidden";

		if (self.config.altInput) self.altInput.type = "hidden";



		try {

			self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);

		} catch (e) {

			//

		}



		self.mobileInput.addEventListener("change", function (e) {

			self.latestSelectedDateObj = self.parseDate(e.target.value);

			self.setDate(self.latestSelectedDateObj);

			triggerEvent("Change");

			triggerEvent("Close");

		});

	}



	function toggle() {

		if (self.isOpen) self.close();else self.open();

	}



	function triggerEvent(event, data) {

		var hooks = self.config["on" + event];



		if (hooks) {

			for (var i = 0; i < hooks.length; i++) {

				hooks[i](self.selectedDates, self.input.value, self, data);

			}

		}



		if (event === "Change") {

			if (typeof Event === "function" && Event.constructor) {

				self.input.dispatchEvent(new Event("change", { "bubbles": true }));



				// many front-end frameworks bind to the input event

				self.input.dispatchEvent(new Event("input", { "bubbles": true }));

			}



			/* istanbul ignore next */

			else {

					if (window.document.createEvent !== undefined) return self.input.dispatchEvent(self.changeEvent);



					self.input.fireEvent("onchange");

				}

		}

	}



	function isDateSelected(date) {

		for (var i = 0; i < self.selectedDates.length; i++) {

			if (compareDates(self.selectedDates[i], date) === 0) return "" + i;

		}



		return false;

	}



	function isDateInRange(date) {

		if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;

		return compareDates(date, self.selectedDates[0]) >= 0 && compareDates(date, self.selectedDates[1]) <= 0;

	}



	function updateNavigationCurrentMonth() {

		if (self.config.noCalendar || self.isMobile || !self.monthNav) return;



		self.currentMonthElement.textContent = self.utils.monthToStr(self.currentMonth) + " ";

		self.currentYearElement.value = self.currentYear;



		self._hidePrevMonthArrow = self.config.minDate && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());



		self._hideNextMonthArrow = self.config.maxDate && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());

	}



	function updateValue() {

		if (!self.selectedDates.length) return self.clear();



		if (self.isMobile) {

			self.mobileInput.value = self.selectedDates.length ? formatDate(self.mobileFormatStr, self.latestSelectedDateObj) : "";

		}



		var joinChar = self.config.mode !== "range" ? "; " : self.l10n.rangeSeparator;



		self.input.value = self.selectedDates.map(function (dObj) {

			return formatDate(self.config.dateFormat, dObj);

		}).join(joinChar);



		if (self.config.altInput) {

			self.altInput.value = self.selectedDates.map(function (dObj) {

				return formatDate(self.config.altFormat, dObj);

			}).join(joinChar);

		}



		triggerEvent("ValueUpdate");

	}



	function yearScroll(e) {

		e.preventDefault();



		var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.deltaY)),

		    newYear = parseInt(e.target.value, 10) + delta;



		changeYear(newYear);

		e.target.value = self.currentYear;

	}



	function createElement(tag, className, content) {

		var e = window.document.createElement(tag);

		className = className || "";

		content = content || "";



		e.className = className;



		if (content) e.textContent = content;



		return e;

	}



	function arrayify(obj) {

		if (Array.isArray(obj)) return obj;

		return [obj];

	}



	function toggleClass(elem, className, bool) {

		if (bool) return elem.classList.add(className);

		elem.classList.remove(className);

	}



	/* istanbul ignore next */

	function debounce(func, wait, immediate) {

		var timeout = void 0;

		return function () {

			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {

				args[_key] = arguments[_key];

			}



			var context = this;

			var later = function later() {

				timeout = null;

				if (!immediate) func.apply(context, args);

			};



			clearTimeout(timeout);

			timeout = setTimeout(later, wait);

			if (immediate && !timeout) func.apply(context, args);

		};

	}



	function compareDates(date1, date2, timeless) {

		if (!(date1 instanceof Date) || !(date2 instanceof Date)) return false;



		if (timeless !== false) {

			return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);

		}



		return date1.getTime() - date2.getTime();

	}



	function timeWrapper(e) {

		e.preventDefault();



		var isKeyDown = e.type === "keydown",

		    isWheel = e.type === "wheel";



		if (e.type !== "input" && !isKeyDown && (e.target.value || e.target.textContent).length >= 2 // typed two digits

		) {

				e.target.focus();

				e.target.blur();

			}



		if (self.amPM && e.target === self.amPM) return e.target.textContent = ["AM", "PM"][e.target.textContent === "AM" | 0];



		var min = Number(e.target.min),

		    max = Number(e.target.max),

		    step = Number(e.target.step),

		    curValue = parseInt(e.target.value, 10),

		    delta = !isKeyDown ? Math.max(-1, Math.min(1, e.wheelDelta || -e.deltaY)) || 0 : e.which === 38 ? 1 : -1;



		var newValue = curValue + (isWheel || isKeyDown) * step * delta;



		if (e.target.value.length === 2) {

			var isHourElem = e.target === self.hourElement;



			if (newValue < min) {

				newValue = max + newValue + !isHourElem + (isHourElem && !self.amPM);

			} else if (newValue > max) {

				newValue = e.target === self.hourElement ? newValue - max - !self.amPM : min;

			}



			if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) self.amPM.textContent = self.amPM.textContent === "PM" ? "AM" : "PM";



			e.target.value = self.pad(newValue);

		}

	}



	init();

	return self;

}



/* istanbul ignore next */

Flatpickr.defaultConfig = {



	mode: "single",



	/* if true, dates will be parsed, formatted, and displayed in UTC.

 preloading date strings w/ timezones is recommended but not necessary */

	utc: false,



	// wrap: see https://chmln.github.io/flatpickr/#strap

	wrap: false,



	// enables week numbers

	weekNumbers: false,



	// allow manual datetime input

	allowInput: false,



	/*

 	clicking on input opens the date(time)picker.

 	disable if you wish to open the calendar manually with .open()

 */

	clickOpens: true,



	// display time picker in 24 hour mode

	time_24hr: false,



	// enables the time picker functionality

	enableTime: false,



	// noCalendar: true will hide the calendar. use for a time picker along w/ enableTime

	noCalendar: false,



	// more date format chars at https://chmln.github.io/flatpickr/#dateformat

	dateFormat: "Y-m-d",



	// altInput - see https://chmln.github.io/flatpickr/#altinput

	altInput: false,



	// the created altInput element will have this class.

	altInputClass: "flatpickr-input form-control input",



	// same as dateFormat, but for altInput

	altFormat: "F j, Y", // defaults to e.g. June 10, 2016



	// defaultDate - either a datestring or a date object. used for datetimepicker"s initial value

	defaultDate: null,



	// the minimum date that user can pick (inclusive)

	minDate: null,



	// the maximum date that user can pick (inclusive)

	maxDate: null,



	// dateparser that transforms a given string to a date object

	parseDate: null,



	// dateformatter that transforms a given date object to a string, according to passed format

	formatDate: null,



	getWeek: function getWeek(givenDate) {

		var date = new Date(givenDate.getTime());

		date.setHours(0, 0, 0, 0);



		// Thursday in current week decides the year.

		date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);

		// January 4 is always in week 1.

		var week1 = new Date(date.getFullYear(), 0, 4);

		// Adjust to Thursday in week 1 and count number of weeks from date to week1.

		return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);

	},



	// see https://chmln.github.io/flatpickr/#disable

	enable: [],



	// see https://chmln.github.io/flatpickr/#disable

	disable: [],



	// display the short version of month names - e.g. Sep instead of September

	shorthandCurrentMonth: false,



	// displays calendar inline. see https://chmln.github.io/flatpickr/#inline-calendar

	inline: false,



	// position calendar inside wrapper and next to the input element

	// leave at false unless you know what you"re doing

	static: false,



	// DOM node to append the calendar to in *static* mode

	appendTo: null,



	// code for previous/next icons. this is where you put your custom icon code e.g. fontawesome

	prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",

	nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",



	// enables seconds in the time picker

	enableSeconds: false,



	// step size used when scrolling/incrementing the hour element

	hourIncrement: 1,



	// step size used when scrolling/incrementing the minute element

	minuteIncrement: 5,



	// initial value in the hour element

	defaultHour: 12,



	// initial value in the minute element

	defaultMinute: 0,



	// disable native mobile datetime input support

	disableMobile: false,



	// default locale

	locale: "default",



	plugins: [],



	// onChange callback when user selects a date or time

	onChange: [], // function (dateObj, dateStr) {}



	// called every time calendar is opened

	onOpen: [], // function (dateObj, dateStr) {}



	// called every time calendar is closed

	onClose: [], // function (dateObj, dateStr) {}



	// called after calendar is ready

	onReady: [], // function (dateObj, dateStr) {}



	onValueUpdate: [],



	onDayCreate: [],



	onMonthChange: [],



	onYearChange: []

};



/* istanbul ignore next */

Flatpickr.l10ns = {

	en: {

		weekdays: {

			shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],

			longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]

		},

		months: {

			shorthand: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],

			longhand: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]

		},

		daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],

		firstDayOfWeek: 0,

		ordinal: function ordinal(nth) {

			var s = nth % 100;

			if (s > 3 && s < 21) return "th";

			switch (s % 10) {

				case 1:

					return "st";

				case 2:

					return "nd";

				case 3:

					return "rd";

				default:

					return "th";

			}

		},

		rangeSeparator: " to ",

		weekAbbreviation: "Wk",

		scrollTitle: "Scroll to increment",

		toggleTitle: "Click to toggle"

	}

};



Flatpickr.l10ns.default = Object.create(Flatpickr.l10ns.en);

Flatpickr.localize = function (l10n) {

	return _extends(Flatpickr.l10ns.default, l10n || {});

};

Flatpickr.setDefaults = function (config) {

	return _extends(Flatpickr.defaultConfig, config || {});

};



Flatpickr.prototype = {

	pad: function pad(number) {

		return ("0" + number).slice(-2);

	},

	parseDate: function parseDate(date, timeless) {

		if (!date) return null;



		var dateTimeRegex = /(\d+)/g,

		    timeRegex = /^(\d{1,2})[:\s](\d\d)?[:\s]?(\d\d)?\s?(a|p|A|P)?/i,

		    timestamp = /^(\d+)$/g,

		    date_orig = date;



		if (date.toFixed || timestamp.test(date)) // timestamp

			date = new Date(date);else if (typeof date === "string") {

			date = date.trim();



			if (date === "today") {

				date = new Date();

				timeless = true;

			} else if (this.config && this.config.parseDate) date = this.config.parseDate(date);else if (timeRegex.test(date)) {

				// time picker

				var m = date.match(timeRegex),

				    hours = !m[4] ? m[1] // military time, no conversion needed

				: m[1] % 12 + (m[4].toLowerCase() === "p" ? 12 : 0); // am/pm



				date = new Date();

				date.setHours(hours, m[2] || 0, m[3] || 0);

			} else if (/Z$/.test(date) || /GMT$/.test(date)) // datestrings w/ timezone

				date = new Date(date);else if (dateTimeRegex.test(date) && /^[0-9]/.test(date)) {

				var d = date.match(dateTimeRegex),

				    isAM = /(am|AM)$/.test(date),

				    isPM = /(pm|PM)$/.test(date);



				date = new Date(d[0] + "/" + (d[1] || 1) + "/" + (d[2] || 1) + " " + (d[3] || 0) + ":" + (d[4] || 0) + ":" + (d[5] || 0));



				if (isAM || isPM) date.setHours(date.getHours() % 12 + 12 * isPM);

			} else // fallback

				date = new Date(date);

		} else if (date instanceof Date) date = new Date(date.getTime()); // create a copy



		/* istanbul ignore next */

		if (!(date instanceof Date)) {

			console.warn("flatpickr: invalid date " + date_orig);

			console.info(this.element);

			return null;

		}



		if (this.config && this.config.utc && !date.fp_isUTC) date = date.fp_toUTC();



		if (timeless === true) date.setHours(0, 0, 0, 0);



		return date;

	}

};



/* istanbul ignore next */

function _flatpickr(nodeList, config) {

	var nodes = Array.prototype.slice.call(nodeList); // static list

	var instances = [];

	for (var i = 0; i < nodes.length; i++) {

		try {

			nodes[i]._flatpickr = new Flatpickr(nodes[i], config || {});

			instances.push(nodes[i]._flatpickr);

		} catch (e) {

			console.warn(e, e.stack);

		}

	}



	return instances.length === 1 ? instances[0] : instances;

}



/* istanbul ignore next */

if (typeof HTMLElement !== "undefined") {

	// browser env

	HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function (config) {

		return _flatpickr(this, config);

	};



	HTMLElement.prototype.flatpickr = function (config) {

		return _flatpickr([this], config);

	};

}



/* istanbul ignore next */

function flatpickr(selector, config) {

	return _flatpickr(window.document.querySelectorAll(selector), config);

}



/* istanbul ignore next */

if (typeof jQuery !== "undefined") {

	jQuery.fn.flatpickr = function (config) {

		return _flatpickr(this, config);

	};

}



Date.prototype.fp_incr = function (days) {

	return new Date(this.getFullYear(), this.getMonth(), this.getDate() + parseInt(days, 10));

};



Date.prototype.fp_isUTC = false;

Date.prototype.fp_toUTC = function () {

	var newDate = new Date(this.getUTCFullYear(), this.getUTCMonth(), this.getUTCDate(), this.getUTCHours(), this.getUTCMinutes(), this.getUTCSeconds());



	newDate.fp_isUTC = true;

	return newDate;

};



// IE9 classList polyfill

/* istanbul ignore next */

if (!window.document.documentElement.classList && Object.defineProperty && typeof HTMLElement !== "undefined") {

	Object.defineProperty(HTMLElement.prototype, "classList", {

		get: function get() {

			var self = this;

			function update(fn) {

				return function (value) {

					var classes = self.className.split(/\s+/),

					    index = classes.indexOf(value);



					fn(classes, index, value);

					self.className = classes.join(" ");

				};

			}



			var ret = {

				add: update(function (classes, index, value) {

					if (!~index) classes.push(value);

				}),



				remove: update(function (classes, index) {

					if (~index) classes.splice(index, 1);

				}),



				toggle: update(function (classes, index, value) {

					if (~index) classes.splice(index, 1);else classes.push(value);

				}),



				contains: function contains(value) {

					return !!~self.className.split(/\s+/).indexOf(value);

				},



				item: function item(i) {

					return self.className.split(/\s+/)[i] || null;

				}

			};



			Object.defineProperty(ret, "length", {

				get: function get() {

					return self.className.split(/\s+/).length;

				}

			});



			return ret;

		}

	});

}



if (typeof module !== "undefined") module.exports = Flatpickr;



/*

     _ _      _       _

 ___| (_) ___| | __  (_)___

/ __| | |/ __| |/ /  | / __|

\__ \ | | (__|   < _ | \__ \

|___/_|_|\___|_|\_(_)/ |___/

                   |__/



 Version: 1.6.0

  Author: Ken Wheeler

 Website: http://kenwheeler.github.io

    Docs: http://kenwheeler.github.io/slick

    Repo: http://github.com/kenwheeler/slick

  Issues: http://github.com/kenwheeler/slick/issues



 */

/* global window, document, define, jQuery, setInterval, clearInterval */

(function(factory) {

    'use strict';

    if (typeof define === 'function' && define.amd) {

        define(['jquery'], factory);

    } else if (typeof exports !== 'undefined') {

        module.exports = factory(require('jquery'));

    } else {

        factory(jQuery);

    }



}(function($) {

    'use strict';

    var Slick = window.Slick || {};



    Slick = (function() {



        var instanceUid = 0;



        function Slick(element, settings) {



            var _ = this, dataSettings;



            _.defaults = {

                accessibility: true,

                adaptiveHeight: false,

                appendArrows: $(element),

                appendDots: $(element),

                arrows: true,

                asNavFor: null,

                prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',

                nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',

                autoplay: false,

                autoplaySpeed: 3000,

                centerMode: false,

                centerPadding: '50px',

                cssEase: 'ease',

                customPaging: function(slider, i) {

                    return $('<button type="button" data-role="none" role="button" tabindex="0" />').text(i + 1);

                },

                dots: false,

                dotsClass: 'slick-dots',

                draggable: true,

                easing: 'linear',

                edgeFriction: 0.35,

                fade: false,

                focusOnSelect: false,

                infinite: true,

                initialSlide: 0,

                lazyLoad: 'ondemand',

                mobileFirst: false,

                pauseOnHover: true,

                pauseOnFocus: true,

                pauseOnDotsHover: false,

                respondTo: 'window',

                responsive: null,

                rows: 1,

                rtl: false,

                slide: '',

                slidesPerRow: 1,

                slidesToShow: 1,

                slidesToScroll: 1,

                speed: 500,

                swipe: true,

                swipeToSlide: false,

                touchMove: true,

                touchThreshold: 5,

                useCSS: true,

                useTransform: true,

                variableWidth: false,

                vertical: false,

                verticalSwiping: false,

                waitForAnimate: true,

                zIndex: 1000

            };



            _.initials = {

                animating: false,

                dragging: false,

                autoPlayTimer: null,

                currentDirection: 0,

                currentLeft: null,

                currentSlide: 0,

                direction: 1,

                $dots: null,

                listWidth: null,

                listHeight: null,

                loadIndex: 0,

                $nextArrow: null,

                $prevArrow: null,

                slideCount: null,

                slideWidth: null,

                $slideTrack: null,

                $slides: null,

                sliding: false,

                slideOffset: 0,

                swipeLeft: null,

                $list: null,

                touchObject: {},

                transformsEnabled: false,

                unslicked: false

            };



            $.extend(_, _.initials);



            _.activeBreakpoint = null;

            _.animType = null;

            _.animProp = null;

            _.breakpoints = [];

            _.breakpointSettings = [];

            _.cssTransitions = false;

            _.focussed = false;

            _.interrupted = false;

            _.hidden = 'hidden';

            _.paused = true;

            _.positionProp = null;

            _.respondTo = null;

            _.rowCount = 1;

            _.shouldClick = true;

            _.$slider = $(element);

            _.$slidesCache = null;

            _.transformType = null;

            _.transitionType = null;

            _.visibilityChange = 'visibilitychange';

            _.windowWidth = 0;

            _.windowTimer = null;



            dataSettings = $(element).data('slick') || {};



            _.options = $.extend({}, _.defaults, settings, dataSettings);



            _.currentSlide = _.options.initialSlide;



            _.originalSettings = _.options;



            if (typeof document.mozHidden !== 'undefined') {

                _.hidden = 'mozHidden';

                _.visibilityChange = 'mozvisibilitychange';

            } else if (typeof document.webkitHidden !== 'undefined') {

                _.hidden = 'webkitHidden';

                _.visibilityChange = 'webkitvisibilitychange';

            }



            _.autoPlay = $.proxy(_.autoPlay, _);

            _.autoPlayClear = $.proxy(_.autoPlayClear, _);

            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);

            _.changeSlide = $.proxy(_.changeSlide, _);

            _.clickHandler = $.proxy(_.clickHandler, _);

            _.selectHandler = $.proxy(_.selectHandler, _);

            _.setPosition = $.proxy(_.setPosition, _);

            _.swipeHandler = $.proxy(_.swipeHandler, _);

            _.dragHandler = $.proxy(_.dragHandler, _);

            _.keyHandler = $.proxy(_.keyHandler, _);



            _.instanceUid = instanceUid++;



            // A simple way to check for HTML strings

            // Strict HTML recognition (must start with <)

            // Extracted from jQuery v1.11 source

            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;





            _.registerBreakpoints();

            _.init(true);



        }



        return Slick;



    }());



    Slick.prototype.activateADA = function() {

        var _ = this;



        _.$slideTrack.find('.slick-active').attr({

            'aria-hidden': 'false'

        }).find('a, input, button, select').attr({

            'tabindex': '0'

        });



    };



    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {



        var _ = this;



        if (typeof(index) === 'boolean') {

            addBefore = index;

            index = null;

        } else if (index < 0 || (index >= _.slideCount)) {

            return false;

        }



        _.unload();



        if (typeof(index) === 'number') {

            if (index === 0 && _.$slides.length === 0) {

                $(markup).appendTo(_.$slideTrack);

            } else if (addBefore) {

                $(markup).insertBefore(_.$slides.eq(index));

            } else {

                $(markup).insertAfter(_.$slides.eq(index));

            }

        } else {

            if (addBefore === true) {

                $(markup).prependTo(_.$slideTrack);

            } else {

                $(markup).appendTo(_.$slideTrack);

            }

        }



        _.$slides = _.$slideTrack.children(this.options.slide);



        _.$slideTrack.children(this.options.slide).detach();



        _.$slideTrack.append(_.$slides);



        _.$slides.each(function(index, element) {

            $(element).attr('data-slick-index', index);

        });



        _.$slidesCache = _.$slides;



        _.reinit();



    };



    Slick.prototype.animateHeight = function() {

        var _ = this;

        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {

            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);

            _.$list.animate({

                height: targetHeight

            }, _.options.speed);

        }

    };



    Slick.prototype.animateSlide = function(targetLeft, callback) {



        var animProps = {},

            _ = this;



        _.animateHeight();



        if (_.options.rtl === true && _.options.vertical === false) {

            targetLeft = -targetLeft;

        }

        if (_.transformsEnabled === false) {

            if (_.options.vertical === false) {

                _.$slideTrack.animate({

                    left: targetLeft

                }, _.options.speed, _.options.easing, callback);

            } else {

                _.$slideTrack.animate({

                    top: targetLeft

                }, _.options.speed, _.options.easing, callback);

            }



        } else {



            if (_.cssTransitions === false) {

                if (_.options.rtl === true) {

                    _.currentLeft = -(_.currentLeft);

                }

                $({

                    animStart: _.currentLeft

                }).animate({

                    animStart: targetLeft

                }, {

                    duration: _.options.speed,

                    easing: _.options.easing,

                    step: function(now) {

                        now = Math.ceil(now);

                        if (_.options.vertical === false) {

                            animProps[_.animType] = 'translate(' +

                                now + 'px, 0px)';

                            _.$slideTrack.css(animProps);

                        } else {

                            animProps[_.animType] = 'translate(0px,' +

                                now + 'px)';

                            _.$slideTrack.css(animProps);

                        }

                    },

                    complete: function() {

                        if (callback) {

                            callback.call();

                        }

                    }

                });



            } else {



                _.applyTransition();

                targetLeft = Math.ceil(targetLeft);



                if (_.options.vertical === false) {

                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';

                } else {

                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';

                }

                _.$slideTrack.css(animProps);



                if (callback) {

                    setTimeout(function() {



                        _.disableTransition();



                        callback.call();

                    }, _.options.speed);

                }



            }



        }



    };



    Slick.prototype.getNavTarget = function() {



        var _ = this,

            asNavFor = _.options.asNavFor;



        if ( asNavFor && asNavFor !== null ) {

            asNavFor = $(asNavFor).not(_.$slider);

        }



        return asNavFor;



    };



    Slick.prototype.asNavFor = function(index) {



        var _ = this,

            asNavFor = _.getNavTarget();



        if ( asNavFor !== null && typeof asNavFor === 'object' ) {

            asNavFor.each(function() {

                var target = $(this).slick('getSlick');

                if(!target.unslicked) {

                    target.slideHandler(index, true);

                }

            });

        }



    };



    Slick.prototype.applyTransition = function(slide) {



        var _ = this,

            transition = {};



        if (_.options.fade === false) {

            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;

        } else {

            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;

        }



        if (_.options.fade === false) {

            _.$slideTrack.css(transition);

        } else {

            _.$slides.eq(slide).css(transition);

        }



    };



    Slick.prototype.autoPlay = function() {



        var _ = this;



        _.autoPlayClear();



        if ( _.slideCount > _.options.slidesToShow ) {

            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );

        }



    };



    Slick.prototype.autoPlayClear = function() {



        var _ = this;



        if (_.autoPlayTimer) {

            clearInterval(_.autoPlayTimer);

        }



    };



    Slick.prototype.autoPlayIterator = function() {



        var _ = this,

            slideTo = _.currentSlide + _.options.slidesToScroll;



        if ( !_.paused && !_.interrupted && !_.focussed ) {



            if ( _.options.infinite === false ) {



                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {

                    _.direction = 0;

                }



                else if ( _.direction === 0 ) {



                    slideTo = _.currentSlide - _.options.slidesToScroll;



                    if ( _.currentSlide - 1 === 0 ) {

                        _.direction = 1;

                    }



                }



            }



            _.slideHandler( slideTo );



        }



    };



    Slick.prototype.buildArrows = function() {



        var _ = this;



        if (_.options.arrows === true ) {



            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');

            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');



            if( _.slideCount > _.options.slidesToShow ) {



                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');



                if (_.htmlExpr.test(_.options.prevArrow)) {

                    _.$prevArrow.prependTo(_.options.appendArrows);

                }



                if (_.htmlExpr.test(_.options.nextArrow)) {

                    _.$nextArrow.appendTo(_.options.appendArrows);

                }



                if (_.options.infinite !== true) {

                    _.$prevArrow

                        .addClass('slick-disabled')

                        .attr('aria-disabled', 'true');

                }



            } else {



                _.$prevArrow.add( _.$nextArrow )



                    .addClass('slick-hidden')

                    .attr({

                        'aria-disabled': 'true',

                        'tabindex': '-1'

                    });



            }



        }



    };



    Slick.prototype.buildDots = function() {



        var _ = this,

            i, dot;



        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {



            _.$slider.addClass('slick-dotted');



            dot = $('<ul />').addClass(_.options.dotsClass);



            for (i = 0; i <= _.getDotCount(); i += 1) {

                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));

            }



            _.$dots = dot.appendTo(_.options.appendDots);



            _.$dots.find('li').first().addClass('slick-active').attr('aria-hidden', 'false');



        }



    };



    Slick.prototype.buildOut = function() {



        var _ = this;



        _.$slides =

            _.$slider

                .children( _.options.slide + ':not(.slick-cloned)')

                .addClass('slick-slide');



        _.slideCount = _.$slides.length;



        _.$slides.each(function(index, element) {

            $(element)

                .attr('data-slick-index', index)

                .data('originalStyling', $(element).attr('style') || '');

        });



        _.$slider.addClass('slick-slider');



        _.$slideTrack = (_.slideCount === 0) ?

            $('<div class="slick-track"/>').appendTo(_.$slider) :

            _.$slides.wrapAll('<div class="slick-track"/>').parent();



        _.$list = _.$slideTrack.wrap(

            '<div aria-live="polite" class="slick-list"/>').parent();

        _.$slideTrack.css('opacity', 0);



        if (_.options.centerMode === true || _.options.swipeToSlide === true) {

            _.options.slidesToScroll = 1;

        }



        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');



        _.setupInfinite();



        _.buildArrows();



        _.buildDots();



        _.updateDots();





        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);



        if (_.options.draggable === true) {

            _.$list.addClass('draggable');

        }



    };



    Slick.prototype.buildRows = function() {



        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;



        newSlides = document.createDocumentFragment();

        originalSlides = _.$slider.children();



        if(_.options.rows > 1) {



            slidesPerSection = _.options.slidesPerRow * _.options.rows;

            numOfSlides = Math.ceil(

                originalSlides.length / slidesPerSection

            );



            for(a = 0; a < numOfSlides; a++){

                var slide = document.createElement('div');

                for(b = 0; b < _.options.rows; b++) {

                    var row = document.createElement('div');

                    for(c = 0; c < _.options.slidesPerRow; c++) {

                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));

                        if (originalSlides.get(target)) {

                            row.appendChild(originalSlides.get(target));

                        }

                    }

                    slide.appendChild(row);

                }

                newSlides.appendChild(slide);

            }



            _.$slider.empty().append(newSlides);

            _.$slider.children().children().children()

                .css({

                    'width':(100 / _.options.slidesPerRow) + '%',

                    'display': 'inline-block'

                });



        }



    };



    Slick.prototype.checkResponsive = function(initial, forceUpdate) {



        var _ = this,

            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;

        var sliderWidth = _.$slider.width();

        var windowWidth = window.innerWidth || $(window).width();



        if (_.respondTo === 'window') {

            respondToWidth = windowWidth;

        } else if (_.respondTo === 'slider') {

            respondToWidth = sliderWidth;

        } else if (_.respondTo === 'min') {

            respondToWidth = Math.min(windowWidth, sliderWidth);

        }



        if ( _.options.responsive &&

            _.options.responsive.length &&

            _.options.responsive !== null) {



            targetBreakpoint = null;



            for (breakpoint in _.breakpoints) {

                if (_.breakpoints.hasOwnProperty(breakpoint)) {

                    if (_.originalSettings.mobileFirst === false) {

                        if (respondToWidth < _.breakpoints[breakpoint]) {

                            targetBreakpoint = _.breakpoints[breakpoint];

                        }

                    } else {

                        if (respondToWidth > _.breakpoints[breakpoint]) {

                            targetBreakpoint = _.breakpoints[breakpoint];

                        }

                    }

                }

            }



            if (targetBreakpoint !== null) {

                if (_.activeBreakpoint !== null) {

                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {

                        _.activeBreakpoint =

                            targetBreakpoint;

                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {

                            _.unslick(targetBreakpoint);

                        } else {

                            _.options = $.extend({}, _.originalSettings,

                                _.breakpointSettings[

                                    targetBreakpoint]);

                            if (initial === true) {

                                _.currentSlide = _.options.initialSlide;

                            }

                            _.refresh(initial);

                        }

                        triggerBreakpoint = targetBreakpoint;

                    }

                } else {

                    _.activeBreakpoint = targetBreakpoint;

                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {

                        _.unslick(targetBreakpoint);

                    } else {

                        _.options = $.extend({}, _.originalSettings,

                            _.breakpointSettings[

                                targetBreakpoint]);

                        if (initial === true) {

                            _.currentSlide = _.options.initialSlide;

                        }

                        _.refresh(initial);

                    }

                    triggerBreakpoint = targetBreakpoint;

                }

            } else {

                if (_.activeBreakpoint !== null) {

                    _.activeBreakpoint = null;

                    _.options = _.originalSettings;

                    if (initial === true) {

                        _.currentSlide = _.options.initialSlide;

                    }

                    _.refresh(initial);

                    triggerBreakpoint = targetBreakpoint;

                }

            }



            // only trigger breakpoints during an actual break. not on initialize.

            if( !initial && triggerBreakpoint !== false ) {

                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);

            }

        }



    };



    Slick.prototype.changeSlide = function(event, dontAnimate) {



        var _ = this,

            $target = $(event.currentTarget),

            indexOffset, slideOffset, unevenOffset;



        // If target is a link, prevent default action.

        if($target.is('a')) {

            event.preventDefault();

        }



        // If target is not the <li> element (ie: a child), find the <li>.

        if(!$target.is('li')) {

            $target = $target.closest('li');

        }



        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);

        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;



        switch (event.data.message) {



            case 'previous':

                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;

                if (_.slideCount > _.options.slidesToShow) {

                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);

                }

                break;



            case 'next':

                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;

                if (_.slideCount > _.options.slidesToShow) {

                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);

                }

                break;



            case 'index':

                var index = event.data.index === 0 ? 0 :

                    event.data.index || $target.index() * _.options.slidesToScroll;



                _.slideHandler(_.checkNavigable(index), false, dontAnimate);

                $target.children().trigger('focus');

                break;



            default:

                return;

        }



    };



    Slick.prototype.checkNavigable = function(index) {



        var _ = this,

            navigables, prevNavigable;



        navigables = _.getNavigableIndexes();

        prevNavigable = 0;

        if (index > navigables[navigables.length - 1]) {

            index = navigables[navigables.length - 1];

        } else {

            for (var n in navigables) {

                if (index < navigables[n]) {

                    index = prevNavigable;

                    break;

                }

                prevNavigable = navigables[n];

            }

        }



        return index;

    };



    Slick.prototype.cleanUpEvents = function() {



        var _ = this;



        if (_.options.dots && _.$dots !== null) {



            $('li', _.$dots)

                .off('click.slick', _.changeSlide)

                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))

                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));



        }



        _.$slider.off('focus.slick blur.slick');



        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);

            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);

        }



        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);

        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);

        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);

        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);



        _.$list.off('click.slick', _.clickHandler);



        $(document).off(_.visibilityChange, _.visibility);



        _.cleanUpSlideEvents();



        if (_.options.accessibility === true) {

            _.$list.off('keydown.slick', _.keyHandler);

        }



        if (_.options.focusOnSelect === true) {

            $(_.$slideTrack).children().off('click.slick', _.selectHandler);

        }



        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);



        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);



        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);



        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);

        $(document).off('ready.slick.slick-' + _.instanceUid, _.setPosition);



    };



    Slick.prototype.cleanUpSlideEvents = function() {



        var _ = this;



        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));

        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));



    };



    Slick.prototype.cleanUpRows = function() {



        var _ = this, originalSlides;



        if(_.options.rows > 1) {

            originalSlides = _.$slides.children().children();

            originalSlides.removeAttr('style');

            _.$slider.empty().append(originalSlides);

        }



    };



    Slick.prototype.clickHandler = function(event) {



        var _ = this;



        if (_.shouldClick === false) {

            event.stopImmediatePropagation();

            event.stopPropagation();

            event.preventDefault();

        }



    };



    Slick.prototype.destroy = function(refresh) {



        var _ = this;



        _.autoPlayClear();



        _.touchObject = {};



        _.cleanUpEvents();



        $('.slick-cloned', _.$slider).detach();



        if (_.$dots) {

            _.$dots.remove();

        }





        if ( _.$prevArrow && _.$prevArrow.length ) {



            _.$prevArrow

                .removeClass('slick-disabled slick-arrow slick-hidden')

                .removeAttr('aria-hidden aria-disabled tabindex')

                .css('display','');



            if ( _.htmlExpr.test( _.options.prevArrow )) {

                _.$prevArrow.remove();

            }

        }



        if ( _.$nextArrow && _.$nextArrow.length ) {



            _.$nextArrow

                .removeClass('slick-disabled slick-arrow slick-hidden')

                .removeAttr('aria-hidden aria-disabled tabindex')

                .css('display','');



            if ( _.htmlExpr.test( _.options.nextArrow )) {

                _.$nextArrow.remove();

            }



        }





        if (_.$slides) {



            _.$slides

                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')

                .removeAttr('aria-hidden')

                .removeAttr('data-slick-index')

                .each(function(){

                    $(this).attr('style', $(this).data('originalStyling'));

                });



            _.$slideTrack.children(this.options.slide).detach();



            _.$slideTrack.detach();



            _.$list.detach();



            _.$slider.append(_.$slides);

        }



        _.cleanUpRows();



        _.$slider.removeClass('slick-slider');

        _.$slider.removeClass('slick-initialized');

        _.$slider.removeClass('slick-dotted');



        _.unslicked = true;



        if(!refresh) {

            _.$slider.trigger('destroy', [_]);

        }



    };



    Slick.prototype.disableTransition = function(slide) {



        var _ = this,

            transition = {};



        transition[_.transitionType] = '';



        if (_.options.fade === false) {

            _.$slideTrack.css(transition);

        } else {

            _.$slides.eq(slide).css(transition);

        }



    };



    Slick.prototype.fadeSlide = function(slideIndex, callback) {



        var _ = this;



        if (_.cssTransitions === false) {



            _.$slides.eq(slideIndex).css({

                zIndex: _.options.zIndex

            });



            _.$slides.eq(slideIndex).animate({

                opacity: 1

            }, _.options.speed, _.options.easing, callback);



        } else {



            _.applyTransition(slideIndex);



            _.$slides.eq(slideIndex).css({

                opacity: 1,

                zIndex: _.options.zIndex

            });



            if (callback) {

                setTimeout(function() {



                    _.disableTransition(slideIndex);



                    callback.call();

                }, _.options.speed);

            }



        }



    };



    Slick.prototype.fadeSlideOut = function(slideIndex) {



        var _ = this;



        if (_.cssTransitions === false) {



            _.$slides.eq(slideIndex).animate({

                opacity: 0,

                zIndex: _.options.zIndex - 2

            }, _.options.speed, _.options.easing);



        } else {



            _.applyTransition(slideIndex);



            _.$slides.eq(slideIndex).css({

                opacity: 0,

                zIndex: _.options.zIndex - 2

            });



        }



    };



    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {



        var _ = this;



        if (filter !== null) {



            _.$slidesCache = _.$slides;



            _.unload();



            _.$slideTrack.children(this.options.slide).detach();



            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);



            _.reinit();



        }



    };



    Slick.prototype.focusHandler = function() {



        var _ = this;



        _.$slider

            .off('focus.slick blur.slick')

            .on('focus.slick blur.slick',

                '*:not(.slick-arrow)', function(event) {



            event.stopImmediatePropagation();

            var $sf = $(this);



            setTimeout(function() {



                if( _.options.pauseOnFocus ) {

                    _.focussed = $sf.is(':focus');

                    _.autoPlay();

                }



            }, 0);



        });

    };



    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {



        var _ = this;

        return _.currentSlide;



    };



    Slick.prototype.getDotCount = function() {



        var _ = this;



        var breakPoint = 0;

        var counter = 0;

        var pagerQty = 0;



        if (_.options.infinite === true) {

            while (breakPoint < _.slideCount) {

                ++pagerQty;

                breakPoint = counter + _.options.slidesToScroll;

                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;

            }

        } else if (_.options.centerMode === true) {

            pagerQty = _.slideCount;

        } else if(!_.options.asNavFor) {

            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);

        }else {

            while (breakPoint < _.slideCount) {

                ++pagerQty;

                breakPoint = counter + _.options.slidesToScroll;

                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;

            }

        }



        return pagerQty - 1;



    };



    Slick.prototype.getLeft = function(slideIndex) {



        var _ = this,

            targetLeft,

            verticalHeight,

            verticalOffset = 0,

            targetSlide;



        _.slideOffset = 0;

        verticalHeight = _.$slides.first().outerHeight(true);



        if (_.options.infinite === true) {

            if (_.slideCount > _.options.slidesToShow) {

                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;

                verticalOffset = (verticalHeight * _.options.slidesToShow) * -1;

            }

            if (_.slideCount % _.options.slidesToScroll !== 0) {

                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {

                    if (slideIndex > _.slideCount) {

                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;

                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;

                    } else {

                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;

                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;

                    }

                }

            }

        } else {

            if (slideIndex + _.options.slidesToShow > _.slideCount) {

                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;

                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;

            }

        }



        if (_.slideCount <= _.options.slidesToShow) {

            _.slideOffset = 0;

            verticalOffset = 0;

        }



        if (_.options.centerMode === true && _.options.infinite === true) {

            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;

        } else if (_.options.centerMode === true) {

            _.slideOffset = 0;

            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);

        }



        if (_.options.vertical === false) {

            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;

        } else {

            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;

        }



        if (_.options.variableWidth === true) {



            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {

                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);

            } else {

                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);

            }



            if (_.options.rtl === true) {

                if (targetSlide[0]) {

                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;

                } else {

                    targetLeft =  0;

                }

            } else {

                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;

            }



            if (_.options.centerMode === true) {

                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {

                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);

                } else {

                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);

                }



                if (_.options.rtl === true) {

                    if (targetSlide[0]) {

                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;

                    } else {

                        targetLeft =  0;

                    }

                } else {

                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;

                }



                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;

            }

        }



        return targetLeft;



    };



    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {



        var _ = this;



        return _.options[option];



    };



    Slick.prototype.getNavigableIndexes = function() {



        var _ = this,

            breakPoint = 0,

            counter = 0,

            indexes = [],

            max;



        if (_.options.infinite === false) {

            max = _.slideCount;

        } else {

            breakPoint = _.options.slidesToScroll * -1;

            counter = _.options.slidesToScroll * -1;

            max = _.slideCount * 2;

        }



        while (breakPoint < max) {

            indexes.push(breakPoint);

            breakPoint = counter + _.options.slidesToScroll;

            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;

        }



        return indexes;



    };



    Slick.prototype.getSlick = function() {



        return this;



    };



    Slick.prototype.getSlideCount = function() {



        var _ = this,

            slidesTraversed, swipedSlide, centerOffset;



        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;



        if (_.options.swipeToSlide === true) {

            _.$slideTrack.find('.slick-slide').each(function(index, slide) {

                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {

                    swipedSlide = slide;

                    return false;

                }

            });



            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;



            return slidesTraversed;



        } else {

            return _.options.slidesToScroll;

        }



    };



    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {



        var _ = this;



        _.changeSlide({

            data: {

                message: 'index',

                index: parseInt(slide)

            }

        }, dontAnimate);



    };



    Slick.prototype.init = function(creation) {



        var _ = this;



        if (!$(_.$slider).hasClass('slick-initialized')) {



            $(_.$slider).addClass('slick-initialized');



            _.buildRows();

            _.buildOut();

            _.setProps();

            _.startLoad();

            _.loadSlider();

            _.initializeEvents();

            _.updateArrows();

            _.updateDots();

            _.checkResponsive(true);

            _.focusHandler();



        }



        if (creation) {

            _.$slider.trigger('init', [_]);

        }



        if (_.options.accessibility === true) {

            _.initADA();

        }



        if ( _.options.autoplay ) {



            _.paused = false;

            _.autoPlay();



        }



    };



    Slick.prototype.initADA = function() {

        var _ = this;

        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({

            'aria-hidden': 'true',

            'tabindex': '-1'

        }).find('a, input, button, select').attr({

            'tabindex': '-1'

        });



        _.$slideTrack.attr('role', 'listbox');



        _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {

            $(this).attr({

                'role': 'option',

                'aria-describedby': 'slick-slide' + _.instanceUid + i + ''

            });

        });



        if (_.$dots !== null) {

            _.$dots.attr('role', 'tablist').find('li').each(function(i) {

                $(this).attr({

                    'role': 'presentation',

                    'aria-selected': 'false',

                    'aria-controls': 'navigation' + _.instanceUid + i + '',

                    'id': 'slick-slide' + _.instanceUid + i + ''

                });

            })

                .first().attr('aria-selected', 'true').end()

                .find('button').attr('role', 'button').end()

                .closest('div').attr('role', 'toolbar');

        }

        _.activateADA();



    };



    Slick.prototype.initArrowEvents = function() {



        var _ = this;



        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow

               .off('click.slick')

               .on('click.slick', {

                    message: 'previous'

               }, _.changeSlide);

            _.$nextArrow

               .off('click.slick')

               .on('click.slick', {

                    message: 'next'

               }, _.changeSlide);

        }



    };



    Slick.prototype.initDotEvents = function() {



        var _ = this;



        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            $('li', _.$dots).on('click.slick', {

                message: 'index'

            }, _.changeSlide);

        }



        if ( _.options.dots === true && _.options.pauseOnDotsHover === true ) {



            $('li', _.$dots)

                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))

                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));



        }



    };



    Slick.prototype.initSlideEvents = function() {



        var _ = this;



        if ( _.options.pauseOnHover ) {



            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));

            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));



        }



    };



    Slick.prototype.initializeEvents = function() {



        var _ = this;



        _.initArrowEvents();



        _.initDotEvents();

        _.initSlideEvents();



        _.$list.on('touchstart.slick mousedown.slick', {

            action: 'start'

        }, _.swipeHandler);

        _.$list.on('touchmove.slick mousemove.slick', {

            action: 'move'

        }, _.swipeHandler);

        _.$list.on('touchend.slick mouseup.slick', {

            action: 'end'

        }, _.swipeHandler);

        _.$list.on('touchcancel.slick mouseleave.slick', {

            action: 'end'

        }, _.swipeHandler);



        _.$list.on('click.slick', _.clickHandler);



        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));



        if (_.options.accessibility === true) {

            _.$list.on('keydown.slick', _.keyHandler);

        }



        if (_.options.focusOnSelect === true) {

            $(_.$slideTrack).children().on('click.slick', _.selectHandler);

        }



        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));



        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));



        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);



        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);

        $(document).on('ready.slick.slick-' + _.instanceUid, _.setPosition);



    };



    Slick.prototype.initUI = function() {



        var _ = this;



        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {



            _.$prevArrow.show();

            _.$nextArrow.show();



        }



        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {



            _.$dots.show();



        }



    };



    Slick.prototype.keyHandler = function(event) {



        var _ = this;

         //Dont slide if the cursor is inside the form fields and arrow keys are pressed

        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {

            if (event.keyCode === 37 && _.options.accessibility === true) {

                _.changeSlide({

                    data: {

                        message: _.options.rtl === true ? 'next' :  'previous'

                    }

                });

            } else if (event.keyCode === 39 && _.options.accessibility === true) {

                _.changeSlide({

                    data: {

                        message: _.options.rtl === true ? 'previous' : 'next'

                    }

                });

            }

        }



    };



    Slick.prototype.lazyLoad = function() {



        var _ = this,

            loadRange, cloneRange, rangeStart, rangeEnd;



        function loadImages(imagesScope) {



            $('img[data-lazy]', imagesScope).each(function() {



                var image = $(this),

                    imageSource = $(this).attr('data-lazy'),

                    imageToLoad = document.createElement('img');



                imageToLoad.onload = function() {



                    image

                        .animate({ opacity: 0 }, 100, function() {

                            image

                                .attr('src', imageSource)

                                .animate({ opacity: 1 }, 200, function() {

                                    image

                                        .removeAttr('data-lazy')

                                        .removeClass('slick-loading');

                                });

                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);

                        });



                };



                imageToLoad.onerror = function() {



                    image

                        .removeAttr( 'data-lazy' )

                        .removeClass( 'slick-loading' )

                        .addClass( 'slick-lazyload-error' );



                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);



                };



                imageToLoad.src = imageSource;



            });



        }



        if (_.options.centerMode === true) {

            if (_.options.infinite === true) {

                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);

                rangeEnd = rangeStart + _.options.slidesToShow + 2;

            } else {

                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));

                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;

            }

        } else {

            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;

            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);

            if (_.options.fade === true) {

                if (rangeStart > 0) rangeStart--;

                if (rangeEnd <= _.slideCount) rangeEnd++;

            }

        }



        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

        loadImages(loadRange);



        if (_.slideCount <= _.options.slidesToShow) {

            cloneRange = _.$slider.find('.slick-slide');

            loadImages(cloneRange);

        } else

        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {

            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);

            loadImages(cloneRange);

        } else if (_.currentSlide === 0) {

            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);

            loadImages(cloneRange);

        }



    };



    Slick.prototype.loadSlider = function() {



        var _ = this;



        _.setPosition();



        _.$slideTrack.css({

            opacity: 1

        });



        _.$slider.removeClass('slick-loading');



        _.initUI();



        if (_.options.lazyLoad === 'progressive') {

            _.progressiveLazyLoad();

        }



    };



    Slick.prototype.next = Slick.prototype.slickNext = function() {



        var _ = this;



        _.changeSlide({

            data: {

                message: 'next'

            }

        });



    };



    Slick.prototype.orientationChange = function() {



        var _ = this;



        _.checkResponsive();

        _.setPosition();



    };



    Slick.prototype.pause = Slick.prototype.slickPause = function() {



        var _ = this;



        _.autoPlayClear();

        _.paused = true;



    };



    Slick.prototype.play = Slick.prototype.slickPlay = function() {



        var _ = this;



        _.autoPlay();

        _.options.autoplay = true;

        _.paused = false;

        _.focussed = false;

        _.interrupted = false;



    };



    Slick.prototype.postSlide = function(index) {



        var _ = this;



        if( !_.unslicked ) {



            _.$slider.trigger('afterChange', [_, index]);



            _.animating = false;



            _.setPosition();



            _.swipeLeft = null;



            if ( _.options.autoplay ) {

                _.autoPlay();

            }



            if (_.options.accessibility === true) {

                _.initADA();

            }



        }



    };



    Slick.prototype.prev = Slick.prototype.slickPrev = function() {



        var _ = this;



        _.changeSlide({

            data: {

                message: 'previous'

            }

        });



    };



    Slick.prototype.preventDefault = function(event) {



        event.preventDefault();



    };



    Slick.prototype.progressiveLazyLoad = function( tryCount ) {



        tryCount = tryCount || 1;



        var _ = this,

            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),

            image,

            imageSource,

            imageToLoad;



        if ( $imgsToLoad.length ) {



            image = $imgsToLoad.first();

            imageSource = image.attr('data-lazy');

            imageToLoad = document.createElement('img');



            imageToLoad.onload = function() {



                image

                    .attr( 'src', imageSource )

                    .removeAttr('data-lazy')

                    .removeClass('slick-loading');



                if ( _.options.adaptiveHeight === true ) {

                    _.setPosition();

                }



                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);

                _.progressiveLazyLoad();



            };



            imageToLoad.onerror = function() {



                if ( tryCount < 3 ) {



                    /**

                     * try to load the image 3 times,

                     * leave a slight delay so we don't get

                     * servers blocking the request.

                     */

                    setTimeout( function() {

                        _.progressiveLazyLoad( tryCount + 1 );

                    }, 500 );



                } else {



                    image

                        .removeAttr( 'data-lazy' )

                        .removeClass( 'slick-loading' )

                        .addClass( 'slick-lazyload-error' );



                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);



                    _.progressiveLazyLoad();



                }



            };



            imageToLoad.src = imageSource;



        } else {



            _.$slider.trigger('allImagesLoaded', [ _ ]);



        }



    };



    Slick.prototype.refresh = function( initializing ) {



        var _ = this, currentSlide, lastVisibleIndex;



        lastVisibleIndex = _.slideCount - _.options.slidesToShow;



        // in non-infinite sliders, we don't want to go past the

        // last visible index.

        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {

            _.currentSlide = lastVisibleIndex;

        }



        // if less slides than to show, go to start.

        if ( _.slideCount <= _.options.slidesToShow ) {

            _.currentSlide = 0;



        }



        currentSlide = _.currentSlide;



        _.destroy(true);



        $.extend(_, _.initials, { currentSlide: currentSlide });



        _.init();



        if( !initializing ) {



            _.changeSlide({

                data: {

                    message: 'index',

                    index: currentSlide

                }

            }, false);



        }



    };



    Slick.prototype.registerBreakpoints = function() {



        var _ = this, breakpoint, currentBreakpoint, l,

            responsiveSettings = _.options.responsive || null;



        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {



            _.respondTo = _.options.respondTo || 'window';



            for ( breakpoint in responsiveSettings ) {



                l = _.breakpoints.length-1;

                currentBreakpoint = responsiveSettings[breakpoint].breakpoint;



                if (responsiveSettings.hasOwnProperty(breakpoint)) {



                    // loop through the breakpoints and cut out any existing

                    // ones with the same breakpoint number, we don't want dupes.

                    while( l >= 0 ) {

                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {

                            _.breakpoints.splice(l,1);

                        }

                        l--;

                    }



                    _.breakpoints.push(currentBreakpoint);

                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;



                }



            }



            _.breakpoints.sort(function(a, b) {

                return ( _.options.mobileFirst ) ? a-b : b-a;

            });



        }



    };



    Slick.prototype.reinit = function() {



        var _ = this;



        _.$slides =

            _.$slideTrack

                .children(_.options.slide)

                .addClass('slick-slide');



        _.slideCount = _.$slides.length;



        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {

            _.currentSlide = _.currentSlide - _.options.slidesToScroll;

        }



        if (_.slideCount <= _.options.slidesToShow) {

            _.currentSlide = 0;

        }



        _.registerBreakpoints();



        _.setProps();

        _.setupInfinite();

        _.buildArrows();

        _.updateArrows();

        _.initArrowEvents();

        _.buildDots();

        _.updateDots();

        _.initDotEvents();

        _.cleanUpSlideEvents();

        _.initSlideEvents();



        _.checkResponsive(false, true);



        if (_.options.focusOnSelect === true) {

            $(_.$slideTrack).children().on('click.slick', _.selectHandler);

        }



        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);



        _.setPosition();

        _.focusHandler();



        _.paused = !_.options.autoplay;

        _.autoPlay();



        _.$slider.trigger('reInit', [_]);



    };



    Slick.prototype.resize = function() {



        var _ = this;



        if ($(window).width() !== _.windowWidth) {

            clearTimeout(_.windowDelay);

            _.windowDelay = window.setTimeout(function() {

                _.windowWidth = $(window).width();

                _.checkResponsive();

                if( !_.unslicked ) { _.setPosition(); }

            }, 50);

        }

    };



    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {



        var _ = this;



        if (typeof(index) === 'boolean') {

            removeBefore = index;

            index = removeBefore === true ? 0 : _.slideCount - 1;

        } else {

            index = removeBefore === true ? --index : index;

        }



        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {

            return false;

        }



        _.unload();



        if (removeAll === true) {

            _.$slideTrack.children().remove();

        } else {

            _.$slideTrack.children(this.options.slide).eq(index).remove();

        }



        _.$slides = _.$slideTrack.children(this.options.slide);



        _.$slideTrack.children(this.options.slide).detach();



        _.$slideTrack.append(_.$slides);



        _.$slidesCache = _.$slides;



        _.reinit();



    };



    Slick.prototype.setCSS = function(position) {



        var _ = this,

            positionProps = {},

            x, y;



        if (_.options.rtl === true) {

            position = -position;

        }

        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';

        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';



        positionProps[_.positionProp] = position;



        if (_.transformsEnabled === false) {

            _.$slideTrack.css(positionProps);

        } else {

            positionProps = {};

            if (_.cssTransitions === false) {

                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';

                _.$slideTrack.css(positionProps);

            } else {

                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';

                _.$slideTrack.css(positionProps);

            }

        }



    };



    Slick.prototype.setDimensions = function() {



        var _ = this;



        if (_.options.vertical === false) {

            if (_.options.centerMode === true) {

                _.$list.css({

                    padding: ('0px ' + _.options.centerPadding)

                });

            }

        } else {

            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);

            if (_.options.centerMode === true) {

                _.$list.css({

                    padding: (_.options.centerPadding + ' 0px')

                });

            }

        }



        _.listWidth = _.$list.width();

        _.listHeight = _.$list.height();





        if (_.options.vertical === false && _.options.variableWidth === false) {

            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);

            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));



        } else if (_.options.variableWidth === true) {

            _.$slideTrack.width(5000 * _.slideCount);

        } else {

            _.slideWidth = Math.ceil(_.listWidth);

            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));

        }



        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();

        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);



    };



    Slick.prototype.setFade = function() {



        var _ = this,

            targetLeft;



        _.$slides.each(function(index, element) {

            targetLeft = (_.slideWidth * index) * -1;

            if (_.options.rtl === true) {

                $(element).css({

                    position: 'relative',

                    right: targetLeft,

                    top: 0,

                    zIndex: _.options.zIndex - 2,

                    opacity: 0

                });

            } else {

                $(element).css({

                    position: 'relative',

                    left: targetLeft,

                    top: 0,

                    zIndex: _.options.zIndex - 2,

                    opacity: 0

                });

            }

        });



        _.$slides.eq(_.currentSlide).css({

            zIndex: _.options.zIndex - 1,

            opacity: 1

        });



    };



    Slick.prototype.setHeight = function() {



        var _ = this;



        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {

            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);

            _.$list.css('height', targetHeight);

        }



    };



    Slick.prototype.setOption =

    Slick.prototype.slickSetOption = function() {



        /**

         * accepts arguments in format of:

         *

         *  - for changing a single option's value:

         *     .slick("setOption", option, value, refresh )

         *

         *  - for changing a set of responsive options:

         *     .slick("setOption", 'responsive', [{}, ...], refresh )

         *

         *  - for updating multiple values at once (not responsive)

         *     .slick("setOption", { 'option': value, ... }, refresh )

         */



        var _ = this, l, item, option, value, refresh = false, type;



        if( $.type( arguments[0] ) === 'object' ) {



            option =  arguments[0];

            refresh = arguments[1];

            type = 'multiple';



        } else if ( $.type( arguments[0] ) === 'string' ) {



            option =  arguments[0];

            value = arguments[1];

            refresh = arguments[2];



            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {



                type = 'responsive';



            } else if ( typeof arguments[1] !== 'undefined' ) {



                type = 'single';



            }



        }



        if ( type === 'single' ) {



            _.options[option] = value;





        } else if ( type === 'multiple' ) {



            $.each( option , function( opt, val ) {



                _.options[opt] = val;



            });





        } else if ( type === 'responsive' ) {



            for ( item in value ) {



                if( $.type( _.options.responsive ) !== 'array' ) {



                    _.options.responsive = [ value[item] ];



                } else {



                    l = _.options.responsive.length-1;



                    // loop through the responsive object and splice out duplicates.

                    while( l >= 0 ) {



                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {



                            _.options.responsive.splice(l,1);



                        }



                        l--;



                    }



                    _.options.responsive.push( value[item] );



                }



            }



        }



        if ( refresh ) {



            _.unload();

            _.reinit();



        }



    };



    Slick.prototype.setPosition = function() {



        var _ = this;



        _.setDimensions();



        _.setHeight();



        if (_.options.fade === false) {

            _.setCSS(_.getLeft(_.currentSlide));

        } else {

            _.setFade();

        }



        _.$slider.trigger('setPosition', [_]);



    };



    Slick.prototype.setProps = function() {



        var _ = this,

            bodyStyle = document.body.style;



        _.positionProp = _.options.vertical === true ? 'top' : 'left';



        if (_.positionProp === 'top') {

            _.$slider.addClass('slick-vertical');

        } else {

            _.$slider.removeClass('slick-vertical');

        }



        if (bodyStyle.WebkitTransition !== undefined ||

            bodyStyle.MozTransition !== undefined ||

            bodyStyle.msTransition !== undefined) {

            if (_.options.useCSS === true) {

                _.cssTransitions = true;

            }

        }



        if ( _.options.fade ) {

            if ( typeof _.options.zIndex === 'number' ) {

                if( _.options.zIndex < 3 ) {

                    _.options.zIndex = 3;

                }

            } else {

                _.options.zIndex = _.defaults.zIndex;

            }

        }



        if (bodyStyle.OTransform !== undefined) {

            _.animType = 'OTransform';

            _.transformType = '-o-transform';

            _.transitionType = 'OTransition';

            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;

        }

        if (bodyStyle.MozTransform !== undefined) {

            _.animType = 'MozTransform';

            _.transformType = '-moz-transform';

            _.transitionType = 'MozTransition';

            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;

        }

        if (bodyStyle.webkitTransform !== undefined) {

            _.animType = 'webkitTransform';

            _.transformType = '-webkit-transform';

            _.transitionType = 'webkitTransition';

            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;

        }

        if (bodyStyle.msTransform !== undefined) {

            _.animType = 'msTransform';

            _.transformType = '-ms-transform';

            _.transitionType = 'msTransition';

            if (bodyStyle.msTransform === undefined) _.animType = false;

        }

        if (bodyStyle.transform !== undefined && _.animType !== false) {

            _.animType = 'transform';

            _.transformType = 'transform';

            _.transitionType = 'transition';

        }

        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);

    };





    Slick.prototype.setSlideClasses = function(index) {



        var _ = this,

            centerOffset, allSlides, indexOffset, remainder;



        allSlides = _.$slider

            .find('.slick-slide')

            .removeClass('slick-active slick-center slick-current')

            .attr('aria-hidden', 'true');



        _.$slides

            .eq(index)

            .addClass('slick-current');



        if (_.options.centerMode === true) {



            centerOffset = Math.floor(_.options.slidesToShow / 2);



            if (_.options.infinite === true) {



                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {



                    _.$slides

                        .slice(index - centerOffset, index + centerOffset + 1)

                        .addClass('slick-active')

                        .attr('aria-hidden', 'false');



                } else {



                    indexOffset = _.options.slidesToShow + index;

                    allSlides

                        .slice(indexOffset - centerOffset + 1, indexOffset + centerOffset + 2)

                        .addClass('slick-active')

                        .attr('aria-hidden', 'false');



                }



                if (index === 0) {



                    allSlides

                        .eq(allSlides.length - 1 - _.options.slidesToShow)

                        .addClass('slick-center');



                } else if (index === _.slideCount - 1) {



                    allSlides

                        .eq(_.options.slidesToShow)

                        .addClass('slick-center');



                }



            }



            _.$slides

                .eq(index)

                .addClass('slick-center');



        } else {



            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {



                _.$slides

                    .slice(index, index + _.options.slidesToShow)

                    .addClass('slick-active')

                    .attr('aria-hidden', 'false');



            } else if (allSlides.length <= _.options.slidesToShow) {



                allSlides

                    .addClass('slick-active')

                    .attr('aria-hidden', 'false');



            } else {



                remainder = _.slideCount % _.options.slidesToShow;

                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;



                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {



                    allSlides

                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)

                        .addClass('slick-active')

                        .attr('aria-hidden', 'false');



                } else {



                    allSlides

                        .slice(indexOffset, indexOffset + _.options.slidesToShow)

                        .addClass('slick-active')

                        .attr('aria-hidden', 'false');



                }



            }



        }



        if (_.options.lazyLoad === 'ondemand') {

            _.lazyLoad();

        }



    };



    Slick.prototype.setupInfinite = function() {



        var _ = this,

            i, slideIndex, infiniteCount;



        if (_.options.fade === true) {

            _.options.centerMode = false;

        }



        if (_.options.infinite === true && _.options.fade === false) {



            slideIndex = null;



            if (_.slideCount > _.options.slidesToShow) {



                if (_.options.centerMode === true) {

                    infiniteCount = _.options.slidesToShow + 1;

                } else {

                    infiniteCount = _.options.slidesToShow;

                }



                for (i = _.slideCount; i > (_.slideCount -

                        infiniteCount); i -= 1) {

                    slideIndex = i - 1;

                    $(_.$slides[slideIndex]).clone(true).attr('id', '')

                        .attr('data-slick-index', slideIndex - _.slideCount)

                        .prependTo(_.$slideTrack).addClass('slick-cloned');

                }

                for (i = 0; i < infiniteCount; i += 1) {

                    slideIndex = i;

                    $(_.$slides[slideIndex]).clone(true).attr('id', '')

                        .attr('data-slick-index', slideIndex + _.slideCount)

                        .appendTo(_.$slideTrack).addClass('slick-cloned');

                }

                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {

                    $(this).attr('id', '');

                });



            }



        }



    };



    Slick.prototype.interrupt = function( toggle ) {



        var _ = this;



        if( !toggle ) {

            _.autoPlay();

        }

        _.interrupted = toggle;



    };



    Slick.prototype.selectHandler = function(event) {



        var _ = this;



        var targetElement =

            $(event.target).is('.slick-slide') ?

                $(event.target) :

                $(event.target).parents('.slick-slide');



        var index = parseInt(targetElement.attr('data-slick-index'));



        if (!index) index = 0;



        if (_.slideCount <= _.options.slidesToShow) {



            _.setSlideClasses(index);

            _.asNavFor(index);

            return;



        }



        _.slideHandler(index);



    };



    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {



        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,

            _ = this, navTarget;



        sync = sync || false;



        if (_.animating === true && _.options.waitForAnimate === true) {

            return;

        }



        if (_.options.fade === true && _.currentSlide === index) {

            return;

        }



        if (_.slideCount <= _.options.slidesToShow) {

            return;

        }



        if (sync === false) {

            _.asNavFor(index);

        }



        targetSlide = index;

        targetLeft = _.getLeft(targetSlide);

        slideLeft = _.getLeft(_.currentSlide);



        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;



        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {

            if (_.options.fade === false) {

                targetSlide = _.currentSlide;

                if (dontAnimate !== true) {

                    _.animateSlide(slideLeft, function() {

                        _.postSlide(targetSlide);

                    });

                } else {

                    _.postSlide(targetSlide);

                }

            }

            return;

        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {

            if (_.options.fade === false) {

                targetSlide = _.currentSlide;

                if (dontAnimate !== true) {

                    _.animateSlide(slideLeft, function() {

                        _.postSlide(targetSlide);

                    });

                } else {

                    _.postSlide(targetSlide);

                }

            }

            return;

        }



        if ( _.options.autoplay ) {

            clearInterval(_.autoPlayTimer);

        }



        if (targetSlide < 0) {

            if (_.slideCount % _.options.slidesToScroll !== 0) {

                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);

            } else {

                animSlide = _.slideCount + targetSlide;

            }

        } else if (targetSlide >= _.slideCount) {

            if (_.slideCount % _.options.slidesToScroll !== 0) {

                animSlide = 0;

            } else {

                animSlide = targetSlide - _.slideCount;

            }

        } else {

            animSlide = targetSlide;

        }



        _.animating = true;



        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);



        oldSlide = _.currentSlide;

        _.currentSlide = animSlide;



        _.setSlideClasses(_.currentSlide);



        if ( _.options.asNavFor ) {



            navTarget = _.getNavTarget();

            navTarget = navTarget.slick('getSlick');



            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {

                navTarget.setSlideClasses(_.currentSlide);

            }



        }



        _.updateDots();

        _.updateArrows();



        if (_.options.fade === true) {

            if (dontAnimate !== true) {



                _.fadeSlideOut(oldSlide);



                _.fadeSlide(animSlide, function() {

                    _.postSlide(animSlide);

                });



            } else {

                _.postSlide(animSlide);

            }

            _.animateHeight();

            return;

        }



        if (dontAnimate !== true) {

            _.animateSlide(targetLeft, function() {

                _.postSlide(animSlide);

            });

        } else {

            _.postSlide(animSlide);

        }



    };



    Slick.prototype.startLoad = function() {



        var _ = this;



        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {



            _.$prevArrow.hide();

            _.$nextArrow.hide();



        }



        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {



            _.$dots.hide();



        }



        _.$slider.addClass('slick-loading');



    };



    Slick.prototype.swipeDirection = function() {



        var xDist, yDist, r, swipeAngle, _ = this;



        xDist = _.touchObject.startX - _.touchObject.curX;

        yDist = _.touchObject.startY - _.touchObject.curY;

        r = Math.atan2(yDist, xDist);



        swipeAngle = Math.round(r * 180 / Math.PI);

        if (swipeAngle < 0) {

            swipeAngle = 360 - Math.abs(swipeAngle);

        }



        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {

            return (_.options.rtl === false ? 'left' : 'right');

        }

        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {

            return (_.options.rtl === false ? 'left' : 'right');

        }

        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {

            return (_.options.rtl === false ? 'right' : 'left');

        }

        if (_.options.verticalSwiping === true) {

            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {

                return 'down';

            } else {

                return 'up';

            }

        }



        return 'vertical';



    };



    Slick.prototype.swipeEnd = function(event) {



        var _ = this,

            slideCount,

            direction;



        _.dragging = false;

        _.interrupted = false;

        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;



        if ( _.touchObject.curX === undefined ) {

            return false;

        }



        if ( _.touchObject.edgeHit === true ) {

            _.$slider.trigger('edge', [_, _.swipeDirection() ]);

        }



        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {



            direction = _.swipeDirection();



            switch ( direction ) {



                case 'left':

                case 'down':



                    slideCount =

                        _.options.swipeToSlide ?

                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :

                            _.currentSlide + _.getSlideCount();



                    _.currentDirection = 0;



                    break;



                case 'right':

                case 'up':



                    slideCount =

                        _.options.swipeToSlide ?

                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :

                            _.currentSlide - _.getSlideCount();



                    _.currentDirection = 1;



                    break;



                default:





            }



            if( direction != 'vertical' ) {



                _.slideHandler( slideCount );

                _.touchObject = {};

                _.$slider.trigger('swipe', [_, direction ]);



            }



        } else {



            if ( _.touchObject.startX !== _.touchObject.curX ) {



                _.slideHandler( _.currentSlide );

                _.touchObject = {};



            }



        }



    };



    Slick.prototype.swipeHandler = function(event) {



        var _ = this;



        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {

            return;

        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {

            return;

        }



        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?

            event.originalEvent.touches.length : 1;



        _.touchObject.minSwipe = _.listWidth / _.options

            .touchThreshold;



        if (_.options.verticalSwiping === true) {

            _.touchObject.minSwipe = _.listHeight / _.options

                .touchThreshold;

        }



        switch (event.data.action) {



            case 'start':

                _.swipeStart(event);

                break;



            case 'move':

                _.swipeMove(event);

                break;



            case 'end':

                _.swipeEnd(event);

                break;



        }



    };



    Slick.prototype.swipeMove = function(event) {



        var _ = this,

            edgeWasHit = false,

            curLeft, swipeDirection, swipeLength, positionOffset, touches;



        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;



        if (!_.dragging || touches && touches.length !== 1) {

            return false;

        }



        curLeft = _.getLeft(_.currentSlide);



        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;

        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;



        _.touchObject.swipeLength = Math.round(Math.sqrt(

            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));



        if (_.options.verticalSwiping === true) {

            _.touchObject.swipeLength = Math.round(Math.sqrt(

                Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));

        }



        swipeDirection = _.swipeDirection();



        if (swipeDirection === 'vertical') {

            return;

        }



        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {

            event.preventDefault();

        }



        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);

        if (_.options.verticalSwiping === true) {

            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;

        }





        swipeLength = _.touchObject.swipeLength;



        _.touchObject.edgeHit = false;



        if (_.options.infinite === false) {

            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {

                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;

                _.touchObject.edgeHit = true;

            }

        }



        if (_.options.vertical === false) {

            _.swipeLeft = curLeft + swipeLength * positionOffset;

        } else {

            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;

        }

        if (_.options.verticalSwiping === true) {

            _.swipeLeft = curLeft + swipeLength * positionOffset;

        }



        if (_.options.fade === true || _.options.touchMove === false) {

            return false;

        }



        if (_.animating === true) {

            _.swipeLeft = null;

            return false;

        }



        _.setCSS(_.swipeLeft);



    };



    Slick.prototype.swipeStart = function(event) {



        var _ = this,

            touches;



        _.interrupted = true;



        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {

            _.touchObject = {};

            return false;

        }



        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {

            touches = event.originalEvent.touches[0];

        }



        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;

        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;



        _.dragging = true;



    };



    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {



        var _ = this;



        if (_.$slidesCache !== null) {



            _.unload();



            _.$slideTrack.children(this.options.slide).detach();



            _.$slidesCache.appendTo(_.$slideTrack);



            _.reinit();



        }



    };



    Slick.prototype.unload = function() {



        var _ = this;



        $('.slick-cloned', _.$slider).remove();



        if (_.$dots) {

            _.$dots.remove();

        }



        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {

            _.$prevArrow.remove();

        }



        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {

            _.$nextArrow.remove();

        }



        _.$slides

            .removeClass('slick-slide slick-active slick-visible slick-current')

            .attr('aria-hidden', 'true')

            .css('width', '');



    };



    Slick.prototype.unslick = function(fromBreakpoint) {



        var _ = this;

        _.$slider.trigger('unslick', [_, fromBreakpoint]);

        _.destroy();



    };



    Slick.prototype.updateArrows = function() {



        var _ = this,

            centerOffset;



        centerOffset = Math.floor(_.options.slidesToShow / 2);



        if ( _.options.arrows === true &&

            _.slideCount > _.options.slidesToShow &&

            !_.options.infinite ) {



            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');



            if (_.currentSlide === 0) {



                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');

                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');



            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {



                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');

                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');



            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {



                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');

                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');



            }



        }



    };



    Slick.prototype.updateDots = function() {



        var _ = this;



        if (_.$dots !== null) {



            _.$dots

                .find('li')

                .removeClass('slick-active')

                .attr('aria-hidden', 'true');



            _.$dots

                .find('li')

                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))

                .addClass('slick-active')

                .attr('aria-hidden', 'false');



        }



    };



    Slick.prototype.visibility = function() {



        var _ = this;



        if ( _.options.autoplay ) {



            if ( document[_.hidden] ) {



                _.interrupted = true;



            } else {



                _.interrupted = false;



            }



        }



    };



    $.fn.slick = function() {

        var _ = this,

            opt = arguments[0],

            args = Array.prototype.slice.call(arguments, 1),

            l = _.length,

            i,

            ret;

        for (i = 0; i < l; i++) {

            if (typeof opt == 'object' || typeof opt == 'undefined')

                _[i].slick = new Slick(_[i], opt);

            else

                ret = _[i].slick[opt].apply(_[i].slick, args);

            if (typeof ret != 'undefined') return ret;

        }

        return _;

    };



}));



/* eslint no-unused-vars: 0 */



/*

 * jQuery throttle / debounce - v1.1 - 3/7/2010

 * http://benalman.com/projects/jquery-throttle-debounce-plugin/

 *

 * Copyright (c) 2010 "Cowboy" Ben Alman

 * Dual licensed under the MIT and GPL licenses.

 * http://benalman.com/about/license/

 */

(function(b, c) {

  var $ = b.jQuery || b.Cowboy || (b.Cowboy = {}),

    a;

  $.throttle = a = function(e, f, j, i) {

    var h,

      d = 0;

    if (typeof f !== 'boolean') {

      i = j;

      j = f;

      f = c;

    }

    function g() {

      var o = this,

        m = +new Date() - d,

        n = arguments;

      function l() {

        d = +new Date();

        j.apply(o, n);

      }

      function k() {

        h = c;

      }

      if (i && !h) {

        l();

      }

      h && clearTimeout(h);

      if (i === c && m > e) {

        l();

      } else {

        if (f !== true) {

          h = setTimeout(i ? k : l, i === c ? e - m : e);

        }

      }

    }

    if ($.guid) {

      g.guid = j.guid = j.guid || $.guid++;

    }

    return g;

  };

  $.debounce = function(d, e, f) {

    return f === c ? a(d, e, false) : a(d, f, e !== false);

  };

})(this);



var RAhelpers = (function($) {

  function videoInModal() {

    var trigger = $('body').find('[data-toggle="modal"]');



    trigger.click(function() {

      var theModal = $(this).data('target'),

        videoSRC = $(this).attr('href'),

        videoSRCauto = videoSRC + '?autoplay=1';



      // Replace the source for the video

      $(theModal + ' iframe').attr('src', videoSRCauto);



      // Stop video playback on close

      $(theModal).on('hidden.bs.modal', function() {

        $(theModal + ' iframe').attr('src', '');

      });

    });

  }



  function customControlInputState() {

    var $customControls = $('label.custom-control input');

    var $customControlsChecked = $('label.custom-control input:checked');



    $customControlsChecked.each(function() {

      var $control = $(this);

      $control.parent().addClass('is-active');

    });



    $customControls.change(function() {

      var $control = $(this),

        type = $control.attr('type'),

        name = $control.attr('name');



      if (type == 'checkbox') {

        // Simply toggle class for checkboxes

        $control.parent().toggleClass('is-active');

      } else if (type == 'radio') {

        // Disable group for radio

        var $radioGroup = $('input[name=' + name + ']');

        $radioGroup.parent().removeClass('is-active');

        // Set current radio active

        $control.parent().toggleClass('is-active');

      }

    });

  }



  function inputNumberControls() {

    var $group = $("[data-input-group='number']");



    $group.each(function() {

      var $this = $(this),

          $input = $this.find('input[type=number]'),

          $plus = $this.find("[data-input-number='plus']"),

          $min = $this.find("[data-input-number='min']");



      if ($input.val() == '') {

        $input.val('0');

      }



      $plus.click(function() {

        var current = parseInt($input.val()),

          next = current + 1;

        $input.val(next);

      });



      $min.click(function() {

        var current = parseInt($input.val()),

          prev = current - 1;

        $input.val(prev);

      });

    });

  }



  function dateTimePicker() {

    $('[data-flatpickr]').flatpickr();

  }



  function progressBar() {

    if (!$('[data-reader-bar]').length) return;

    $(window).scroll($.throttle(150, handleReaderBarProgress));

    handleReaderBarProgress();

  }



  function handleReaderBarProgress() {

    var progress = 0;

    var $readerbar = $('[data-reader-bar]');

    var windowHeight = $(window).height();

    var documentHeight = $(document).height();

    var readerbarOffset = $readerbar.offset().top;

    var value = $(window).scrollTop();

    var max = documentHeight - windowHeight;

    var width = (value / max) * 100;

    width = width - 100 + '%';

    $readerbar.find('.bar').css('transform', 'translateX(' + width + ')');

  }



  function fixedNav() {

    var $bar = $('.booking-bar');

    if (!$bar.length) return;



    var barStart = $bar.offset().top;

    var offset = barStart + $bar.height();



    $(window).scroll(function() {

      if ($(this).scrollTop() > offset) {

        $('body').addClass('has-sticky-bar');

        $bar.removeClass('fixed');

      } else {

        $('body').removeClass('has-sticky-bar');

        $bar.addClass('fixed');

      }

    });

    $(window).scroll();

  }



  function photoSlider() {

    $('[data-slider=photo]').slick({

      infinite: false,

      prevArrow: '<button type="button" class="slick-prev"><i></i> Previous</button>',

      nextArrow: '<button type="button" class="slick-next">Next <i></i></button>',

    });

  }



  function remoteModal() {

    $('.hasRemoteModal')

      .attr('data-toggle', 'remote-modal')

      .removeClass('hasRemoteModal');



    var $trigger = $('[data-toggle="remote-modal"]');



    $trigger.on('click', function(e) {

      e.preventDefault();



      // Check for remote modal HTML

      var $target = $('#remoteModal');

      if (!$target.length) {

        console.warn("Error 20: Remote modal HTML not found. Make sure it's added to the page.");

        return;

      }

      var $targetLabel = $('#remoteModalLabel');

      var $targetBody = $('#remoteModalBody');



      var $this = $(this),

        title = $this.attr('title'),

        href = $this.attr('href');



      if (href.indexOf('?') !== -1) {

        href = href + '&modal=true';

      } else {

        href = href + '?modal=true';

      }



      // Get content with ajax

      $.ajax(href)

        .done(function(data) {

          $targetLabel.text(title);

          $targetBody.html(data);



          $target.modal('show');

        })

        .fail(function() {

          console.warn('Error 21: Target not found.');

        });

    });

  }



  function autoOpenModal() {

    if (window.location.hash) {

      var hash = window.location.hash;

      var $target = $(hash);



      if (hash.indexOf('modal') !== -1 && $target.length > 0) {

        $target.modal('show');

      }

    }

  }



  return {

    customControlInputState: customControlInputState,

    inputNumberControls: inputNumberControls,

    videoInModal: videoInModal,

    dateTimePicker: dateTimePicker,

    progressBar: progressBar,

    fixedNav: fixedNav,

    photoSlider: photoSlider,

    remoteModal: remoteModal,

    autoOpenModal: autoOpenModal,

  };

})(jQuery);
/* eslint no-unused-vars: 0 */

var RAnav = (function($) {
  var backdrop = null,
      isShown = false,
      $nav,
      $toggle;

  function init() {
    $toggle = $("[data-toggle='nav']");
    $nav = $($toggle.attr('href'));

    $toggle.click(function(e) {
      e.preventDefault();
      toggle();
    });

    toggleStickyHeader();

    toggleDarkSiteTitle();
  }

  function toggle() {
    return isShown ? hide() : show();
  }

  function show() {
    isShown = true;
    $nav.addClass('is-visible');
    $(document.body).addClass('modal-open');
    $toggle.addClass('is-active');
    showBackdrop();
  }

  function hide() {
    isShown = false;
    $nav.removeClass('is-visible');
    $(document.body).removeClass('modal-open');
    $toggle.removeClass('is-active');
    removeBackdrop();
  }

  function showBackdrop() {
    backdrop = document.createElement('div');
    backdrop.className = 'nav-backdrop fade';
    $(backdrop).appendTo(document.body);
    $(backdrop).addClass('show');

    $(backdrop).on('click', function() {
      console.log('backdrop click!');
      hide();
    });
  }

  function removeBackdrop() {
    if (backdrop) {
      $(backdrop).remove();
      backdrop = null;
    }
  }

  function toggleStickyHeader() {
    var lastScrollTop = 0;
    $(window).on('scroll', function() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > lastScrollTop && scrollTop > 50) {
        $('.header').addClass('hidden');
      } else if (scrollTop < lastScrollTop) {
        $('.header').removeClass('hidden');
      }
      lastScrollTop = scrollTop;
    });
  }

  // Toggle the dark site title in the header once we scroll past the hero
  function toggleDarkSiteTitle() {
    $(window).on('scroll', function() {
      if ($(window).scrollTop() > $('.hero').outerHeight()) {
        $('.header').addClass('fixed');
      } else {
        $('.header').removeClass('fixed');
      }
    });
  }

  return { init: init };
})(jQuery);

/* global RAhelpers */
/* global RAnav */

(function($) {
  var Roadtrip = {
    common: {
      init: function() {
        RAhelpers.videoInModal();
        RAhelpers.customControlInputState();
        RAhelpers.inputNumberControls();
        RAhelpers.dateTimePicker();
        RAhelpers.progressBar();
        RAhelpers.fixedNav();
        RAhelpers.photoSlider();
        RAhelpers.remoteModal();
        RAhelpers.autoOpenModal();
        RAnav.init();
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },
    home: {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      },
    },
    trip_detail: {
      init: function() {
        var $prev = $("[data-slider-prev='day-to-day']");
        var $next = $("[data-slider-next='day-to-day']");
        $('[data-slider=day-to-day]').slick({
          nextArrow: $next,
          prevArrow: $prev,
          fade: true,
          dots: true,
          slide: '.slider__item',
          appendDots: '.slider__controls__wrap',
          adaptiveHeight: true,
        });
      },
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Roadtrip;
      funcname = funcname === undefined ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery);